"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorefrontProductCollectionSortKeys = exports.StorefrontPredictiveSearchType = exports.StorefrontPredictiveSearchLimitScope = exports.StorefrontPaymentTokenType = exports.StorefrontPageSortKeys = exports.StorefrontOrderSortKeys = exports.StorefrontOrderFulfillmentStatus = exports.StorefrontOrderFinancialStatus = exports.StorefrontOrderCancelReason = exports.StorefrontMetafieldsSetUserErrorCode = exports.StorefrontMetafieldDeleteErrorCode = exports.StorefrontMenuItemType = exports.StorefrontMediaPresentationFormat = exports.StorefrontMediaHost = exports.StorefrontMediaContentType = exports.StorefrontLocationSortKeys = exports.StorefrontLanguageCode = exports.StorefrontImageContentType = exports.StorefrontFilterType = exports.StorefrontDiscountApplicationTargetType = exports.StorefrontDiscountApplicationTargetSelection = exports.StorefrontDiscountApplicationAllocationMethod = exports.StorefrontDigitalWallet = exports.StorefrontDeliveryMethodType = exports.StorefrontCustomerErrorCode = exports.StorefrontCurrencyCode = exports.StorefrontCropRegion = exports.StorefrontCountryCode = exports.StorefrontCompletionErrorCode = exports.StorefrontCollectionSortKeys = exports.StorefrontCheckoutErrorCode = exports.StorefrontCartErrorCode = exports.StorefrontCartCardSource = exports.StorefrontCardBrand = exports.StorefrontBlogSortKeys = exports.StorefrontArticleSortKeys = exports.StickerTokenTransactionReason = exports.StickerSizeClass = exports.StickerOrderStatus = exports.SortOrder = exports.Role = exports.PromotionStatus = exports.PromotionEntryStatus = exports.ProjectOutputType = exports.OpeningSuggestionStatus = exports.MapmakerLicensePolicy = exports.MapmakerFileViewerPolicy = exports.MapmakerFileAccessPolicy = exports.MapmakerBusinessId = exports.FileAccessRole = void 0;
exports.OrderLightFragmentDoc = exports.OrderItemLightFragmentDoc = exports.MapLineItemFragmentDoc = exports.OrderDetailsFragmentDoc = exports.RefundFragmentDoc = exports.OrderItemDetailsFragmentDoc = exports.FulfillmentFragmentDoc = exports.TrackingInfoFragmentDoc = exports.PageFragmentDoc = exports.NavigationFragmentDoc = exports.NavigationLinkFragmentDoc = exports.NavigationLinkTargetFragmentDoc = exports.StickerOrderForLineItemFragmentDoc = exports.StorefrontCheckoutHeavyFragmentDoc = exports.StorefrontCheckoutLineItemHeavyFragmentDoc = exports.StorefrontDiscountAllocationFragmentDoc = exports.StorefrontDiscountApplicationFragmentDoc = exports.BlogPostFragmentDoc = exports.BlogPostCardFragmentDoc = exports.StorefrontCheckoutLightFragmentDoc = exports.StickerVariantForPricingFragmentDoc = exports.StickerOrderFragmentDoc = exports.StickerOrderItemFragmentDoc = exports.MapmakerFileHeavyFragmentDoc = exports.MapmakerDesignHeavyFragmentDoc = exports.OpeningSuggestionFragmentDoc = exports.MapmakerFileAccessFragmentDoc = exports.MapmakerFileLiteFragmentDoc = exports.MapmakerDesignLiteFragmentDoc = exports.MapmakerFileBaseFragmentDoc = exports.MapmakerAccountFragmentDoc = exports.MapmakerAuthenticatedAccountFragmentDoc = exports.StorefrontWeightUnit = exports.StorefrontUnitSystem = exports.StorefrontUnitPriceMeasurementMeasuredUnit = exports.StorefrontUnitPriceMeasurementMeasuredType = exports.StorefrontTransactionStatus = exports.StorefrontTransactionKind = exports.StorefrontSubmissionErrorCode = exports.StorefrontSellingPlanCheckoutChargeType = exports.StorefrontSearchableField = exports.StorefrontSearchUnavailableProductsType = exports.StorefrontSearchType = exports.StorefrontSearchSortKeys = exports.StorefrontSearchPrefixQueryType = exports.StorefrontProductVariantSortKeys = exports.StorefrontProductSortKeys = exports.StorefrontProductRecommendationIntent = exports.StorefrontProductMediaSortKeys = exports.StorefrontProductImageSortKeys = void 0;
exports.StorefrontAddCheckoutLineItemsDocument = exports.useStorefrontCreateCheckoutMutation = exports.StorefrontCreateCheckoutDocument = exports.useStorefrontGetCheckoutLightLazyQuery = exports.useStorefrontGetCheckoutLightQuery = exports.StorefrontGetCheckoutLightDocument = exports.useGetStickerProductsLazyQuery = exports.useGetStickerProductsQuery = exports.GetStickerProductsDocument = exports.usePresignedImageUploadMutation = exports.PresignedImageUploadDocument = exports.useCreateStickerOrderMutation = exports.CreateStickerOrderDocument = exports.useGetStickerOrdersLazyQuery = exports.useGetStickerOrdersQuery = exports.GetStickerOrdersDocument = exports.useGetStickerOrderLazyQuery = exports.useGetStickerOrderQuery = exports.GetStickerOrderDocument = exports.useDeleteFileMutation = exports.DeleteFileDocument = exports.useUpdateFileHeavyMutation = exports.UpdateFileHeavyDocument = exports.useUpdateFileMutation = exports.UpdateFileDocument = exports.useCreateFileMutation = exports.CreateFileDocument = exports.useGetFileWithDesignLazyQuery = exports.useGetFileWithDesignQuery = exports.GetFileWithDesignDocument = exports.useGetDesignLazyQuery = exports.useGetDesignQuery = exports.GetDesignDocument = exports.useGetAccountLazyQuery = exports.useGetAccountQuery = exports.GetAccountDocument = exports.PresignedPostFragmentDoc = exports.RenderableOpeningSuggestionFragmentDoc = exports.RenderableFileFragmentDoc = exports.RenderableDesignFragmentDoc = exports.StickerOrderForSandboxFragmentDoc = exports.StickerTokenProductFragmentDoc = exports.StickerTokenVariantFragmentDoc = exports.StorefrontProductPageProductFragmentDoc = exports.StorefrontProductPageVariantFragmentDoc = exports.StorefrontProductImageFragmentDoc = exports.WalgreensStoreFragmentDoc = exports.StickerOfferFragmentDoc = exports.StickerOfferItemFragmentDoc = exports.StickerOrderForStickerLineItemFragmentDoc = void 0;
exports.useRefundPolicyQuery = exports.RefundPolicyDocument = exports.usePrivacyPolicyLazyQuery = exports.usePrivacyPolicyQuery = exports.PrivacyPolicyDocument = exports.useGetOrdersForUserLazyQuery = exports.useGetOrdersForUserQuery = exports.GetOrdersForUserDocument = exports.useGetStickerOrdersForOrderDetailsLazyQuery = exports.useGetStickerOrdersForOrderDetailsQuery = exports.GetStickerOrdersForOrderDetailsDocument = exports.useGetOrderLazyQuery = exports.useGetOrderQuery = exports.GetOrderDocument = exports.useGetReferenceLazyQuery = exports.useGetReferenceQuery = exports.GetReferenceDocument = exports.usePageBySlugLazyQuery = exports.usePageBySlugQuery = exports.PageBySlugDocument = exports.useCreateTicketMutation = exports.CreateTicketDocument = exports.useNavigationByIdLazyQuery = exports.useNavigationByIdQuery = exports.NavigationByIdDocument = exports.useGetDesignsLazyQuery = exports.useGetDesignsQuery = exports.GetDesignsDocument = exports.useGetDesignsAndFilesLazyQuery = exports.useGetDesignsAndFilesQuery = exports.GetDesignsAndFilesDocument = exports.useStorefrontUpdateCheckoutLineItemsMutation = exports.StorefrontUpdateCheckoutLineItemsDocument = exports.useStorefrontUpdateCheckoutAttributesMutation = exports.StorefrontUpdateCheckoutAttributesDocument = exports.useGetStickerOrdersForCartPageLazyQuery = exports.useGetStickerOrdersForCartPageQuery = exports.GetStickerOrdersForCartPageDocument = exports.useStorefrontRemoveCheckoutLineItemsMutation = exports.StorefrontRemoveCheckoutLineItemsDocument = exports.useStorefrontGetCheckoutHeavyLazyQuery = exports.useStorefrontGetCheckoutHeavyQuery = exports.StorefrontGetCheckoutHeavyDocument = exports.useAllPostsLazyQuery = exports.useAllPostsQuery = exports.AllPostsDocument = exports.useBlogPostLazyQuery = exports.useBlogPostQuery = exports.BlogPostDocument = exports.useStorefrontAddCheckoutLineItemsMutation = void 0;
exports.useGetRenderableDesignLazyQuery = exports.useGetRenderableDesignQuery = exports.GetRenderableDesignDocument = exports.useRenderMutation = exports.RenderDocument = exports.useGetStickerOrdersForSandboxLazyQuery = exports.useGetStickerOrdersForSandboxQuery = exports.GetStickerOrdersForSandboxDocument = exports.useSubmitOpeningSuggestionMutation = exports.SubmitOpeningSuggestionDocument = exports.useUpdateOpeningSuggestionMutation = exports.UpdateOpeningSuggestionDocument = exports.useCreateOpeningSuggestionMutation = exports.CreateOpeningSuggestionDocument = exports.useGetOpeningSuggestionLazyQuery = exports.useGetOpeningSuggestionQuery = exports.GetOpeningSuggestionDocument = exports.useHideOpeningSuggestionMutation = exports.HideOpeningSuggestionDocument = exports.useDeleteOpeningSuggestionMutation = exports.DeleteOpeningSuggestionDocument = exports.useDeleteMapmakerFileAccessMutation = exports.DeleteMapmakerFileAccessDocument = exports.useAddMapmakerFileAccessMutation = exports.AddMapmakerFileAccessDocument = exports.useStickerTokensModalLazyQuery = exports.useStickerTokensModalQuery = exports.StickerTokensModalDocument = exports.useStorefrontGetProductByHandleLazyQuery = exports.useStorefrontGetProductByHandleQuery = exports.StorefrontGetProductByHandleDocument = exports.useCreateRectangularPrintsMutation = exports.CreateRectangularPrintsDocument = exports.useWalgreensStoresLazyQuery = exports.useWalgreensStoresQuery = exports.WalgreensStoresDocument = exports.useWalgreensSubmitOrderMutation = exports.WalgreensSubmitOrderDocument = exports.useWalgreensProductsLazyQuery = exports.useWalgreensProductsQuery = exports.WalgreensProductsDocument = exports.useGetStickerOfferLazyQuery = exports.useGetStickerOfferQuery = exports.GetStickerOfferDocument = exports.useCreateRectangularPrintsForDownloadMutation = exports.CreateRectangularPrintsForDownloadDocument = exports.useTermsOfServiceLazyQuery = exports.useTermsOfServiceQuery = exports.TermsOfServiceDocument = exports.useRefundPolicyLazyQuery = void 0;
exports.useStorefrontReplaceCheckoutLineItemsMutation = exports.StorefrontReplaceCheckoutLineItemsDocument = exports.useCreatePresignedPostMutation = exports.CreatePresignedPostDocument = exports.useAccountStickerTokenDataLazyQuery = exports.useAccountStickerTokenDataQuery = exports.AccountStickerTokenDataDocument = exports.useRedeemStickerTokenVoucherMutation = exports.RedeemStickerTokenVoucherDocument = exports.useRenderableFileHeavyLazyQuery = exports.useRenderableFileHeavyQuery = exports.RenderableFileHeavyDocument = exports.useRenderableFileListLazyQuery = exports.useRenderableFileListQuery = exports.RenderableFileListDocument = exports.useGetRenderableOpeningSuggestionLazyQuery = exports.useGetRenderableOpeningSuggestionQuery = exports.GetRenderableOpeningSuggestionDocument = exports.useGetRenderableFileLazyQuery = exports.useGetRenderableFileQuery = exports.GetRenderableFileDocument = void 0;
const client_1 = require("@apollo/client");
const Apollo = __importStar(require("@apollo/client"));
const defaultOptions = {};
var FileAccessRole;
(function (FileAccessRole) {
    FileAccessRole["Collaborator"] = "COLLABORATOR";
    FileAccessRole["Viewer"] = "VIEWER";
})(FileAccessRole = exports.FileAccessRole || (exports.FileAccessRole = {}));
var MapmakerBusinessId;
(function (MapmakerBusinessId) {
    MapmakerBusinessId["Pm"] = "pm";
    MapmakerBusinessId["Tbl"] = "tbl";
})(MapmakerBusinessId = exports.MapmakerBusinessId || (exports.MapmakerBusinessId = {}));
var MapmakerFileAccessPolicy;
(function (MapmakerFileAccessPolicy) {
    MapmakerFileAccessPolicy["Private"] = "PRIVATE";
    MapmakerFileAccessPolicy["Public"] = "PUBLIC";
    MapmakerFileAccessPolicy["PublicCollaborators"] = "PUBLIC_COLLABORATORS";
})(MapmakerFileAccessPolicy = exports.MapmakerFileAccessPolicy || (exports.MapmakerFileAccessPolicy = {}));
var MapmakerFileViewerPolicy;
(function (MapmakerFileViewerPolicy) {
    MapmakerFileViewerPolicy["Collaborator"] = "COLLABORATOR";
    MapmakerFileViewerPolicy["None"] = "NONE";
    MapmakerFileViewerPolicy["Owner"] = "OWNER";
    MapmakerFileViewerPolicy["Viewer"] = "VIEWER";
})(MapmakerFileViewerPolicy = exports.MapmakerFileViewerPolicy || (exports.MapmakerFileViewerPolicy = {}));
var MapmakerLicensePolicy;
(function (MapmakerLicensePolicy) {
    MapmakerLicensePolicy["FullDigitalRights"] = "FULL_DIGITAL_RIGHTS";
    MapmakerLicensePolicy["None"] = "NONE";
})(MapmakerLicensePolicy = exports.MapmakerLicensePolicy || (exports.MapmakerLicensePolicy = {}));
var OpeningSuggestionStatus;
(function (OpeningSuggestionStatus) {
    OpeningSuggestionStatus["Draft"] = "DRAFT";
    OpeningSuggestionStatus["Hidden"] = "HIDDEN";
    OpeningSuggestionStatus["Submitted"] = "SUBMITTED";
})(OpeningSuggestionStatus = exports.OpeningSuggestionStatus || (exports.OpeningSuggestionStatus = {}));
var ProjectOutputType;
(function (ProjectOutputType) {
    ProjectOutputType["MatboardWallMap"] = "MATBOARD_WALL_MAP";
    ProjectOutputType["MatboardWallMapSingle"] = "MATBOARD_WALL_MAP_SINGLE";
    ProjectOutputType["VehicleMap"] = "VEHICLE_MAP";
    ProjectOutputType["VinylWallMap"] = "VINYL_WALL_MAP";
})(ProjectOutputType = exports.ProjectOutputType || (exports.ProjectOutputType = {}));
var PromotionEntryStatus;
(function (PromotionEntryStatus) {
    PromotionEntryStatus["Approved"] = "APPROVED";
    PromotionEntryStatus["AwaitingApproval"] = "AWAITING_APPROVAL";
    PromotionEntryStatus["Denied"] = "DENIED";
})(PromotionEntryStatus = exports.PromotionEntryStatus || (exports.PromotionEntryStatus = {}));
var PromotionStatus;
(function (PromotionStatus) {
    PromotionStatus["Closed"] = "CLOSED";
    PromotionStatus["Open"] = "OPEN";
})(PromotionStatus = exports.PromotionStatus || (exports.PromotionStatus = {}));
var Role;
(function (Role) {
    Role["Admin"] = "ADMIN";
    Role["Employee"] = "EMPLOYEE";
    Role["Guest"] = "GUEST";
    Role["User"] = "USER";
})(Role = exports.Role || (exports.Role = {}));
var SortOrder;
(function (SortOrder) {
    /** Sorts on the value in ascending order. */
    SortOrder["Asc"] = "ASC";
    /** Sorts on the value in descending order. */
    SortOrder["Desc"] = "DESC";
})(SortOrder = exports.SortOrder || (exports.SortOrder = {}));
var StickerOrderStatus;
(function (StickerOrderStatus) {
    StickerOrderStatus["AwaitingPayment"] = "AWAITING_PAYMENT";
    StickerOrderStatus["AwaitingShipment"] = "AWAITING_SHIPMENT";
    StickerOrderStatus["Cancelled"] = "CANCELLED";
    StickerOrderStatus["Shipped"] = "SHIPPED";
})(StickerOrderStatus = exports.StickerOrderStatus || (exports.StickerOrderStatus = {}));
var StickerSizeClass;
(function (StickerSizeClass) {
    StickerSizeClass["Large"] = "LARGE";
    StickerSizeClass["Medium"] = "MEDIUM";
    StickerSizeClass["Small"] = "SMALL";
})(StickerSizeClass = exports.StickerSizeClass || (exports.StickerSizeClass = {}));
var StickerTokenTransactionReason;
(function (StickerTokenTransactionReason) {
    StickerTokenTransactionReason["AdminAdjustment"] = "ADMIN_ADJUSTMENT";
    StickerTokenTransactionReason["Promotion"] = "PROMOTION";
    StickerTokenTransactionReason["StickerPurchase"] = "STICKER_PURCHASE";
    StickerTokenTransactionReason["VoucherRedemption"] = "VOUCHER_REDEMPTION";
})(StickerTokenTransactionReason = exports.StickerTokenTransactionReason || (exports.StickerTokenTransactionReason = {}));
/** The set of valid sort keys for the Article query. */
var StorefrontArticleSortKeys;
(function (StorefrontArticleSortKeys) {
    /** Sort by the `author` value. */
    StorefrontArticleSortKeys["Author"] = "AUTHOR";
    /** Sort by the `blog_title` value. */
    StorefrontArticleSortKeys["BlogTitle"] = "BLOG_TITLE";
    /** Sort by the `id` value. */
    StorefrontArticleSortKeys["Id"] = "ID";
    /** Sort by the `published_at` value. */
    StorefrontArticleSortKeys["PublishedAt"] = "PUBLISHED_AT";
    /**
     * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
     * Don't use this sort key when no search query is specified.
     *
     */
    StorefrontArticleSortKeys["Relevance"] = "RELEVANCE";
    /** Sort by the `title` value. */
    StorefrontArticleSortKeys["Title"] = "TITLE";
    /** Sort by the `updated_at` value. */
    StorefrontArticleSortKeys["UpdatedAt"] = "UPDATED_AT";
})(StorefrontArticleSortKeys = exports.StorefrontArticleSortKeys || (exports.StorefrontArticleSortKeys = {}));
/** The set of valid sort keys for the Blog query. */
var StorefrontBlogSortKeys;
(function (StorefrontBlogSortKeys) {
    /** Sort by the `handle` value. */
    StorefrontBlogSortKeys["Handle"] = "HANDLE";
    /** Sort by the `id` value. */
    StorefrontBlogSortKeys["Id"] = "ID";
    /**
     * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
     * Don't use this sort key when no search query is specified.
     *
     */
    StorefrontBlogSortKeys["Relevance"] = "RELEVANCE";
    /** Sort by the `title` value. */
    StorefrontBlogSortKeys["Title"] = "TITLE";
})(StorefrontBlogSortKeys = exports.StorefrontBlogSortKeys || (exports.StorefrontBlogSortKeys = {}));
/** Card brand, such as Visa or Mastercard, which can be used for payments. */
var StorefrontCardBrand;
(function (StorefrontCardBrand) {
    /** American Express. */
    StorefrontCardBrand["AmericanExpress"] = "AMERICAN_EXPRESS";
    /** Diners Club. */
    StorefrontCardBrand["DinersClub"] = "DINERS_CLUB";
    /** Discover. */
    StorefrontCardBrand["Discover"] = "DISCOVER";
    /** JCB. */
    StorefrontCardBrand["Jcb"] = "JCB";
    /** Mastercard. */
    StorefrontCardBrand["Mastercard"] = "MASTERCARD";
    /** Visa. */
    StorefrontCardBrand["Visa"] = "VISA";
})(StorefrontCardBrand = exports.StorefrontCardBrand || (exports.StorefrontCardBrand = {}));
/**
 * Represents how credit card details are provided for a direct payment.
 *
 */
var StorefrontCartCardSource;
(function (StorefrontCartCardSource) {
    /**
     * The credit card was provided by a third party and vaulted on their system.
     * Using this value requires a separate permission from Shopify.
     *
     */
    StorefrontCartCardSource["SavedCreditCard"] = "SAVED_CREDIT_CARD";
})(StorefrontCartCardSource = exports.StorefrontCartCardSource || (exports.StorefrontCartCardSource = {}));
/** Possible error codes that can be returned by `CartUserError`. */
var StorefrontCartErrorCode;
(function (StorefrontCartErrorCode) {
    /** The input value is invalid. */
    StorefrontCartErrorCode["Invalid"] = "INVALID";
    /** Delivery group was not found in cart. */
    StorefrontCartErrorCode["InvalidDeliveryGroup"] = "INVALID_DELIVERY_GROUP";
    /** Delivery option was not valid. */
    StorefrontCartErrorCode["InvalidDeliveryOption"] = "INVALID_DELIVERY_OPTION";
    /** Merchandise line was not found in cart. */
    StorefrontCartErrorCode["InvalidMerchandiseLine"] = "INVALID_MERCHANDISE_LINE";
    /** The metafields were not valid. */
    StorefrontCartErrorCode["InvalidMetafields"] = "INVALID_METAFIELDS";
    /** The payment wasn't valid. */
    StorefrontCartErrorCode["InvalidPayment"] = "INVALID_PAYMENT";
    /** Cannot update payment on an empty cart */
    StorefrontCartErrorCode["InvalidPaymentEmptyCart"] = "INVALID_PAYMENT_EMPTY_CART";
    /** The input value should be less than the maximum value allowed. */
    StorefrontCartErrorCode["LessThan"] = "LESS_THAN";
    /** Missing discount code. */
    StorefrontCartErrorCode["MissingDiscountCode"] = "MISSING_DISCOUNT_CODE";
    /** Missing note. */
    StorefrontCartErrorCode["MissingNote"] = "MISSING_NOTE";
    /** The payment method is not supported. */
    StorefrontCartErrorCode["PaymentMethodNotSupported"] = "PAYMENT_METHOD_NOT_SUPPORTED";
})(StorefrontCartErrorCode = exports.StorefrontCartErrorCode || (exports.StorefrontCartErrorCode = {}));
/** Possible error codes that can be returned by `CheckoutUserError`. */
var StorefrontCheckoutErrorCode;
(function (StorefrontCheckoutErrorCode) {
    /** Checkout is already completed. */
    StorefrontCheckoutErrorCode["AlreadyCompleted"] = "ALREADY_COMPLETED";
    /** Input email contains an invalid domain name. */
    StorefrontCheckoutErrorCode["BadDomain"] = "BAD_DOMAIN";
    /** The input value is blank. */
    StorefrontCheckoutErrorCode["Blank"] = "BLANK";
    /** Cart does not meet discount requirements notice. */
    StorefrontCheckoutErrorCode["CartDoesNotMeetDiscountRequirementsNotice"] = "CART_DOES_NOT_MEET_DISCOUNT_REQUIREMENTS_NOTICE";
    /** Customer already used once per customer discount notice. */
    StorefrontCheckoutErrorCode["CustomerAlreadyUsedOncePerCustomerDiscountNotice"] = "CUSTOMER_ALREADY_USED_ONCE_PER_CUSTOMER_DISCOUNT_NOTICE";
    /** Discount already applied. */
    StorefrontCheckoutErrorCode["DiscountAlreadyApplied"] = "DISCOUNT_ALREADY_APPLIED";
    /** Discount code isn't working right now. Please contact us for help. */
    StorefrontCheckoutErrorCode["DiscountCodeApplicationFailed"] = "DISCOUNT_CODE_APPLICATION_FAILED";
    /** Discount disabled. */
    StorefrontCheckoutErrorCode["DiscountDisabled"] = "DISCOUNT_DISABLED";
    /** Discount expired. */
    StorefrontCheckoutErrorCode["DiscountExpired"] = "DISCOUNT_EXPIRED";
    /** Discount limit reached. */
    StorefrontCheckoutErrorCode["DiscountLimitReached"] = "DISCOUNT_LIMIT_REACHED";
    /** Discount not found. */
    StorefrontCheckoutErrorCode["DiscountNotFound"] = "DISCOUNT_NOT_FOUND";
    /** Checkout is already completed. */
    StorefrontCheckoutErrorCode["Empty"] = "EMPTY";
    /** Queue token has expired. */
    StorefrontCheckoutErrorCode["ExpiredQueueToken"] = "EXPIRED_QUEUE_TOKEN";
    /** Gift card has already been applied. */
    StorefrontCheckoutErrorCode["GiftCardAlreadyApplied"] = "GIFT_CARD_ALREADY_APPLIED";
    /** Gift card code is invalid. */
    StorefrontCheckoutErrorCode["GiftCardCodeInvalid"] = "GIFT_CARD_CODE_INVALID";
    /** Gift card currency does not match checkout currency. */
    StorefrontCheckoutErrorCode["GiftCardCurrencyMismatch"] = "GIFT_CARD_CURRENCY_MISMATCH";
    /** Gift card has no funds left. */
    StorefrontCheckoutErrorCode["GiftCardDepleted"] = "GIFT_CARD_DEPLETED";
    /** Gift card is disabled. */
    StorefrontCheckoutErrorCode["GiftCardDisabled"] = "GIFT_CARD_DISABLED";
    /** Gift card is expired. */
    StorefrontCheckoutErrorCode["GiftCardExpired"] = "GIFT_CARD_EXPIRED";
    /** Gift card was not found. */
    StorefrontCheckoutErrorCode["GiftCardNotFound"] = "GIFT_CARD_NOT_FOUND";
    /** Gift card cannot be applied to a checkout that contains a gift card. */
    StorefrontCheckoutErrorCode["GiftCardUnusable"] = "GIFT_CARD_UNUSABLE";
    /** The input value should be greater than or equal to the minimum value allowed. */
    StorefrontCheckoutErrorCode["GreaterThanOrEqualTo"] = "GREATER_THAN_OR_EQUAL_TO";
    /** Higher value discount applied. */
    StorefrontCheckoutErrorCode["HigherValueDiscountApplied"] = "HIGHER_VALUE_DISCOUNT_APPLIED";
    /** The input value is invalid. */
    StorefrontCheckoutErrorCode["Invalid"] = "INVALID";
    /** Cannot specify country and presentment currency code. */
    StorefrontCheckoutErrorCode["InvalidCountryAndCurrency"] = "INVALID_COUNTRY_AND_CURRENCY";
    /** Input Zip is invalid for country provided. */
    StorefrontCheckoutErrorCode["InvalidForCountry"] = "INVALID_FOR_COUNTRY";
    /** Input Zip is invalid for country and province provided. */
    StorefrontCheckoutErrorCode["InvalidForCountryAndProvince"] = "INVALID_FOR_COUNTRY_AND_PROVINCE";
    /** Invalid province in country. */
    StorefrontCheckoutErrorCode["InvalidProvinceInCountry"] = "INVALID_PROVINCE_IN_COUNTRY";
    /** Queue token is invalid. */
    StorefrontCheckoutErrorCode["InvalidQueueToken"] = "INVALID_QUEUE_TOKEN";
    /** Invalid region in country. */
    StorefrontCheckoutErrorCode["InvalidRegionInCountry"] = "INVALID_REGION_IN_COUNTRY";
    /** Invalid state in country. */
    StorefrontCheckoutErrorCode["InvalidStateInCountry"] = "INVALID_STATE_IN_COUNTRY";
    /** The input value should be less than the maximum value allowed. */
    StorefrontCheckoutErrorCode["LessThan"] = "LESS_THAN";
    /** The input value should be less than or equal to the maximum value allowed. */
    StorefrontCheckoutErrorCode["LessThanOrEqualTo"] = "LESS_THAN_OR_EQUAL_TO";
    /** Line item was not found in checkout. */
    StorefrontCheckoutErrorCode["LineItemNotFound"] = "LINE_ITEM_NOT_FOUND";
    /** Checkout is locked. */
    StorefrontCheckoutErrorCode["Locked"] = "LOCKED";
    /** Maximum number of discount codes limit reached. */
    StorefrontCheckoutErrorCode["MaximumDiscountCodeLimitReached"] = "MAXIMUM_DISCOUNT_CODE_LIMIT_REACHED";
    /** Missing payment input. */
    StorefrontCheckoutErrorCode["MissingPaymentInput"] = "MISSING_PAYMENT_INPUT";
    /** Not enough in stock. */
    StorefrontCheckoutErrorCode["NotEnoughInStock"] = "NOT_ENOUGH_IN_STOCK";
    /** Input value is not supported. */
    StorefrontCheckoutErrorCode["NotSupported"] = "NOT_SUPPORTED";
    /** The input value needs to be blank. */
    StorefrontCheckoutErrorCode["Present"] = "PRESENT";
    /** Product is not published for this customer. */
    StorefrontCheckoutErrorCode["ProductNotAvailable"] = "PRODUCT_NOT_AVAILABLE";
    /** Shipping rate expired. */
    StorefrontCheckoutErrorCode["ShippingRateExpired"] = "SHIPPING_RATE_EXPIRED";
    /** Throttled during checkout. */
    StorefrontCheckoutErrorCode["ThrottledDuringCheckout"] = "THROTTLED_DURING_CHECKOUT";
    /** The input value is too long. */
    StorefrontCheckoutErrorCode["TooLong"] = "TOO_LONG";
    /** The amount of the payment does not match the value to be paid. */
    StorefrontCheckoutErrorCode["TotalPriceMismatch"] = "TOTAL_PRICE_MISMATCH";
    /** Unable to apply discount. */
    StorefrontCheckoutErrorCode["UnableToApply"] = "UNABLE_TO_APPLY";
})(StorefrontCheckoutErrorCode = exports.StorefrontCheckoutErrorCode || (exports.StorefrontCheckoutErrorCode = {}));
/** The set of valid sort keys for the Collection query. */
var StorefrontCollectionSortKeys;
(function (StorefrontCollectionSortKeys) {
    /** Sort by the `id` value. */
    StorefrontCollectionSortKeys["Id"] = "ID";
    /**
     * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
     * Don't use this sort key when no search query is specified.
     *
     */
    StorefrontCollectionSortKeys["Relevance"] = "RELEVANCE";
    /** Sort by the `title` value. */
    StorefrontCollectionSortKeys["Title"] = "TITLE";
    /** Sort by the `updated_at` value. */
    StorefrontCollectionSortKeys["UpdatedAt"] = "UPDATED_AT";
})(StorefrontCollectionSortKeys = exports.StorefrontCollectionSortKeys || (exports.StorefrontCollectionSortKeys = {}));
/** The code of the error that occurred during a cart completion attempt. */
var StorefrontCompletionErrorCode;
(function (StorefrontCompletionErrorCode) {
    StorefrontCompletionErrorCode["Error"] = "ERROR";
    StorefrontCompletionErrorCode["InventoryReservationError"] = "INVENTORY_RESERVATION_ERROR";
    StorefrontCompletionErrorCode["PaymentAmountTooSmall"] = "PAYMENT_AMOUNT_TOO_SMALL";
    StorefrontCompletionErrorCode["PaymentCallIssuer"] = "PAYMENT_CALL_ISSUER";
    StorefrontCompletionErrorCode["PaymentCardDeclined"] = "PAYMENT_CARD_DECLINED";
    StorefrontCompletionErrorCode["PaymentError"] = "PAYMENT_ERROR";
    StorefrontCompletionErrorCode["PaymentGatewayNotEnabledError"] = "PAYMENT_GATEWAY_NOT_ENABLED_ERROR";
    StorefrontCompletionErrorCode["PaymentInsufficientFunds"] = "PAYMENT_INSUFFICIENT_FUNDS";
    StorefrontCompletionErrorCode["PaymentInvalidBillingAddress"] = "PAYMENT_INVALID_BILLING_ADDRESS";
    StorefrontCompletionErrorCode["PaymentInvalidCreditCard"] = "PAYMENT_INVALID_CREDIT_CARD";
    StorefrontCompletionErrorCode["PaymentInvalidCurrency"] = "PAYMENT_INVALID_CURRENCY";
    StorefrontCompletionErrorCode["PaymentInvalidPaymentMethod"] = "PAYMENT_INVALID_PAYMENT_METHOD";
    StorefrontCompletionErrorCode["PaymentTransientError"] = "PAYMENT_TRANSIENT_ERROR";
})(StorefrontCompletionErrorCode = exports.StorefrontCompletionErrorCode || (exports.StorefrontCompletionErrorCode = {}));
/**
 * The code designating a country/region, which generally follows ISO 3166-1 alpha-2 guidelines.
 * If a territory doesn't have a country code value in the `CountryCode` enum, then it might be considered a subdivision
 * of another country. For example, the territories associated with Spain are represented by the country code `ES`,
 * and the territories associated with the United States of America are represented by the country code `US`.
 *
 */
var StorefrontCountryCode;
(function (StorefrontCountryCode) {
    /** Ascension Island. */
    StorefrontCountryCode["Ac"] = "AC";
    /** Andorra. */
    StorefrontCountryCode["Ad"] = "AD";
    /** United Arab Emirates. */
    StorefrontCountryCode["Ae"] = "AE";
    /** Afghanistan. */
    StorefrontCountryCode["Af"] = "AF";
    /** Antigua & Barbuda. */
    StorefrontCountryCode["Ag"] = "AG";
    /** Anguilla. */
    StorefrontCountryCode["Ai"] = "AI";
    /** Albania. */
    StorefrontCountryCode["Al"] = "AL";
    /** Armenia. */
    StorefrontCountryCode["Am"] = "AM";
    /** Netherlands Antilles. */
    StorefrontCountryCode["An"] = "AN";
    /** Angola. */
    StorefrontCountryCode["Ao"] = "AO";
    /** Argentina. */
    StorefrontCountryCode["Ar"] = "AR";
    /** Austria. */
    StorefrontCountryCode["At"] = "AT";
    /** Australia. */
    StorefrontCountryCode["Au"] = "AU";
    /** Aruba. */
    StorefrontCountryCode["Aw"] = "AW";
    /** Åland Islands. */
    StorefrontCountryCode["Ax"] = "AX";
    /** Azerbaijan. */
    StorefrontCountryCode["Az"] = "AZ";
    /** Bosnia & Herzegovina. */
    StorefrontCountryCode["Ba"] = "BA";
    /** Barbados. */
    StorefrontCountryCode["Bb"] = "BB";
    /** Bangladesh. */
    StorefrontCountryCode["Bd"] = "BD";
    /** Belgium. */
    StorefrontCountryCode["Be"] = "BE";
    /** Burkina Faso. */
    StorefrontCountryCode["Bf"] = "BF";
    /** Bulgaria. */
    StorefrontCountryCode["Bg"] = "BG";
    /** Bahrain. */
    StorefrontCountryCode["Bh"] = "BH";
    /** Burundi. */
    StorefrontCountryCode["Bi"] = "BI";
    /** Benin. */
    StorefrontCountryCode["Bj"] = "BJ";
    /** St. Barthélemy. */
    StorefrontCountryCode["Bl"] = "BL";
    /** Bermuda. */
    StorefrontCountryCode["Bm"] = "BM";
    /** Brunei. */
    StorefrontCountryCode["Bn"] = "BN";
    /** Bolivia. */
    StorefrontCountryCode["Bo"] = "BO";
    /** Caribbean Netherlands. */
    StorefrontCountryCode["Bq"] = "BQ";
    /** Brazil. */
    StorefrontCountryCode["Br"] = "BR";
    /** Bahamas. */
    StorefrontCountryCode["Bs"] = "BS";
    /** Bhutan. */
    StorefrontCountryCode["Bt"] = "BT";
    /** Bouvet Island. */
    StorefrontCountryCode["Bv"] = "BV";
    /** Botswana. */
    StorefrontCountryCode["Bw"] = "BW";
    /** Belarus. */
    StorefrontCountryCode["By"] = "BY";
    /** Belize. */
    StorefrontCountryCode["Bz"] = "BZ";
    /** Canada. */
    StorefrontCountryCode["Ca"] = "CA";
    /** Cocos (Keeling) Islands. */
    StorefrontCountryCode["Cc"] = "CC";
    /** Congo - Kinshasa. */
    StorefrontCountryCode["Cd"] = "CD";
    /** Central African Republic. */
    StorefrontCountryCode["Cf"] = "CF";
    /** Congo - Brazzaville. */
    StorefrontCountryCode["Cg"] = "CG";
    /** Switzerland. */
    StorefrontCountryCode["Ch"] = "CH";
    /** Côte d’Ivoire. */
    StorefrontCountryCode["Ci"] = "CI";
    /** Cook Islands. */
    StorefrontCountryCode["Ck"] = "CK";
    /** Chile. */
    StorefrontCountryCode["Cl"] = "CL";
    /** Cameroon. */
    StorefrontCountryCode["Cm"] = "CM";
    /** China. */
    StorefrontCountryCode["Cn"] = "CN";
    /** Colombia. */
    StorefrontCountryCode["Co"] = "CO";
    /** Costa Rica. */
    StorefrontCountryCode["Cr"] = "CR";
    /** Cuba. */
    StorefrontCountryCode["Cu"] = "CU";
    /** Cape Verde. */
    StorefrontCountryCode["Cv"] = "CV";
    /** Curaçao. */
    StorefrontCountryCode["Cw"] = "CW";
    /** Christmas Island. */
    StorefrontCountryCode["Cx"] = "CX";
    /** Cyprus. */
    StorefrontCountryCode["Cy"] = "CY";
    /** Czechia. */
    StorefrontCountryCode["Cz"] = "CZ";
    /** Germany. */
    StorefrontCountryCode["De"] = "DE";
    /** Djibouti. */
    StorefrontCountryCode["Dj"] = "DJ";
    /** Denmark. */
    StorefrontCountryCode["Dk"] = "DK";
    /** Dominica. */
    StorefrontCountryCode["Dm"] = "DM";
    /** Dominican Republic. */
    StorefrontCountryCode["Do"] = "DO";
    /** Algeria. */
    StorefrontCountryCode["Dz"] = "DZ";
    /** Ecuador. */
    StorefrontCountryCode["Ec"] = "EC";
    /** Estonia. */
    StorefrontCountryCode["Ee"] = "EE";
    /** Egypt. */
    StorefrontCountryCode["Eg"] = "EG";
    /** Western Sahara. */
    StorefrontCountryCode["Eh"] = "EH";
    /** Eritrea. */
    StorefrontCountryCode["Er"] = "ER";
    /** Spain. */
    StorefrontCountryCode["Es"] = "ES";
    /** Ethiopia. */
    StorefrontCountryCode["Et"] = "ET";
    /** Finland. */
    StorefrontCountryCode["Fi"] = "FI";
    /** Fiji. */
    StorefrontCountryCode["Fj"] = "FJ";
    /** Falkland Islands. */
    StorefrontCountryCode["Fk"] = "FK";
    /** Faroe Islands. */
    StorefrontCountryCode["Fo"] = "FO";
    /** France. */
    StorefrontCountryCode["Fr"] = "FR";
    /** Gabon. */
    StorefrontCountryCode["Ga"] = "GA";
    /** United Kingdom. */
    StorefrontCountryCode["Gb"] = "GB";
    /** Grenada. */
    StorefrontCountryCode["Gd"] = "GD";
    /** Georgia. */
    StorefrontCountryCode["Ge"] = "GE";
    /** French Guiana. */
    StorefrontCountryCode["Gf"] = "GF";
    /** Guernsey. */
    StorefrontCountryCode["Gg"] = "GG";
    /** Ghana. */
    StorefrontCountryCode["Gh"] = "GH";
    /** Gibraltar. */
    StorefrontCountryCode["Gi"] = "GI";
    /** Greenland. */
    StorefrontCountryCode["Gl"] = "GL";
    /** Gambia. */
    StorefrontCountryCode["Gm"] = "GM";
    /** Guinea. */
    StorefrontCountryCode["Gn"] = "GN";
    /** Guadeloupe. */
    StorefrontCountryCode["Gp"] = "GP";
    /** Equatorial Guinea. */
    StorefrontCountryCode["Gq"] = "GQ";
    /** Greece. */
    StorefrontCountryCode["Gr"] = "GR";
    /** South Georgia & South Sandwich Islands. */
    StorefrontCountryCode["Gs"] = "GS";
    /** Guatemala. */
    StorefrontCountryCode["Gt"] = "GT";
    /** Guinea-Bissau. */
    StorefrontCountryCode["Gw"] = "GW";
    /** Guyana. */
    StorefrontCountryCode["Gy"] = "GY";
    /** Hong Kong SAR. */
    StorefrontCountryCode["Hk"] = "HK";
    /** Heard & McDonald Islands. */
    StorefrontCountryCode["Hm"] = "HM";
    /** Honduras. */
    StorefrontCountryCode["Hn"] = "HN";
    /** Croatia. */
    StorefrontCountryCode["Hr"] = "HR";
    /** Haiti. */
    StorefrontCountryCode["Ht"] = "HT";
    /** Hungary. */
    StorefrontCountryCode["Hu"] = "HU";
    /** Indonesia. */
    StorefrontCountryCode["Id"] = "ID";
    /** Ireland. */
    StorefrontCountryCode["Ie"] = "IE";
    /** Israel. */
    StorefrontCountryCode["Il"] = "IL";
    /** Isle of Man. */
    StorefrontCountryCode["Im"] = "IM";
    /** India. */
    StorefrontCountryCode["In"] = "IN";
    /** British Indian Ocean Territory. */
    StorefrontCountryCode["Io"] = "IO";
    /** Iraq. */
    StorefrontCountryCode["Iq"] = "IQ";
    /** Iran. */
    StorefrontCountryCode["Ir"] = "IR";
    /** Iceland. */
    StorefrontCountryCode["Is"] = "IS";
    /** Italy. */
    StorefrontCountryCode["It"] = "IT";
    /** Jersey. */
    StorefrontCountryCode["Je"] = "JE";
    /** Jamaica. */
    StorefrontCountryCode["Jm"] = "JM";
    /** Jordan. */
    StorefrontCountryCode["Jo"] = "JO";
    /** Japan. */
    StorefrontCountryCode["Jp"] = "JP";
    /** Kenya. */
    StorefrontCountryCode["Ke"] = "KE";
    /** Kyrgyzstan. */
    StorefrontCountryCode["Kg"] = "KG";
    /** Cambodia. */
    StorefrontCountryCode["Kh"] = "KH";
    /** Kiribati. */
    StorefrontCountryCode["Ki"] = "KI";
    /** Comoros. */
    StorefrontCountryCode["Km"] = "KM";
    /** St. Kitts & Nevis. */
    StorefrontCountryCode["Kn"] = "KN";
    /** North Korea. */
    StorefrontCountryCode["Kp"] = "KP";
    /** South Korea. */
    StorefrontCountryCode["Kr"] = "KR";
    /** Kuwait. */
    StorefrontCountryCode["Kw"] = "KW";
    /** Cayman Islands. */
    StorefrontCountryCode["Ky"] = "KY";
    /** Kazakhstan. */
    StorefrontCountryCode["Kz"] = "KZ";
    /** Laos. */
    StorefrontCountryCode["La"] = "LA";
    /** Lebanon. */
    StorefrontCountryCode["Lb"] = "LB";
    /** St. Lucia. */
    StorefrontCountryCode["Lc"] = "LC";
    /** Liechtenstein. */
    StorefrontCountryCode["Li"] = "LI";
    /** Sri Lanka. */
    StorefrontCountryCode["Lk"] = "LK";
    /** Liberia. */
    StorefrontCountryCode["Lr"] = "LR";
    /** Lesotho. */
    StorefrontCountryCode["Ls"] = "LS";
    /** Lithuania. */
    StorefrontCountryCode["Lt"] = "LT";
    /** Luxembourg. */
    StorefrontCountryCode["Lu"] = "LU";
    /** Latvia. */
    StorefrontCountryCode["Lv"] = "LV";
    /** Libya. */
    StorefrontCountryCode["Ly"] = "LY";
    /** Morocco. */
    StorefrontCountryCode["Ma"] = "MA";
    /** Monaco. */
    StorefrontCountryCode["Mc"] = "MC";
    /** Moldova. */
    StorefrontCountryCode["Md"] = "MD";
    /** Montenegro. */
    StorefrontCountryCode["Me"] = "ME";
    /** St. Martin. */
    StorefrontCountryCode["Mf"] = "MF";
    /** Madagascar. */
    StorefrontCountryCode["Mg"] = "MG";
    /** North Macedonia. */
    StorefrontCountryCode["Mk"] = "MK";
    /** Mali. */
    StorefrontCountryCode["Ml"] = "ML";
    /** Myanmar (Burma). */
    StorefrontCountryCode["Mm"] = "MM";
    /** Mongolia. */
    StorefrontCountryCode["Mn"] = "MN";
    /** Macao SAR. */
    StorefrontCountryCode["Mo"] = "MO";
    /** Martinique. */
    StorefrontCountryCode["Mq"] = "MQ";
    /** Mauritania. */
    StorefrontCountryCode["Mr"] = "MR";
    /** Montserrat. */
    StorefrontCountryCode["Ms"] = "MS";
    /** Malta. */
    StorefrontCountryCode["Mt"] = "MT";
    /** Mauritius. */
    StorefrontCountryCode["Mu"] = "MU";
    /** Maldives. */
    StorefrontCountryCode["Mv"] = "MV";
    /** Malawi. */
    StorefrontCountryCode["Mw"] = "MW";
    /** Mexico. */
    StorefrontCountryCode["Mx"] = "MX";
    /** Malaysia. */
    StorefrontCountryCode["My"] = "MY";
    /** Mozambique. */
    StorefrontCountryCode["Mz"] = "MZ";
    /** Namibia. */
    StorefrontCountryCode["Na"] = "NA";
    /** New Caledonia. */
    StorefrontCountryCode["Nc"] = "NC";
    /** Niger. */
    StorefrontCountryCode["Ne"] = "NE";
    /** Norfolk Island. */
    StorefrontCountryCode["Nf"] = "NF";
    /** Nigeria. */
    StorefrontCountryCode["Ng"] = "NG";
    /** Nicaragua. */
    StorefrontCountryCode["Ni"] = "NI";
    /** Netherlands. */
    StorefrontCountryCode["Nl"] = "NL";
    /** Norway. */
    StorefrontCountryCode["No"] = "NO";
    /** Nepal. */
    StorefrontCountryCode["Np"] = "NP";
    /** Nauru. */
    StorefrontCountryCode["Nr"] = "NR";
    /** Niue. */
    StorefrontCountryCode["Nu"] = "NU";
    /** New Zealand. */
    StorefrontCountryCode["Nz"] = "NZ";
    /** Oman. */
    StorefrontCountryCode["Om"] = "OM";
    /** Panama. */
    StorefrontCountryCode["Pa"] = "PA";
    /** Peru. */
    StorefrontCountryCode["Pe"] = "PE";
    /** French Polynesia. */
    StorefrontCountryCode["Pf"] = "PF";
    /** Papua New Guinea. */
    StorefrontCountryCode["Pg"] = "PG";
    /** Philippines. */
    StorefrontCountryCode["Ph"] = "PH";
    /** Pakistan. */
    StorefrontCountryCode["Pk"] = "PK";
    /** Poland. */
    StorefrontCountryCode["Pl"] = "PL";
    /** St. Pierre & Miquelon. */
    StorefrontCountryCode["Pm"] = "PM";
    /** Pitcairn Islands. */
    StorefrontCountryCode["Pn"] = "PN";
    /** Palestinian Territories. */
    StorefrontCountryCode["Ps"] = "PS";
    /** Portugal. */
    StorefrontCountryCode["Pt"] = "PT";
    /** Paraguay. */
    StorefrontCountryCode["Py"] = "PY";
    /** Qatar. */
    StorefrontCountryCode["Qa"] = "QA";
    /** Réunion. */
    StorefrontCountryCode["Re"] = "RE";
    /** Romania. */
    StorefrontCountryCode["Ro"] = "RO";
    /** Serbia. */
    StorefrontCountryCode["Rs"] = "RS";
    /** Russia. */
    StorefrontCountryCode["Ru"] = "RU";
    /** Rwanda. */
    StorefrontCountryCode["Rw"] = "RW";
    /** Saudi Arabia. */
    StorefrontCountryCode["Sa"] = "SA";
    /** Solomon Islands. */
    StorefrontCountryCode["Sb"] = "SB";
    /** Seychelles. */
    StorefrontCountryCode["Sc"] = "SC";
    /** Sudan. */
    StorefrontCountryCode["Sd"] = "SD";
    /** Sweden. */
    StorefrontCountryCode["Se"] = "SE";
    /** Singapore. */
    StorefrontCountryCode["Sg"] = "SG";
    /** St. Helena. */
    StorefrontCountryCode["Sh"] = "SH";
    /** Slovenia. */
    StorefrontCountryCode["Si"] = "SI";
    /** Svalbard & Jan Mayen. */
    StorefrontCountryCode["Sj"] = "SJ";
    /** Slovakia. */
    StorefrontCountryCode["Sk"] = "SK";
    /** Sierra Leone. */
    StorefrontCountryCode["Sl"] = "SL";
    /** San Marino. */
    StorefrontCountryCode["Sm"] = "SM";
    /** Senegal. */
    StorefrontCountryCode["Sn"] = "SN";
    /** Somalia. */
    StorefrontCountryCode["So"] = "SO";
    /** Suriname. */
    StorefrontCountryCode["Sr"] = "SR";
    /** South Sudan. */
    StorefrontCountryCode["Ss"] = "SS";
    /** São Tomé & Príncipe. */
    StorefrontCountryCode["St"] = "ST";
    /** El Salvador. */
    StorefrontCountryCode["Sv"] = "SV";
    /** Sint Maarten. */
    StorefrontCountryCode["Sx"] = "SX";
    /** Syria. */
    StorefrontCountryCode["Sy"] = "SY";
    /** Eswatini. */
    StorefrontCountryCode["Sz"] = "SZ";
    /** Tristan da Cunha. */
    StorefrontCountryCode["Ta"] = "TA";
    /** Turks & Caicos Islands. */
    StorefrontCountryCode["Tc"] = "TC";
    /** Chad. */
    StorefrontCountryCode["Td"] = "TD";
    /** French Southern Territories. */
    StorefrontCountryCode["Tf"] = "TF";
    /** Togo. */
    StorefrontCountryCode["Tg"] = "TG";
    /** Thailand. */
    StorefrontCountryCode["Th"] = "TH";
    /** Tajikistan. */
    StorefrontCountryCode["Tj"] = "TJ";
    /** Tokelau. */
    StorefrontCountryCode["Tk"] = "TK";
    /** Timor-Leste. */
    StorefrontCountryCode["Tl"] = "TL";
    /** Turkmenistan. */
    StorefrontCountryCode["Tm"] = "TM";
    /** Tunisia. */
    StorefrontCountryCode["Tn"] = "TN";
    /** Tonga. */
    StorefrontCountryCode["To"] = "TO";
    /** Turkey. */
    StorefrontCountryCode["Tr"] = "TR";
    /** Trinidad & Tobago. */
    StorefrontCountryCode["Tt"] = "TT";
    /** Tuvalu. */
    StorefrontCountryCode["Tv"] = "TV";
    /** Taiwan. */
    StorefrontCountryCode["Tw"] = "TW";
    /** Tanzania. */
    StorefrontCountryCode["Tz"] = "TZ";
    /** Ukraine. */
    StorefrontCountryCode["Ua"] = "UA";
    /** Uganda. */
    StorefrontCountryCode["Ug"] = "UG";
    /** U.S. Outlying Islands. */
    StorefrontCountryCode["Um"] = "UM";
    /** United States. */
    StorefrontCountryCode["Us"] = "US";
    /** Uruguay. */
    StorefrontCountryCode["Uy"] = "UY";
    /** Uzbekistan. */
    StorefrontCountryCode["Uz"] = "UZ";
    /** Vatican City. */
    StorefrontCountryCode["Va"] = "VA";
    /** St. Vincent & Grenadines. */
    StorefrontCountryCode["Vc"] = "VC";
    /** Venezuela. */
    StorefrontCountryCode["Ve"] = "VE";
    /** British Virgin Islands. */
    StorefrontCountryCode["Vg"] = "VG";
    /** Vietnam. */
    StorefrontCountryCode["Vn"] = "VN";
    /** Vanuatu. */
    StorefrontCountryCode["Vu"] = "VU";
    /** Wallis & Futuna. */
    StorefrontCountryCode["Wf"] = "WF";
    /** Samoa. */
    StorefrontCountryCode["Ws"] = "WS";
    /** Kosovo. */
    StorefrontCountryCode["Xk"] = "XK";
    /** Yemen. */
    StorefrontCountryCode["Ye"] = "YE";
    /** Mayotte. */
    StorefrontCountryCode["Yt"] = "YT";
    /** South Africa. */
    StorefrontCountryCode["Za"] = "ZA";
    /** Zambia. */
    StorefrontCountryCode["Zm"] = "ZM";
    /** Zimbabwe. */
    StorefrontCountryCode["Zw"] = "ZW";
    /** Unknown Region. */
    StorefrontCountryCode["Zz"] = "ZZ";
})(StorefrontCountryCode = exports.StorefrontCountryCode || (exports.StorefrontCountryCode = {}));
/** The part of the image that should remain after cropping. */
var StorefrontCropRegion;
(function (StorefrontCropRegion) {
    /** Keep the bottom of the image. */
    StorefrontCropRegion["Bottom"] = "BOTTOM";
    /** Keep the center of the image. */
    StorefrontCropRegion["Center"] = "CENTER";
    /** Keep the left of the image. */
    StorefrontCropRegion["Left"] = "LEFT";
    /** Keep the right of the image. */
    StorefrontCropRegion["Right"] = "RIGHT";
    /** Keep the top of the image. */
    StorefrontCropRegion["Top"] = "TOP";
})(StorefrontCropRegion = exports.StorefrontCropRegion || (exports.StorefrontCropRegion = {}));
/**
 * The three-letter currency codes that represent the world currencies used in stores. These include standard ISO 4217 codes, legacy codes,
 * and non-standard codes.
 *
 */
var StorefrontCurrencyCode;
(function (StorefrontCurrencyCode) {
    /** United Arab Emirates Dirham (AED). */
    StorefrontCurrencyCode["Aed"] = "AED";
    /** Afghan Afghani (AFN). */
    StorefrontCurrencyCode["Afn"] = "AFN";
    /** Albanian Lek (ALL). */
    StorefrontCurrencyCode["All"] = "ALL";
    /** Armenian Dram (AMD). */
    StorefrontCurrencyCode["Amd"] = "AMD";
    /** Netherlands Antillean Guilder. */
    StorefrontCurrencyCode["Ang"] = "ANG";
    /** Angolan Kwanza (AOA). */
    StorefrontCurrencyCode["Aoa"] = "AOA";
    /** Argentine Pesos (ARS). */
    StorefrontCurrencyCode["Ars"] = "ARS";
    /** Australian Dollars (AUD). */
    StorefrontCurrencyCode["Aud"] = "AUD";
    /** Aruban Florin (AWG). */
    StorefrontCurrencyCode["Awg"] = "AWG";
    /** Azerbaijani Manat (AZN). */
    StorefrontCurrencyCode["Azn"] = "AZN";
    /** Bosnia and Herzegovina Convertible Mark (BAM). */
    StorefrontCurrencyCode["Bam"] = "BAM";
    /** Barbadian Dollar (BBD). */
    StorefrontCurrencyCode["Bbd"] = "BBD";
    /** Bangladesh Taka (BDT). */
    StorefrontCurrencyCode["Bdt"] = "BDT";
    /** Bulgarian Lev (BGN). */
    StorefrontCurrencyCode["Bgn"] = "BGN";
    /** Bahraini Dinar (BHD). */
    StorefrontCurrencyCode["Bhd"] = "BHD";
    /** Burundian Franc (BIF). */
    StorefrontCurrencyCode["Bif"] = "BIF";
    /** Bermudian Dollar (BMD). */
    StorefrontCurrencyCode["Bmd"] = "BMD";
    /** Brunei Dollar (BND). */
    StorefrontCurrencyCode["Bnd"] = "BND";
    /** Bolivian Boliviano (BOB). */
    StorefrontCurrencyCode["Bob"] = "BOB";
    /** Brazilian Real (BRL). */
    StorefrontCurrencyCode["Brl"] = "BRL";
    /** Bahamian Dollar (BSD). */
    StorefrontCurrencyCode["Bsd"] = "BSD";
    /** Bhutanese Ngultrum (BTN). */
    StorefrontCurrencyCode["Btn"] = "BTN";
    /** Botswana Pula (BWP). */
    StorefrontCurrencyCode["Bwp"] = "BWP";
    /** Belarusian Ruble (BYN). */
    StorefrontCurrencyCode["Byn"] = "BYN";
    /**
     * Belarusian Ruble (BYR).
     * @deprecated `BYR` is deprecated. Use `BYN` available from version `2021-01` onwards instead.
     */
    StorefrontCurrencyCode["Byr"] = "BYR";
    /** Belize Dollar (BZD). */
    StorefrontCurrencyCode["Bzd"] = "BZD";
    /** Canadian Dollars (CAD). */
    StorefrontCurrencyCode["Cad"] = "CAD";
    /** Congolese franc (CDF). */
    StorefrontCurrencyCode["Cdf"] = "CDF";
    /** Swiss Francs (CHF). */
    StorefrontCurrencyCode["Chf"] = "CHF";
    /** Chilean Peso (CLP). */
    StorefrontCurrencyCode["Clp"] = "CLP";
    /** Chinese Yuan Renminbi (CNY). */
    StorefrontCurrencyCode["Cny"] = "CNY";
    /** Colombian Peso (COP). */
    StorefrontCurrencyCode["Cop"] = "COP";
    /** Costa Rican Colones (CRC). */
    StorefrontCurrencyCode["Crc"] = "CRC";
    /** Cape Verdean escudo (CVE). */
    StorefrontCurrencyCode["Cve"] = "CVE";
    /** Czech Koruny (CZK). */
    StorefrontCurrencyCode["Czk"] = "CZK";
    /** Djiboutian Franc (DJF). */
    StorefrontCurrencyCode["Djf"] = "DJF";
    /** Danish Kroner (DKK). */
    StorefrontCurrencyCode["Dkk"] = "DKK";
    /** Dominican Peso (DOP). */
    StorefrontCurrencyCode["Dop"] = "DOP";
    /** Algerian Dinar (DZD). */
    StorefrontCurrencyCode["Dzd"] = "DZD";
    /** Egyptian Pound (EGP). */
    StorefrontCurrencyCode["Egp"] = "EGP";
    /** Eritrean Nakfa (ERN). */
    StorefrontCurrencyCode["Ern"] = "ERN";
    /** Ethiopian Birr (ETB). */
    StorefrontCurrencyCode["Etb"] = "ETB";
    /** Euro (EUR). */
    StorefrontCurrencyCode["Eur"] = "EUR";
    /** Fijian Dollars (FJD). */
    StorefrontCurrencyCode["Fjd"] = "FJD";
    /** Falkland Islands Pounds (FKP). */
    StorefrontCurrencyCode["Fkp"] = "FKP";
    /** United Kingdom Pounds (GBP). */
    StorefrontCurrencyCode["Gbp"] = "GBP";
    /** Georgian Lari (GEL). */
    StorefrontCurrencyCode["Gel"] = "GEL";
    /** Ghanaian Cedi (GHS). */
    StorefrontCurrencyCode["Ghs"] = "GHS";
    /** Gibraltar Pounds (GIP). */
    StorefrontCurrencyCode["Gip"] = "GIP";
    /** Gambian Dalasi (GMD). */
    StorefrontCurrencyCode["Gmd"] = "GMD";
    /** Guinean Franc (GNF). */
    StorefrontCurrencyCode["Gnf"] = "GNF";
    /** Guatemalan Quetzal (GTQ). */
    StorefrontCurrencyCode["Gtq"] = "GTQ";
    /** Guyanese Dollar (GYD). */
    StorefrontCurrencyCode["Gyd"] = "GYD";
    /** Hong Kong Dollars (HKD). */
    StorefrontCurrencyCode["Hkd"] = "HKD";
    /** Honduran Lempira (HNL). */
    StorefrontCurrencyCode["Hnl"] = "HNL";
    /** Croatian Kuna (HRK). */
    StorefrontCurrencyCode["Hrk"] = "HRK";
    /** Haitian Gourde (HTG). */
    StorefrontCurrencyCode["Htg"] = "HTG";
    /** Hungarian Forint (HUF). */
    StorefrontCurrencyCode["Huf"] = "HUF";
    /** Indonesian Rupiah (IDR). */
    StorefrontCurrencyCode["Idr"] = "IDR";
    /** Israeli New Shekel (NIS). */
    StorefrontCurrencyCode["Ils"] = "ILS";
    /** Indian Rupees (INR). */
    StorefrontCurrencyCode["Inr"] = "INR";
    /** Iraqi Dinar (IQD). */
    StorefrontCurrencyCode["Iqd"] = "IQD";
    /** Iranian Rial (IRR). */
    StorefrontCurrencyCode["Irr"] = "IRR";
    /** Icelandic Kronur (ISK). */
    StorefrontCurrencyCode["Isk"] = "ISK";
    /** Jersey Pound. */
    StorefrontCurrencyCode["Jep"] = "JEP";
    /** Jamaican Dollars (JMD). */
    StorefrontCurrencyCode["Jmd"] = "JMD";
    /** Jordanian Dinar (JOD). */
    StorefrontCurrencyCode["Jod"] = "JOD";
    /** Japanese Yen (JPY). */
    StorefrontCurrencyCode["Jpy"] = "JPY";
    /** Kenyan Shilling (KES). */
    StorefrontCurrencyCode["Kes"] = "KES";
    /** Kyrgyzstani Som (KGS). */
    StorefrontCurrencyCode["Kgs"] = "KGS";
    /** Cambodian Riel. */
    StorefrontCurrencyCode["Khr"] = "KHR";
    /** Kiribati Dollar (KID). */
    StorefrontCurrencyCode["Kid"] = "KID";
    /** Comorian Franc (KMF). */
    StorefrontCurrencyCode["Kmf"] = "KMF";
    /** South Korean Won (KRW). */
    StorefrontCurrencyCode["Krw"] = "KRW";
    /** Kuwaiti Dinar (KWD). */
    StorefrontCurrencyCode["Kwd"] = "KWD";
    /** Cayman Dollars (KYD). */
    StorefrontCurrencyCode["Kyd"] = "KYD";
    /** Kazakhstani Tenge (KZT). */
    StorefrontCurrencyCode["Kzt"] = "KZT";
    /** Laotian Kip (LAK). */
    StorefrontCurrencyCode["Lak"] = "LAK";
    /** Lebanese Pounds (LBP). */
    StorefrontCurrencyCode["Lbp"] = "LBP";
    /** Sri Lankan Rupees (LKR). */
    StorefrontCurrencyCode["Lkr"] = "LKR";
    /** Liberian Dollar (LRD). */
    StorefrontCurrencyCode["Lrd"] = "LRD";
    /** Lesotho Loti (LSL). */
    StorefrontCurrencyCode["Lsl"] = "LSL";
    /** Lithuanian Litai (LTL). */
    StorefrontCurrencyCode["Ltl"] = "LTL";
    /** Latvian Lati (LVL). */
    StorefrontCurrencyCode["Lvl"] = "LVL";
    /** Libyan Dinar (LYD). */
    StorefrontCurrencyCode["Lyd"] = "LYD";
    /** Moroccan Dirham. */
    StorefrontCurrencyCode["Mad"] = "MAD";
    /** Moldovan Leu (MDL). */
    StorefrontCurrencyCode["Mdl"] = "MDL";
    /** Malagasy Ariary (MGA). */
    StorefrontCurrencyCode["Mga"] = "MGA";
    /** Macedonia Denar (MKD). */
    StorefrontCurrencyCode["Mkd"] = "MKD";
    /** Burmese Kyat (MMK). */
    StorefrontCurrencyCode["Mmk"] = "MMK";
    /** Mongolian Tugrik. */
    StorefrontCurrencyCode["Mnt"] = "MNT";
    /** Macanese Pataca (MOP). */
    StorefrontCurrencyCode["Mop"] = "MOP";
    /** Mauritanian Ouguiya (MRU). */
    StorefrontCurrencyCode["Mru"] = "MRU";
    /** Mauritian Rupee (MUR). */
    StorefrontCurrencyCode["Mur"] = "MUR";
    /** Maldivian Rufiyaa (MVR). */
    StorefrontCurrencyCode["Mvr"] = "MVR";
    /** Malawian Kwacha (MWK). */
    StorefrontCurrencyCode["Mwk"] = "MWK";
    /** Mexican Pesos (MXN). */
    StorefrontCurrencyCode["Mxn"] = "MXN";
    /** Malaysian Ringgits (MYR). */
    StorefrontCurrencyCode["Myr"] = "MYR";
    /** Mozambican Metical. */
    StorefrontCurrencyCode["Mzn"] = "MZN";
    /** Namibian Dollar. */
    StorefrontCurrencyCode["Nad"] = "NAD";
    /** Nigerian Naira (NGN). */
    StorefrontCurrencyCode["Ngn"] = "NGN";
    /** Nicaraguan Córdoba (NIO). */
    StorefrontCurrencyCode["Nio"] = "NIO";
    /** Norwegian Kroner (NOK). */
    StorefrontCurrencyCode["Nok"] = "NOK";
    /** Nepalese Rupee (NPR). */
    StorefrontCurrencyCode["Npr"] = "NPR";
    /** New Zealand Dollars (NZD). */
    StorefrontCurrencyCode["Nzd"] = "NZD";
    /** Omani Rial (OMR). */
    StorefrontCurrencyCode["Omr"] = "OMR";
    /** Panamian Balboa (PAB). */
    StorefrontCurrencyCode["Pab"] = "PAB";
    /** Peruvian Nuevo Sol (PEN). */
    StorefrontCurrencyCode["Pen"] = "PEN";
    /** Papua New Guinean Kina (PGK). */
    StorefrontCurrencyCode["Pgk"] = "PGK";
    /** Philippine Peso (PHP). */
    StorefrontCurrencyCode["Php"] = "PHP";
    /** Pakistani Rupee (PKR). */
    StorefrontCurrencyCode["Pkr"] = "PKR";
    /** Polish Zlotych (PLN). */
    StorefrontCurrencyCode["Pln"] = "PLN";
    /** Paraguayan Guarani (PYG). */
    StorefrontCurrencyCode["Pyg"] = "PYG";
    /** Qatari Rial (QAR). */
    StorefrontCurrencyCode["Qar"] = "QAR";
    /** Romanian Lei (RON). */
    StorefrontCurrencyCode["Ron"] = "RON";
    /** Serbian dinar (RSD). */
    StorefrontCurrencyCode["Rsd"] = "RSD";
    /** Russian Rubles (RUB). */
    StorefrontCurrencyCode["Rub"] = "RUB";
    /** Rwandan Franc (RWF). */
    StorefrontCurrencyCode["Rwf"] = "RWF";
    /** Saudi Riyal (SAR). */
    StorefrontCurrencyCode["Sar"] = "SAR";
    /** Solomon Islands Dollar (SBD). */
    StorefrontCurrencyCode["Sbd"] = "SBD";
    /** Seychellois Rupee (SCR). */
    StorefrontCurrencyCode["Scr"] = "SCR";
    /** Sudanese Pound (SDG). */
    StorefrontCurrencyCode["Sdg"] = "SDG";
    /** Swedish Kronor (SEK). */
    StorefrontCurrencyCode["Sek"] = "SEK";
    /** Singapore Dollars (SGD). */
    StorefrontCurrencyCode["Sgd"] = "SGD";
    /** Saint Helena Pounds (SHP). */
    StorefrontCurrencyCode["Shp"] = "SHP";
    /** Sierra Leonean Leone (SLL). */
    StorefrontCurrencyCode["Sll"] = "SLL";
    /** Somali Shilling (SOS). */
    StorefrontCurrencyCode["Sos"] = "SOS";
    /** Surinamese Dollar (SRD). */
    StorefrontCurrencyCode["Srd"] = "SRD";
    /** South Sudanese Pound (SSP). */
    StorefrontCurrencyCode["Ssp"] = "SSP";
    /**
     * Sao Tome And Principe Dobra (STD).
     * @deprecated `STD` is deprecated. Use `STN` available from version `2022-07` onwards instead.
     */
    StorefrontCurrencyCode["Std"] = "STD";
    /** Sao Tome And Principe Dobra (STN). */
    StorefrontCurrencyCode["Stn"] = "STN";
    /** Syrian Pound (SYP). */
    StorefrontCurrencyCode["Syp"] = "SYP";
    /** Swazi Lilangeni (SZL). */
    StorefrontCurrencyCode["Szl"] = "SZL";
    /** Thai baht (THB). */
    StorefrontCurrencyCode["Thb"] = "THB";
    /** Tajikistani Somoni (TJS). */
    StorefrontCurrencyCode["Tjs"] = "TJS";
    /** Turkmenistani Manat (TMT). */
    StorefrontCurrencyCode["Tmt"] = "TMT";
    /** Tunisian Dinar (TND). */
    StorefrontCurrencyCode["Tnd"] = "TND";
    /** Tongan Pa'anga (TOP). */
    StorefrontCurrencyCode["Top"] = "TOP";
    /** Turkish Lira (TRY). */
    StorefrontCurrencyCode["Try"] = "TRY";
    /** Trinidad and Tobago Dollars (TTD). */
    StorefrontCurrencyCode["Ttd"] = "TTD";
    /** Taiwan Dollars (TWD). */
    StorefrontCurrencyCode["Twd"] = "TWD";
    /** Tanzanian Shilling (TZS). */
    StorefrontCurrencyCode["Tzs"] = "TZS";
    /** Ukrainian Hryvnia (UAH). */
    StorefrontCurrencyCode["Uah"] = "UAH";
    /** Ugandan Shilling (UGX). */
    StorefrontCurrencyCode["Ugx"] = "UGX";
    /** United States Dollars (USD). */
    StorefrontCurrencyCode["Usd"] = "USD";
    /** Uruguayan Pesos (UYU). */
    StorefrontCurrencyCode["Uyu"] = "UYU";
    /** Uzbekistan som (UZS). */
    StorefrontCurrencyCode["Uzs"] = "UZS";
    /** Venezuelan Bolivares (VED). */
    StorefrontCurrencyCode["Ved"] = "VED";
    /**
     * Venezuelan Bolivares (VEF).
     * @deprecated `VEF` is deprecated. Use `VES` available from version `2020-10` onwards instead.
     */
    StorefrontCurrencyCode["Vef"] = "VEF";
    /** Venezuelan Bolivares (VES). */
    StorefrontCurrencyCode["Ves"] = "VES";
    /** Vietnamese đồng (VND). */
    StorefrontCurrencyCode["Vnd"] = "VND";
    /** Vanuatu Vatu (VUV). */
    StorefrontCurrencyCode["Vuv"] = "VUV";
    /** Samoan Tala (WST). */
    StorefrontCurrencyCode["Wst"] = "WST";
    /** Central African CFA Franc (XAF). */
    StorefrontCurrencyCode["Xaf"] = "XAF";
    /** East Caribbean Dollar (XCD). */
    StorefrontCurrencyCode["Xcd"] = "XCD";
    /** West African CFA franc (XOF). */
    StorefrontCurrencyCode["Xof"] = "XOF";
    /** CFP Franc (XPF). */
    StorefrontCurrencyCode["Xpf"] = "XPF";
    /** Unrecognized currency. */
    StorefrontCurrencyCode["Xxx"] = "XXX";
    /** Yemeni Rial (YER). */
    StorefrontCurrencyCode["Yer"] = "YER";
    /** South African Rand (ZAR). */
    StorefrontCurrencyCode["Zar"] = "ZAR";
    /** Zambian Kwacha (ZMW). */
    StorefrontCurrencyCode["Zmw"] = "ZMW";
})(StorefrontCurrencyCode = exports.StorefrontCurrencyCode || (exports.StorefrontCurrencyCode = {}));
/** Possible error codes that can be returned by `CustomerUserError`. */
var StorefrontCustomerErrorCode;
(function (StorefrontCustomerErrorCode) {
    /** Customer already enabled. */
    StorefrontCustomerErrorCode["AlreadyEnabled"] = "ALREADY_ENABLED";
    /** Input email contains an invalid domain name. */
    StorefrontCustomerErrorCode["BadDomain"] = "BAD_DOMAIN";
    /** The input value is blank. */
    StorefrontCustomerErrorCode["Blank"] = "BLANK";
    /** Input contains HTML tags. */
    StorefrontCustomerErrorCode["ContainsHtmlTags"] = "CONTAINS_HTML_TAGS";
    /** Input contains URL. */
    StorefrontCustomerErrorCode["ContainsUrl"] = "CONTAINS_URL";
    /** Customer is disabled. */
    StorefrontCustomerErrorCode["CustomerDisabled"] = "CUSTOMER_DISABLED";
    /** The input value is invalid. */
    StorefrontCustomerErrorCode["Invalid"] = "INVALID";
    /** Multipass token is not valid. */
    StorefrontCustomerErrorCode["InvalidMultipassRequest"] = "INVALID_MULTIPASS_REQUEST";
    /** Address does not exist. */
    StorefrontCustomerErrorCode["NotFound"] = "NOT_FOUND";
    /** Input password starts or ends with whitespace. */
    StorefrontCustomerErrorCode["PasswordStartsOrEndsWithWhitespace"] = "PASSWORD_STARTS_OR_ENDS_WITH_WHITESPACE";
    /** The input value is already taken. */
    StorefrontCustomerErrorCode["Taken"] = "TAKEN";
    /** Invalid activation token. */
    StorefrontCustomerErrorCode["TokenInvalid"] = "TOKEN_INVALID";
    /** The input value is too long. */
    StorefrontCustomerErrorCode["TooLong"] = "TOO_LONG";
    /** The input value is too short. */
    StorefrontCustomerErrorCode["TooShort"] = "TOO_SHORT";
    /** Unidentified customer. */
    StorefrontCustomerErrorCode["UnidentifiedCustomer"] = "UNIDENTIFIED_CUSTOMER";
})(StorefrontCustomerErrorCode = exports.StorefrontCustomerErrorCode || (exports.StorefrontCustomerErrorCode = {}));
/** List of different delivery method types. */
var StorefrontDeliveryMethodType;
(function (StorefrontDeliveryMethodType) {
    /** Local Delivery. */
    StorefrontDeliveryMethodType["Local"] = "LOCAL";
    /** None. */
    StorefrontDeliveryMethodType["None"] = "NONE";
    /** Shipping to a Pickup Point. */
    StorefrontDeliveryMethodType["PickupPoint"] = "PICKUP_POINT";
    /** Local Pickup. */
    StorefrontDeliveryMethodType["PickUp"] = "PICK_UP";
    /** Retail. */
    StorefrontDeliveryMethodType["Retail"] = "RETAIL";
    /** Shipping. */
    StorefrontDeliveryMethodType["Shipping"] = "SHIPPING";
})(StorefrontDeliveryMethodType = exports.StorefrontDeliveryMethodType || (exports.StorefrontDeliveryMethodType = {}));
/** Digital wallet, such as Apple Pay, which can be used for accelerated checkouts. */
var StorefrontDigitalWallet;
(function (StorefrontDigitalWallet) {
    /** Android Pay. */
    StorefrontDigitalWallet["AndroidPay"] = "ANDROID_PAY";
    /** Apple Pay. */
    StorefrontDigitalWallet["ApplePay"] = "APPLE_PAY";
    /** Google Pay. */
    StorefrontDigitalWallet["GooglePay"] = "GOOGLE_PAY";
    /** Shopify Pay. */
    StorefrontDigitalWallet["ShopifyPay"] = "SHOPIFY_PAY";
})(StorefrontDigitalWallet = exports.StorefrontDigitalWallet || (exports.StorefrontDigitalWallet = {}));
/** The method by which the discount's value is allocated onto its entitled lines. */
var StorefrontDiscountApplicationAllocationMethod;
(function (StorefrontDiscountApplicationAllocationMethod) {
    /** The value is spread across all entitled lines. */
    StorefrontDiscountApplicationAllocationMethod["Across"] = "ACROSS";
    /** The value is applied onto every entitled line. */
    StorefrontDiscountApplicationAllocationMethod["Each"] = "EACH";
    /**
     * The value is specifically applied onto a particular line.
     * @deprecated Use ACROSS instead.
     */
    StorefrontDiscountApplicationAllocationMethod["One"] = "ONE";
})(StorefrontDiscountApplicationAllocationMethod = exports.StorefrontDiscountApplicationAllocationMethod || (exports.StorefrontDiscountApplicationAllocationMethod = {}));
/**
 * The lines on the order to which the discount is applied, of the type defined by
 * the discount application's `targetType`. For example, the value `ENTITLED`, combined with a `targetType` of
 * `LINE_ITEM`, applies the discount on all line items that are entitled to the discount.
 * The value `ALL`, combined with a `targetType` of `SHIPPING_LINE`, applies the discount on all shipping lines.
 *
 */
var StorefrontDiscountApplicationTargetSelection;
(function (StorefrontDiscountApplicationTargetSelection) {
    /** The discount is allocated onto all the lines. */
    StorefrontDiscountApplicationTargetSelection["All"] = "ALL";
    /** The discount is allocated onto only the lines that it's entitled for. */
    StorefrontDiscountApplicationTargetSelection["Entitled"] = "ENTITLED";
    /** The discount is allocated onto explicitly chosen lines. */
    StorefrontDiscountApplicationTargetSelection["Explicit"] = "EXPLICIT";
})(StorefrontDiscountApplicationTargetSelection = exports.StorefrontDiscountApplicationTargetSelection || (exports.StorefrontDiscountApplicationTargetSelection = {}));
/**
 * The type of line (i.e. line item or shipping line) on an order that the discount is applicable towards.
 *
 */
var StorefrontDiscountApplicationTargetType;
(function (StorefrontDiscountApplicationTargetType) {
    /** The discount applies onto line items. */
    StorefrontDiscountApplicationTargetType["LineItem"] = "LINE_ITEM";
    /** The discount applies onto shipping lines. */
    StorefrontDiscountApplicationTargetType["ShippingLine"] = "SHIPPING_LINE";
})(StorefrontDiscountApplicationTargetType = exports.StorefrontDiscountApplicationTargetType || (exports.StorefrontDiscountApplicationTargetType = {}));
/**
 * The type of data that the filter group represents.
 *
 * For more information, refer to [Filter products in a collection with the Storefront API]
 * (https://shopify.dev/custom-storefronts/products-collections/filter-products).
 *
 */
var StorefrontFilterType;
(function (StorefrontFilterType) {
    /** A boolean value. */
    StorefrontFilterType["Boolean"] = "BOOLEAN";
    /** A list of selectable values. */
    StorefrontFilterType["List"] = "LIST";
    /** A range of prices. */
    StorefrontFilterType["PriceRange"] = "PRICE_RANGE";
})(StorefrontFilterType = exports.StorefrontFilterType || (exports.StorefrontFilterType = {}));
/** List of supported image content types. */
var StorefrontImageContentType;
(function (StorefrontImageContentType) {
    /** A JPG image. */
    StorefrontImageContentType["Jpg"] = "JPG";
    /** A PNG image. */
    StorefrontImageContentType["Png"] = "PNG";
    /** A WEBP image. */
    StorefrontImageContentType["Webp"] = "WEBP";
})(StorefrontImageContentType = exports.StorefrontImageContentType || (exports.StorefrontImageContentType = {}));
/** ISO 639-1 language codes supported by Shopify. */
var StorefrontLanguageCode;
(function (StorefrontLanguageCode) {
    /** Afrikaans. */
    StorefrontLanguageCode["Af"] = "AF";
    /** Akan. */
    StorefrontLanguageCode["Ak"] = "AK";
    /** Amharic. */
    StorefrontLanguageCode["Am"] = "AM";
    /** Arabic. */
    StorefrontLanguageCode["Ar"] = "AR";
    /** Assamese. */
    StorefrontLanguageCode["As"] = "AS";
    /** Azerbaijani. */
    StorefrontLanguageCode["Az"] = "AZ";
    /** Belarusian. */
    StorefrontLanguageCode["Be"] = "BE";
    /** Bulgarian. */
    StorefrontLanguageCode["Bg"] = "BG";
    /** Bambara. */
    StorefrontLanguageCode["Bm"] = "BM";
    /** Bangla. */
    StorefrontLanguageCode["Bn"] = "BN";
    /** Tibetan. */
    StorefrontLanguageCode["Bo"] = "BO";
    /** Breton. */
    StorefrontLanguageCode["Br"] = "BR";
    /** Bosnian. */
    StorefrontLanguageCode["Bs"] = "BS";
    /** Catalan. */
    StorefrontLanguageCode["Ca"] = "CA";
    /** Chechen. */
    StorefrontLanguageCode["Ce"] = "CE";
    /** Czech. */
    StorefrontLanguageCode["Cs"] = "CS";
    /** Church Slavic. */
    StorefrontLanguageCode["Cu"] = "CU";
    /** Welsh. */
    StorefrontLanguageCode["Cy"] = "CY";
    /** Danish. */
    StorefrontLanguageCode["Da"] = "DA";
    /** German. */
    StorefrontLanguageCode["De"] = "DE";
    /** Dzongkha. */
    StorefrontLanguageCode["Dz"] = "DZ";
    /** Ewe. */
    StorefrontLanguageCode["Ee"] = "EE";
    /** Greek. */
    StorefrontLanguageCode["El"] = "EL";
    /** English. */
    StorefrontLanguageCode["En"] = "EN";
    /** Esperanto. */
    StorefrontLanguageCode["Eo"] = "EO";
    /** Spanish. */
    StorefrontLanguageCode["Es"] = "ES";
    /** Estonian. */
    StorefrontLanguageCode["Et"] = "ET";
    /** Basque. */
    StorefrontLanguageCode["Eu"] = "EU";
    /** Persian. */
    StorefrontLanguageCode["Fa"] = "FA";
    /** Fulah. */
    StorefrontLanguageCode["Ff"] = "FF";
    /** Finnish. */
    StorefrontLanguageCode["Fi"] = "FI";
    /** Faroese. */
    StorefrontLanguageCode["Fo"] = "FO";
    /** French. */
    StorefrontLanguageCode["Fr"] = "FR";
    /** Western Frisian. */
    StorefrontLanguageCode["Fy"] = "FY";
    /** Irish. */
    StorefrontLanguageCode["Ga"] = "GA";
    /** Scottish Gaelic. */
    StorefrontLanguageCode["Gd"] = "GD";
    /** Galician. */
    StorefrontLanguageCode["Gl"] = "GL";
    /** Gujarati. */
    StorefrontLanguageCode["Gu"] = "GU";
    /** Manx. */
    StorefrontLanguageCode["Gv"] = "GV";
    /** Hausa. */
    StorefrontLanguageCode["Ha"] = "HA";
    /** Hebrew. */
    StorefrontLanguageCode["He"] = "HE";
    /** Hindi. */
    StorefrontLanguageCode["Hi"] = "HI";
    /** Croatian. */
    StorefrontLanguageCode["Hr"] = "HR";
    /** Hungarian. */
    StorefrontLanguageCode["Hu"] = "HU";
    /** Armenian. */
    StorefrontLanguageCode["Hy"] = "HY";
    /** Interlingua. */
    StorefrontLanguageCode["Ia"] = "IA";
    /** Indonesian. */
    StorefrontLanguageCode["Id"] = "ID";
    /** Igbo. */
    StorefrontLanguageCode["Ig"] = "IG";
    /** Sichuan Yi. */
    StorefrontLanguageCode["Ii"] = "II";
    /** Icelandic. */
    StorefrontLanguageCode["Is"] = "IS";
    /** Italian. */
    StorefrontLanguageCode["It"] = "IT";
    /** Japanese. */
    StorefrontLanguageCode["Ja"] = "JA";
    /** Javanese. */
    StorefrontLanguageCode["Jv"] = "JV";
    /** Georgian. */
    StorefrontLanguageCode["Ka"] = "KA";
    /** Kikuyu. */
    StorefrontLanguageCode["Ki"] = "KI";
    /** Kazakh. */
    StorefrontLanguageCode["Kk"] = "KK";
    /** Kalaallisut. */
    StorefrontLanguageCode["Kl"] = "KL";
    /** Khmer. */
    StorefrontLanguageCode["Km"] = "KM";
    /** Kannada. */
    StorefrontLanguageCode["Kn"] = "KN";
    /** Korean. */
    StorefrontLanguageCode["Ko"] = "KO";
    /** Kashmiri. */
    StorefrontLanguageCode["Ks"] = "KS";
    /** Kurdish. */
    StorefrontLanguageCode["Ku"] = "KU";
    /** Cornish. */
    StorefrontLanguageCode["Kw"] = "KW";
    /** Kyrgyz. */
    StorefrontLanguageCode["Ky"] = "KY";
    /** Luxembourgish. */
    StorefrontLanguageCode["Lb"] = "LB";
    /** Ganda. */
    StorefrontLanguageCode["Lg"] = "LG";
    /** Lingala. */
    StorefrontLanguageCode["Ln"] = "LN";
    /** Lao. */
    StorefrontLanguageCode["Lo"] = "LO";
    /** Lithuanian. */
    StorefrontLanguageCode["Lt"] = "LT";
    /** Luba-Katanga. */
    StorefrontLanguageCode["Lu"] = "LU";
    /** Latvian. */
    StorefrontLanguageCode["Lv"] = "LV";
    /** Malagasy. */
    StorefrontLanguageCode["Mg"] = "MG";
    /** Māori. */
    StorefrontLanguageCode["Mi"] = "MI";
    /** Macedonian. */
    StorefrontLanguageCode["Mk"] = "MK";
    /** Malayalam. */
    StorefrontLanguageCode["Ml"] = "ML";
    /** Mongolian. */
    StorefrontLanguageCode["Mn"] = "MN";
    /** Marathi. */
    StorefrontLanguageCode["Mr"] = "MR";
    /** Malay. */
    StorefrontLanguageCode["Ms"] = "MS";
    /** Maltese. */
    StorefrontLanguageCode["Mt"] = "MT";
    /** Burmese. */
    StorefrontLanguageCode["My"] = "MY";
    /** Norwegian (Bokmål). */
    StorefrontLanguageCode["Nb"] = "NB";
    /** North Ndebele. */
    StorefrontLanguageCode["Nd"] = "ND";
    /** Nepali. */
    StorefrontLanguageCode["Ne"] = "NE";
    /** Dutch. */
    StorefrontLanguageCode["Nl"] = "NL";
    /** Norwegian Nynorsk. */
    StorefrontLanguageCode["Nn"] = "NN";
    /** Norwegian. */
    StorefrontLanguageCode["No"] = "NO";
    /** Oromo. */
    StorefrontLanguageCode["Om"] = "OM";
    /** Odia. */
    StorefrontLanguageCode["Or"] = "OR";
    /** Ossetic. */
    StorefrontLanguageCode["Os"] = "OS";
    /** Punjabi. */
    StorefrontLanguageCode["Pa"] = "PA";
    /** Polish. */
    StorefrontLanguageCode["Pl"] = "PL";
    /** Pashto. */
    StorefrontLanguageCode["Ps"] = "PS";
    /** Portuguese. */
    StorefrontLanguageCode["Pt"] = "PT";
    /** Portuguese (Brazil). */
    StorefrontLanguageCode["PtBr"] = "PT_BR";
    /** Portuguese (Portugal). */
    StorefrontLanguageCode["PtPt"] = "PT_PT";
    /** Quechua. */
    StorefrontLanguageCode["Qu"] = "QU";
    /** Romansh. */
    StorefrontLanguageCode["Rm"] = "RM";
    /** Rundi. */
    StorefrontLanguageCode["Rn"] = "RN";
    /** Romanian. */
    StorefrontLanguageCode["Ro"] = "RO";
    /** Russian. */
    StorefrontLanguageCode["Ru"] = "RU";
    /** Kinyarwanda. */
    StorefrontLanguageCode["Rw"] = "RW";
    /** Sindhi. */
    StorefrontLanguageCode["Sd"] = "SD";
    /** Northern Sami. */
    StorefrontLanguageCode["Se"] = "SE";
    /** Sango. */
    StorefrontLanguageCode["Sg"] = "SG";
    /** Sinhala. */
    StorefrontLanguageCode["Si"] = "SI";
    /** Slovak. */
    StorefrontLanguageCode["Sk"] = "SK";
    /** Slovenian. */
    StorefrontLanguageCode["Sl"] = "SL";
    /** Shona. */
    StorefrontLanguageCode["Sn"] = "SN";
    /** Somali. */
    StorefrontLanguageCode["So"] = "SO";
    /** Albanian. */
    StorefrontLanguageCode["Sq"] = "SQ";
    /** Serbian. */
    StorefrontLanguageCode["Sr"] = "SR";
    /** Sundanese. */
    StorefrontLanguageCode["Su"] = "SU";
    /** Swedish. */
    StorefrontLanguageCode["Sv"] = "SV";
    /** Swahili. */
    StorefrontLanguageCode["Sw"] = "SW";
    /** Tamil. */
    StorefrontLanguageCode["Ta"] = "TA";
    /** Telugu. */
    StorefrontLanguageCode["Te"] = "TE";
    /** Tajik. */
    StorefrontLanguageCode["Tg"] = "TG";
    /** Thai. */
    StorefrontLanguageCode["Th"] = "TH";
    /** Tigrinya. */
    StorefrontLanguageCode["Ti"] = "TI";
    /** Turkmen. */
    StorefrontLanguageCode["Tk"] = "TK";
    /** Tongan. */
    StorefrontLanguageCode["To"] = "TO";
    /** Turkish. */
    StorefrontLanguageCode["Tr"] = "TR";
    /** Tatar. */
    StorefrontLanguageCode["Tt"] = "TT";
    /** Uyghur. */
    StorefrontLanguageCode["Ug"] = "UG";
    /** Ukrainian. */
    StorefrontLanguageCode["Uk"] = "UK";
    /** Urdu. */
    StorefrontLanguageCode["Ur"] = "UR";
    /** Uzbek. */
    StorefrontLanguageCode["Uz"] = "UZ";
    /** Vietnamese. */
    StorefrontLanguageCode["Vi"] = "VI";
    /** Volapük. */
    StorefrontLanguageCode["Vo"] = "VO";
    /** Wolof. */
    StorefrontLanguageCode["Wo"] = "WO";
    /** Xhosa. */
    StorefrontLanguageCode["Xh"] = "XH";
    /** Yiddish. */
    StorefrontLanguageCode["Yi"] = "YI";
    /** Yoruba. */
    StorefrontLanguageCode["Yo"] = "YO";
    /** Chinese. */
    StorefrontLanguageCode["Zh"] = "ZH";
    /** Chinese (Simplified). */
    StorefrontLanguageCode["ZhCn"] = "ZH_CN";
    /** Chinese (Traditional). */
    StorefrontLanguageCode["ZhTw"] = "ZH_TW";
    /** Zulu. */
    StorefrontLanguageCode["Zu"] = "ZU";
})(StorefrontLanguageCode = exports.StorefrontLanguageCode || (exports.StorefrontLanguageCode = {}));
/** The set of valid sort keys for the Location query. */
var StorefrontLocationSortKeys;
(function (StorefrontLocationSortKeys) {
    /** Sort by the `city` value. */
    StorefrontLocationSortKeys["City"] = "CITY";
    /** Sort by the `distance` value. */
    StorefrontLocationSortKeys["Distance"] = "DISTANCE";
    /** Sort by the `id` value. */
    StorefrontLocationSortKeys["Id"] = "ID";
    /** Sort by the `name` value. */
    StorefrontLocationSortKeys["Name"] = "NAME";
})(StorefrontLocationSortKeys = exports.StorefrontLocationSortKeys || (exports.StorefrontLocationSortKeys = {}));
/** The possible content types for a media object. */
var StorefrontMediaContentType;
(function (StorefrontMediaContentType) {
    /** An externally hosted video. */
    StorefrontMediaContentType["ExternalVideo"] = "EXTERNAL_VIDEO";
    /** A Shopify hosted image. */
    StorefrontMediaContentType["Image"] = "IMAGE";
    /** A 3d model. */
    StorefrontMediaContentType["Model_3D"] = "MODEL_3D";
    /** A Shopify hosted video. */
    StorefrontMediaContentType["Video"] = "VIDEO";
})(StorefrontMediaContentType = exports.StorefrontMediaContentType || (exports.StorefrontMediaContentType = {}));
/** Host for a Media Resource. */
var StorefrontMediaHost;
(function (StorefrontMediaHost) {
    /** Host for Vimeo embedded videos. */
    StorefrontMediaHost["Vimeo"] = "VIMEO";
    /** Host for YouTube embedded videos. */
    StorefrontMediaHost["Youtube"] = "YOUTUBE";
})(StorefrontMediaHost = exports.StorefrontMediaHost || (exports.StorefrontMediaHost = {}));
/** The possible formats for a media presentation. */
var StorefrontMediaPresentationFormat;
(function (StorefrontMediaPresentationFormat) {
    /** A media image presentation. */
    StorefrontMediaPresentationFormat["Image"] = "IMAGE";
    /** A model viewer presentation. */
    StorefrontMediaPresentationFormat["ModelViewer"] = "MODEL_VIEWER";
})(StorefrontMediaPresentationFormat = exports.StorefrontMediaPresentationFormat || (exports.StorefrontMediaPresentationFormat = {}));
/** A menu item type. */
var StorefrontMenuItemType;
(function (StorefrontMenuItemType) {
    /** An article link. */
    StorefrontMenuItemType["Article"] = "ARTICLE";
    /** A blog link. */
    StorefrontMenuItemType["Blog"] = "BLOG";
    /** A catalog link. */
    StorefrontMenuItemType["Catalog"] = "CATALOG";
    /** A collection link. */
    StorefrontMenuItemType["Collection"] = "COLLECTION";
    /** A collection link. */
    StorefrontMenuItemType["Collections"] = "COLLECTIONS";
    /** A frontpage link. */
    StorefrontMenuItemType["Frontpage"] = "FRONTPAGE";
    /** An http link. */
    StorefrontMenuItemType["Http"] = "HTTP";
    /** A page link. */
    StorefrontMenuItemType["Page"] = "PAGE";
    /** A product link. */
    StorefrontMenuItemType["Product"] = "PRODUCT";
    /** A search link. */
    StorefrontMenuItemType["Search"] = "SEARCH";
    /** A shop policy link. */
    StorefrontMenuItemType["ShopPolicy"] = "SHOP_POLICY";
})(StorefrontMenuItemType = exports.StorefrontMenuItemType || (exports.StorefrontMenuItemType = {}));
/** Possible error codes that can be returned by `MetafieldDeleteUserError`. */
var StorefrontMetafieldDeleteErrorCode;
(function (StorefrontMetafieldDeleteErrorCode) {
    /** The owner ID is invalid. */
    StorefrontMetafieldDeleteErrorCode["InvalidOwner"] = "INVALID_OWNER";
    /** Metafield not found. */
    StorefrontMetafieldDeleteErrorCode["MetafieldDoesNotExist"] = "METAFIELD_DOES_NOT_EXIST";
})(StorefrontMetafieldDeleteErrorCode = exports.StorefrontMetafieldDeleteErrorCode || (exports.StorefrontMetafieldDeleteErrorCode = {}));
/** Possible error codes that can be returned by `MetafieldsSetUserError`. */
var StorefrontMetafieldsSetUserErrorCode;
(function (StorefrontMetafieldsSetUserErrorCode) {
    /** The input value is blank. */
    StorefrontMetafieldsSetUserErrorCode["Blank"] = "BLANK";
    /** The input value isn't included in the list. */
    StorefrontMetafieldsSetUserErrorCode["Inclusion"] = "INCLUSION";
    /** The owner ID is invalid. */
    StorefrontMetafieldsSetUserErrorCode["InvalidOwner"] = "INVALID_OWNER";
    /** The type is invalid. */
    StorefrontMetafieldsSetUserErrorCode["InvalidType"] = "INVALID_TYPE";
    /** The value is invalid for metafield type or for definition options. */
    StorefrontMetafieldsSetUserErrorCode["InvalidValue"] = "INVALID_VALUE";
    /** The input value should be less than or equal to the maximum value allowed. */
    StorefrontMetafieldsSetUserErrorCode["LessThanOrEqualTo"] = "LESS_THAN_OR_EQUAL_TO";
    /** The input value needs to be blank. */
    StorefrontMetafieldsSetUserErrorCode["Present"] = "PRESENT";
    /** The input value is too long. */
    StorefrontMetafieldsSetUserErrorCode["TooLong"] = "TOO_LONG";
    /** The input value is too short. */
    StorefrontMetafieldsSetUserErrorCode["TooShort"] = "TOO_SHORT";
})(StorefrontMetafieldsSetUserErrorCode = exports.StorefrontMetafieldsSetUserErrorCode || (exports.StorefrontMetafieldsSetUserErrorCode = {}));
/** Represents the reason for the order's cancellation. */
var StorefrontOrderCancelReason;
(function (StorefrontOrderCancelReason) {
    /** The customer wanted to cancel the order. */
    StorefrontOrderCancelReason["Customer"] = "CUSTOMER";
    /** Payment was declined. */
    StorefrontOrderCancelReason["Declined"] = "DECLINED";
    /** The order was fraudulent. */
    StorefrontOrderCancelReason["Fraud"] = "FRAUD";
    /** There was insufficient inventory. */
    StorefrontOrderCancelReason["Inventory"] = "INVENTORY";
    /** The order was canceled for an unlisted reason. */
    StorefrontOrderCancelReason["Other"] = "OTHER";
})(StorefrontOrderCancelReason = exports.StorefrontOrderCancelReason || (exports.StorefrontOrderCancelReason = {}));
/** Represents the order's current financial status. */
var StorefrontOrderFinancialStatus;
(function (StorefrontOrderFinancialStatus) {
    /** Displayed as **Authorized**. */
    StorefrontOrderFinancialStatus["Authorized"] = "AUTHORIZED";
    /** Displayed as **Paid**. */
    StorefrontOrderFinancialStatus["Paid"] = "PAID";
    /** Displayed as **Partially paid**. */
    StorefrontOrderFinancialStatus["PartiallyPaid"] = "PARTIALLY_PAID";
    /** Displayed as **Partially refunded**. */
    StorefrontOrderFinancialStatus["PartiallyRefunded"] = "PARTIALLY_REFUNDED";
    /** Displayed as **Pending**. */
    StorefrontOrderFinancialStatus["Pending"] = "PENDING";
    /** Displayed as **Refunded**. */
    StorefrontOrderFinancialStatus["Refunded"] = "REFUNDED";
    /** Displayed as **Voided**. */
    StorefrontOrderFinancialStatus["Voided"] = "VOIDED";
})(StorefrontOrderFinancialStatus = exports.StorefrontOrderFinancialStatus || (exports.StorefrontOrderFinancialStatus = {}));
/** Represents the order's aggregated fulfillment status for display purposes. */
var StorefrontOrderFulfillmentStatus;
(function (StorefrontOrderFulfillmentStatus) {
    /** Displayed as **Fulfilled**. All of the items in the order have been fulfilled. */
    StorefrontOrderFulfillmentStatus["Fulfilled"] = "FULFILLED";
    /** Displayed as **In progress**. Some of the items in the order have been fulfilled, or a request for fulfillment has been sent to the fulfillment service. */
    StorefrontOrderFulfillmentStatus["InProgress"] = "IN_PROGRESS";
    /** Displayed as **On hold**. All of the unfulfilled items in this order are on hold. */
    StorefrontOrderFulfillmentStatus["OnHold"] = "ON_HOLD";
    /** Displayed as **Open**. None of the items in the order have been fulfilled. Replaced by "UNFULFILLED" status. */
    StorefrontOrderFulfillmentStatus["Open"] = "OPEN";
    /** Displayed as **Partially fulfilled**. Some of the items in the order have been fulfilled. */
    StorefrontOrderFulfillmentStatus["PartiallyFulfilled"] = "PARTIALLY_FULFILLED";
    /** Displayed as **Pending fulfillment**. A request for fulfillment of some items awaits a response from the fulfillment service. Replaced by "IN_PROGRESS" status. */
    StorefrontOrderFulfillmentStatus["PendingFulfillment"] = "PENDING_FULFILLMENT";
    /** Displayed as **Restocked**. All of the items in the order have been restocked. Replaced by "UNFULFILLED" status. */
    StorefrontOrderFulfillmentStatus["Restocked"] = "RESTOCKED";
    /** Displayed as **Scheduled**. All of the unfulfilled items in this order are scheduled for fulfillment at later time. */
    StorefrontOrderFulfillmentStatus["Scheduled"] = "SCHEDULED";
    /** Displayed as **Unfulfilled**. None of the items in the order have been fulfilled. */
    StorefrontOrderFulfillmentStatus["Unfulfilled"] = "UNFULFILLED";
})(StorefrontOrderFulfillmentStatus = exports.StorefrontOrderFulfillmentStatus || (exports.StorefrontOrderFulfillmentStatus = {}));
/** The set of valid sort keys for the Order query. */
var StorefrontOrderSortKeys;
(function (StorefrontOrderSortKeys) {
    /** Sort by the `id` value. */
    StorefrontOrderSortKeys["Id"] = "ID";
    /** Sort by the `processed_at` value. */
    StorefrontOrderSortKeys["ProcessedAt"] = "PROCESSED_AT";
    /**
     * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
     * Don't use this sort key when no search query is specified.
     *
     */
    StorefrontOrderSortKeys["Relevance"] = "RELEVANCE";
    /** Sort by the `total_price` value. */
    StorefrontOrderSortKeys["TotalPrice"] = "TOTAL_PRICE";
})(StorefrontOrderSortKeys = exports.StorefrontOrderSortKeys || (exports.StorefrontOrderSortKeys = {}));
/** The set of valid sort keys for the Page query. */
var StorefrontPageSortKeys;
(function (StorefrontPageSortKeys) {
    /** Sort by the `id` value. */
    StorefrontPageSortKeys["Id"] = "ID";
    /**
     * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
     * Don't use this sort key when no search query is specified.
     *
     */
    StorefrontPageSortKeys["Relevance"] = "RELEVANCE";
    /** Sort by the `title` value. */
    StorefrontPageSortKeys["Title"] = "TITLE";
    /** Sort by the `updated_at` value. */
    StorefrontPageSortKeys["UpdatedAt"] = "UPDATED_AT";
})(StorefrontPageSortKeys = exports.StorefrontPageSortKeys || (exports.StorefrontPageSortKeys = {}));
/** The valid values for the types of payment token. */
var StorefrontPaymentTokenType;
(function (StorefrontPaymentTokenType) {
    /** Apple Pay token type. */
    StorefrontPaymentTokenType["ApplePay"] = "APPLE_PAY";
    /** Google Pay token type. */
    StorefrontPaymentTokenType["GooglePay"] = "GOOGLE_PAY";
    /** Shopify Pay token type. */
    StorefrontPaymentTokenType["ShopifyPay"] = "SHOPIFY_PAY";
    /** Stripe token type. */
    StorefrontPaymentTokenType["StripeVaultToken"] = "STRIPE_VAULT_TOKEN";
    /** Vault payment token type. */
    StorefrontPaymentTokenType["Vault"] = "VAULT";
})(StorefrontPaymentTokenType = exports.StorefrontPaymentTokenType || (exports.StorefrontPaymentTokenType = {}));
/** Decides the distribution of results. */
var StorefrontPredictiveSearchLimitScope;
(function (StorefrontPredictiveSearchLimitScope) {
    /** Return results up to limit across all types. */
    StorefrontPredictiveSearchLimitScope["All"] = "ALL";
    /** Return results up to limit per type. */
    StorefrontPredictiveSearchLimitScope["Each"] = "EACH";
})(StorefrontPredictiveSearchLimitScope = exports.StorefrontPredictiveSearchLimitScope || (exports.StorefrontPredictiveSearchLimitScope = {}));
/** The types of search items to perform predictive search on. */
var StorefrontPredictiveSearchType;
(function (StorefrontPredictiveSearchType) {
    /** Returns matching articles. */
    StorefrontPredictiveSearchType["Article"] = "ARTICLE";
    /** Returns matching collections. */
    StorefrontPredictiveSearchType["Collection"] = "COLLECTION";
    /** Returns matching pages. */
    StorefrontPredictiveSearchType["Page"] = "PAGE";
    /** Returns matching products. */
    StorefrontPredictiveSearchType["Product"] = "PRODUCT";
    /** Returns matching query strings. */
    StorefrontPredictiveSearchType["Query"] = "QUERY";
})(StorefrontPredictiveSearchType = exports.StorefrontPredictiveSearchType || (exports.StorefrontPredictiveSearchType = {}));
/** The set of valid sort keys for the ProductCollection query. */
var StorefrontProductCollectionSortKeys;
(function (StorefrontProductCollectionSortKeys) {
    /** Sort by the `best-selling` value. */
    StorefrontProductCollectionSortKeys["BestSelling"] = "BEST_SELLING";
    /** Sort by the `collection-default` value. */
    StorefrontProductCollectionSortKeys["CollectionDefault"] = "COLLECTION_DEFAULT";
    /** Sort by the `created` value. */
    StorefrontProductCollectionSortKeys["Created"] = "CREATED";
    /** Sort by the `id` value. */
    StorefrontProductCollectionSortKeys["Id"] = "ID";
    /** Sort by the `manual` value. */
    StorefrontProductCollectionSortKeys["Manual"] = "MANUAL";
    /** Sort by the `price` value. */
    StorefrontProductCollectionSortKeys["Price"] = "PRICE";
    /**
     * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
     * Don't use this sort key when no search query is specified.
     *
     */
    StorefrontProductCollectionSortKeys["Relevance"] = "RELEVANCE";
    /** Sort by the `title` value. */
    StorefrontProductCollectionSortKeys["Title"] = "TITLE";
})(StorefrontProductCollectionSortKeys = exports.StorefrontProductCollectionSortKeys || (exports.StorefrontProductCollectionSortKeys = {}));
/** The set of valid sort keys for the ProductImage query. */
var StorefrontProductImageSortKeys;
(function (StorefrontProductImageSortKeys) {
    /** Sort by the `created_at` value. */
    StorefrontProductImageSortKeys["CreatedAt"] = "CREATED_AT";
    /** Sort by the `id` value. */
    StorefrontProductImageSortKeys["Id"] = "ID";
    /** Sort by the `position` value. */
    StorefrontProductImageSortKeys["Position"] = "POSITION";
    /**
     * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
     * Don't use this sort key when no search query is specified.
     *
     */
    StorefrontProductImageSortKeys["Relevance"] = "RELEVANCE";
})(StorefrontProductImageSortKeys = exports.StorefrontProductImageSortKeys || (exports.StorefrontProductImageSortKeys = {}));
/** The set of valid sort keys for the ProductMedia query. */
var StorefrontProductMediaSortKeys;
(function (StorefrontProductMediaSortKeys) {
    /** Sort by the `id` value. */
    StorefrontProductMediaSortKeys["Id"] = "ID";
    /** Sort by the `position` value. */
    StorefrontProductMediaSortKeys["Position"] = "POSITION";
    /**
     * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
     * Don't use this sort key when no search query is specified.
     *
     */
    StorefrontProductMediaSortKeys["Relevance"] = "RELEVANCE";
})(StorefrontProductMediaSortKeys = exports.StorefrontProductMediaSortKeys || (exports.StorefrontProductMediaSortKeys = {}));
/**
 * The recommendation intent that is used to generate product recommendations.
 * You can use intent to generate product recommendations according to different strategies.
 *
 */
var StorefrontProductRecommendationIntent;
(function (StorefrontProductRecommendationIntent) {
    /** Offer customers products that are complementary to a product for which recommendations are to be fetched. An example is add-on products that display in a Pair it with section. */
    StorefrontProductRecommendationIntent["Complementary"] = "COMPLEMENTARY";
    /** Offer customers a mix of products that are similar or complementary to a product for which recommendations are to be fetched. An example is substitutable products that display in a You may also like section. */
    StorefrontProductRecommendationIntent["Related"] = "RELATED";
})(StorefrontProductRecommendationIntent = exports.StorefrontProductRecommendationIntent || (exports.StorefrontProductRecommendationIntent = {}));
/** The set of valid sort keys for the Product query. */
var StorefrontProductSortKeys;
(function (StorefrontProductSortKeys) {
    /** Sort by the `best_selling` value. */
    StorefrontProductSortKeys["BestSelling"] = "BEST_SELLING";
    /** Sort by the `created_at` value. */
    StorefrontProductSortKeys["CreatedAt"] = "CREATED_AT";
    /** Sort by the `id` value. */
    StorefrontProductSortKeys["Id"] = "ID";
    /** Sort by the `price` value. */
    StorefrontProductSortKeys["Price"] = "PRICE";
    /** Sort by the `product_type` value. */
    StorefrontProductSortKeys["ProductType"] = "PRODUCT_TYPE";
    /**
     * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
     * Don't use this sort key when no search query is specified.
     *
     */
    StorefrontProductSortKeys["Relevance"] = "RELEVANCE";
    /** Sort by the `title` value. */
    StorefrontProductSortKeys["Title"] = "TITLE";
    /** Sort by the `updated_at` value. */
    StorefrontProductSortKeys["UpdatedAt"] = "UPDATED_AT";
    /** Sort by the `vendor` value. */
    StorefrontProductSortKeys["Vendor"] = "VENDOR";
})(StorefrontProductSortKeys = exports.StorefrontProductSortKeys || (exports.StorefrontProductSortKeys = {}));
/** The set of valid sort keys for the ProductVariant query. */
var StorefrontProductVariantSortKeys;
(function (StorefrontProductVariantSortKeys) {
    /** Sort by the `id` value. */
    StorefrontProductVariantSortKeys["Id"] = "ID";
    /** Sort by the `position` value. */
    StorefrontProductVariantSortKeys["Position"] = "POSITION";
    /**
     * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
     * Don't use this sort key when no search query is specified.
     *
     */
    StorefrontProductVariantSortKeys["Relevance"] = "RELEVANCE";
    /** Sort by the `sku` value. */
    StorefrontProductVariantSortKeys["Sku"] = "SKU";
    /** Sort by the `title` value. */
    StorefrontProductVariantSortKeys["Title"] = "TITLE";
})(StorefrontProductVariantSortKeys = exports.StorefrontProductVariantSortKeys || (exports.StorefrontProductVariantSortKeys = {}));
/** Specifies whether to perform a partial word match on the last search term. */
var StorefrontSearchPrefixQueryType;
(function (StorefrontSearchPrefixQueryType) {
    /** Perform a partial word match on the last search term. */
    StorefrontSearchPrefixQueryType["Last"] = "LAST";
    /** Don't perform a partial word match on the last search term. */
    StorefrontSearchPrefixQueryType["None"] = "NONE";
})(StorefrontSearchPrefixQueryType = exports.StorefrontSearchPrefixQueryType || (exports.StorefrontSearchPrefixQueryType = {}));
/** The set of valid sort keys for the search query. */
var StorefrontSearchSortKeys;
(function (StorefrontSearchSortKeys) {
    /** Sort by the `price` value. */
    StorefrontSearchSortKeys["Price"] = "PRICE";
    /** Sort by relevance to the search terms. */
    StorefrontSearchSortKeys["Relevance"] = "RELEVANCE";
})(StorefrontSearchSortKeys = exports.StorefrontSearchSortKeys || (exports.StorefrontSearchSortKeys = {}));
/** The types of search items to perform search within. */
var StorefrontSearchType;
(function (StorefrontSearchType) {
    /** Returns matching articles. */
    StorefrontSearchType["Article"] = "ARTICLE";
    /** Returns matching pages. */
    StorefrontSearchType["Page"] = "PAGE";
    /** Returns matching products. */
    StorefrontSearchType["Product"] = "PRODUCT";
})(StorefrontSearchType = exports.StorefrontSearchType || (exports.StorefrontSearchType = {}));
/** Specifies whether to display results for unavailable products. */
var StorefrontSearchUnavailableProductsType;
(function (StorefrontSearchUnavailableProductsType) {
    /** Exclude unavailable products. */
    StorefrontSearchUnavailableProductsType["Hide"] = "HIDE";
    /** Show unavailable products after all other matching results. This is the default. */
    StorefrontSearchUnavailableProductsType["Last"] = "LAST";
    /** Show unavailable products in the order that they're found. */
    StorefrontSearchUnavailableProductsType["Show"] = "SHOW";
})(StorefrontSearchUnavailableProductsType = exports.StorefrontSearchUnavailableProductsType || (exports.StorefrontSearchUnavailableProductsType = {}));
/** Specifies the list of resource fields to search. */
var StorefrontSearchableField;
(function (StorefrontSearchableField) {
    /** Author of the page or article. */
    StorefrontSearchableField["Author"] = "AUTHOR";
    /** Body of the page or article or product description or collection description. */
    StorefrontSearchableField["Body"] = "BODY";
    /** Product type. */
    StorefrontSearchableField["ProductType"] = "PRODUCT_TYPE";
    /** Tag associated with the product or article. */
    StorefrontSearchableField["Tag"] = "TAG";
    /** Title of the page or article or product title or collection title. */
    StorefrontSearchableField["Title"] = "TITLE";
    /** Variant barcode. */
    StorefrontSearchableField["VariantsBarcode"] = "VARIANTS_BARCODE";
    /** Variant SKU. */
    StorefrontSearchableField["VariantsSku"] = "VARIANTS_SKU";
    /** Variant title. */
    StorefrontSearchableField["VariantsTitle"] = "VARIANTS_TITLE";
    /** Product vendor. */
    StorefrontSearchableField["Vendor"] = "VENDOR";
})(StorefrontSearchableField = exports.StorefrontSearchableField || (exports.StorefrontSearchableField = {}));
/** The checkout charge when the full amount isn't charged at checkout. */
var StorefrontSellingPlanCheckoutChargeType;
(function (StorefrontSellingPlanCheckoutChargeType) {
    /** The checkout charge is a percentage of the product or variant price. */
    StorefrontSellingPlanCheckoutChargeType["Percentage"] = "PERCENTAGE";
    /** The checkout charge is a fixed price amount. */
    StorefrontSellingPlanCheckoutChargeType["Price"] = "PRICE";
})(StorefrontSellingPlanCheckoutChargeType = exports.StorefrontSellingPlanCheckoutChargeType || (exports.StorefrontSellingPlanCheckoutChargeType = {}));
/** The code of the error that occurred during cart submit for completion. */
var StorefrontSubmissionErrorCode;
(function (StorefrontSubmissionErrorCode) {
    StorefrontSubmissionErrorCode["BuyerIdentityEmailIsInvalid"] = "BUYER_IDENTITY_EMAIL_IS_INVALID";
    StorefrontSubmissionErrorCode["BuyerIdentityEmailRequired"] = "BUYER_IDENTITY_EMAIL_REQUIRED";
    StorefrontSubmissionErrorCode["BuyerIdentityPhoneIsInvalid"] = "BUYER_IDENTITY_PHONE_IS_INVALID";
    StorefrontSubmissionErrorCode["DeliveryAddress1Invalid"] = "DELIVERY_ADDRESS1_INVALID";
    StorefrontSubmissionErrorCode["DeliveryAddress1Required"] = "DELIVERY_ADDRESS1_REQUIRED";
    StorefrontSubmissionErrorCode["DeliveryAddress1TooLong"] = "DELIVERY_ADDRESS1_TOO_LONG";
    StorefrontSubmissionErrorCode["DeliveryAddress2Invalid"] = "DELIVERY_ADDRESS2_INVALID";
    StorefrontSubmissionErrorCode["DeliveryAddress2Required"] = "DELIVERY_ADDRESS2_REQUIRED";
    StorefrontSubmissionErrorCode["DeliveryAddress2TooLong"] = "DELIVERY_ADDRESS2_TOO_LONG";
    StorefrontSubmissionErrorCode["DeliveryAddressRequired"] = "DELIVERY_ADDRESS_REQUIRED";
    StorefrontSubmissionErrorCode["DeliveryCityInvalid"] = "DELIVERY_CITY_INVALID";
    StorefrontSubmissionErrorCode["DeliveryCityRequired"] = "DELIVERY_CITY_REQUIRED";
    StorefrontSubmissionErrorCode["DeliveryCityTooLong"] = "DELIVERY_CITY_TOO_LONG";
    StorefrontSubmissionErrorCode["DeliveryCompanyInvalid"] = "DELIVERY_COMPANY_INVALID";
    StorefrontSubmissionErrorCode["DeliveryCompanyRequired"] = "DELIVERY_COMPANY_REQUIRED";
    StorefrontSubmissionErrorCode["DeliveryCompanyTooLong"] = "DELIVERY_COMPANY_TOO_LONG";
    StorefrontSubmissionErrorCode["DeliveryCountryRequired"] = "DELIVERY_COUNTRY_REQUIRED";
    StorefrontSubmissionErrorCode["DeliveryFirstNameInvalid"] = "DELIVERY_FIRST_NAME_INVALID";
    StorefrontSubmissionErrorCode["DeliveryFirstNameRequired"] = "DELIVERY_FIRST_NAME_REQUIRED";
    StorefrontSubmissionErrorCode["DeliveryFirstNameTooLong"] = "DELIVERY_FIRST_NAME_TOO_LONG";
    StorefrontSubmissionErrorCode["DeliveryInvalidPostalCodeForCountry"] = "DELIVERY_INVALID_POSTAL_CODE_FOR_COUNTRY";
    StorefrontSubmissionErrorCode["DeliveryInvalidPostalCodeForZone"] = "DELIVERY_INVALID_POSTAL_CODE_FOR_ZONE";
    StorefrontSubmissionErrorCode["DeliveryLastNameInvalid"] = "DELIVERY_LAST_NAME_INVALID";
    StorefrontSubmissionErrorCode["DeliveryLastNameRequired"] = "DELIVERY_LAST_NAME_REQUIRED";
    StorefrontSubmissionErrorCode["DeliveryLastNameTooLong"] = "DELIVERY_LAST_NAME_TOO_LONG";
    StorefrontSubmissionErrorCode["DeliveryNoDeliveryAvailable"] = "DELIVERY_NO_DELIVERY_AVAILABLE";
    StorefrontSubmissionErrorCode["DeliveryNoDeliveryAvailableForMerchandiseLine"] = "DELIVERY_NO_DELIVERY_AVAILABLE_FOR_MERCHANDISE_LINE";
    StorefrontSubmissionErrorCode["DeliveryOptionsPhoneNumberInvalid"] = "DELIVERY_OPTIONS_PHONE_NUMBER_INVALID";
    StorefrontSubmissionErrorCode["DeliveryOptionsPhoneNumberRequired"] = "DELIVERY_OPTIONS_PHONE_NUMBER_REQUIRED";
    StorefrontSubmissionErrorCode["DeliveryPhoneNumberInvalid"] = "DELIVERY_PHONE_NUMBER_INVALID";
    StorefrontSubmissionErrorCode["DeliveryPhoneNumberRequired"] = "DELIVERY_PHONE_NUMBER_REQUIRED";
    StorefrontSubmissionErrorCode["DeliveryPostalCodeInvalid"] = "DELIVERY_POSTAL_CODE_INVALID";
    StorefrontSubmissionErrorCode["DeliveryPostalCodeRequired"] = "DELIVERY_POSTAL_CODE_REQUIRED";
    StorefrontSubmissionErrorCode["DeliveryZoneNotFound"] = "DELIVERY_ZONE_NOT_FOUND";
    StorefrontSubmissionErrorCode["DeliveryZoneRequiredForCountry"] = "DELIVERY_ZONE_REQUIRED_FOR_COUNTRY";
    StorefrontSubmissionErrorCode["Error"] = "ERROR";
    StorefrontSubmissionErrorCode["MerchandiseLineLimitReached"] = "MERCHANDISE_LINE_LIMIT_REACHED";
    StorefrontSubmissionErrorCode["MerchandiseNotApplicable"] = "MERCHANDISE_NOT_APPLICABLE";
    StorefrontSubmissionErrorCode["MerchandiseNotEnoughStockAvailable"] = "MERCHANDISE_NOT_ENOUGH_STOCK_AVAILABLE";
    StorefrontSubmissionErrorCode["MerchandiseOutOfStock"] = "MERCHANDISE_OUT_OF_STOCK";
    StorefrontSubmissionErrorCode["MerchandiseProductNotPublished"] = "MERCHANDISE_PRODUCT_NOT_PUBLISHED";
    StorefrontSubmissionErrorCode["NoDeliveryGroupSelected"] = "NO_DELIVERY_GROUP_SELECTED";
    StorefrontSubmissionErrorCode["PaymentsAddress1Invalid"] = "PAYMENTS_ADDRESS1_INVALID";
    StorefrontSubmissionErrorCode["PaymentsAddress1Required"] = "PAYMENTS_ADDRESS1_REQUIRED";
    StorefrontSubmissionErrorCode["PaymentsAddress1TooLong"] = "PAYMENTS_ADDRESS1_TOO_LONG";
    StorefrontSubmissionErrorCode["PaymentsAddress2Invalid"] = "PAYMENTS_ADDRESS2_INVALID";
    StorefrontSubmissionErrorCode["PaymentsAddress2Required"] = "PAYMENTS_ADDRESS2_REQUIRED";
    StorefrontSubmissionErrorCode["PaymentsAddress2TooLong"] = "PAYMENTS_ADDRESS2_TOO_LONG";
    StorefrontSubmissionErrorCode["PaymentsBillingAddressZoneNotFound"] = "PAYMENTS_BILLING_ADDRESS_ZONE_NOT_FOUND";
    StorefrontSubmissionErrorCode["PaymentsBillingAddressZoneRequiredForCountry"] = "PAYMENTS_BILLING_ADDRESS_ZONE_REQUIRED_FOR_COUNTRY";
    StorefrontSubmissionErrorCode["PaymentsCityInvalid"] = "PAYMENTS_CITY_INVALID";
    StorefrontSubmissionErrorCode["PaymentsCityRequired"] = "PAYMENTS_CITY_REQUIRED";
    StorefrontSubmissionErrorCode["PaymentsCityTooLong"] = "PAYMENTS_CITY_TOO_LONG";
    StorefrontSubmissionErrorCode["PaymentsCompanyInvalid"] = "PAYMENTS_COMPANY_INVALID";
    StorefrontSubmissionErrorCode["PaymentsCompanyRequired"] = "PAYMENTS_COMPANY_REQUIRED";
    StorefrontSubmissionErrorCode["PaymentsCompanyTooLong"] = "PAYMENTS_COMPANY_TOO_LONG";
    StorefrontSubmissionErrorCode["PaymentsCountryRequired"] = "PAYMENTS_COUNTRY_REQUIRED";
    StorefrontSubmissionErrorCode["PaymentsCreditCardBaseExpired"] = "PAYMENTS_CREDIT_CARD_BASE_EXPIRED";
    StorefrontSubmissionErrorCode["PaymentsCreditCardBaseGatewayNotSupported"] = "PAYMENTS_CREDIT_CARD_BASE_GATEWAY_NOT_SUPPORTED";
    StorefrontSubmissionErrorCode["PaymentsCreditCardBaseInvalidStartDateOrIssueNumberForDebit"] = "PAYMENTS_CREDIT_CARD_BASE_INVALID_START_DATE_OR_ISSUE_NUMBER_FOR_DEBIT";
    StorefrontSubmissionErrorCode["PaymentsCreditCardBrandNotSupported"] = "PAYMENTS_CREDIT_CARD_BRAND_NOT_SUPPORTED";
    StorefrontSubmissionErrorCode["PaymentsCreditCardFirstNameBlank"] = "PAYMENTS_CREDIT_CARD_FIRST_NAME_BLANK";
    StorefrontSubmissionErrorCode["PaymentsCreditCardGeneric"] = "PAYMENTS_CREDIT_CARD_GENERIC";
    StorefrontSubmissionErrorCode["PaymentsCreditCardLastNameBlank"] = "PAYMENTS_CREDIT_CARD_LAST_NAME_BLANK";
    StorefrontSubmissionErrorCode["PaymentsCreditCardMonthInclusion"] = "PAYMENTS_CREDIT_CARD_MONTH_INCLUSION";
    StorefrontSubmissionErrorCode["PaymentsCreditCardNameInvalid"] = "PAYMENTS_CREDIT_CARD_NAME_INVALID";
    StorefrontSubmissionErrorCode["PaymentsCreditCardNumberInvalid"] = "PAYMENTS_CREDIT_CARD_NUMBER_INVALID";
    StorefrontSubmissionErrorCode["PaymentsCreditCardNumberInvalidFormat"] = "PAYMENTS_CREDIT_CARD_NUMBER_INVALID_FORMAT";
    StorefrontSubmissionErrorCode["PaymentsCreditCardSessionId"] = "PAYMENTS_CREDIT_CARD_SESSION_ID";
    StorefrontSubmissionErrorCode["PaymentsCreditCardVerificationValueBlank"] = "PAYMENTS_CREDIT_CARD_VERIFICATION_VALUE_BLANK";
    StorefrontSubmissionErrorCode["PaymentsCreditCardVerificationValueInvalidForCardType"] = "PAYMENTS_CREDIT_CARD_VERIFICATION_VALUE_INVALID_FOR_CARD_TYPE";
    StorefrontSubmissionErrorCode["PaymentsCreditCardYearExpired"] = "PAYMENTS_CREDIT_CARD_YEAR_EXPIRED";
    StorefrontSubmissionErrorCode["PaymentsCreditCardYearInvalidExpiryYear"] = "PAYMENTS_CREDIT_CARD_YEAR_INVALID_EXPIRY_YEAR";
    StorefrontSubmissionErrorCode["PaymentsFirstNameInvalid"] = "PAYMENTS_FIRST_NAME_INVALID";
    StorefrontSubmissionErrorCode["PaymentsFirstNameRequired"] = "PAYMENTS_FIRST_NAME_REQUIRED";
    StorefrontSubmissionErrorCode["PaymentsFirstNameTooLong"] = "PAYMENTS_FIRST_NAME_TOO_LONG";
    StorefrontSubmissionErrorCode["PaymentsInvalidPostalCodeForCountry"] = "PAYMENTS_INVALID_POSTAL_CODE_FOR_COUNTRY";
    StorefrontSubmissionErrorCode["PaymentsInvalidPostalCodeForZone"] = "PAYMENTS_INVALID_POSTAL_CODE_FOR_ZONE";
    StorefrontSubmissionErrorCode["PaymentsLastNameInvalid"] = "PAYMENTS_LAST_NAME_INVALID";
    StorefrontSubmissionErrorCode["PaymentsLastNameRequired"] = "PAYMENTS_LAST_NAME_REQUIRED";
    StorefrontSubmissionErrorCode["PaymentsLastNameTooLong"] = "PAYMENTS_LAST_NAME_TOO_LONG";
    StorefrontSubmissionErrorCode["PaymentsMethodRequired"] = "PAYMENTS_METHOD_REQUIRED";
    StorefrontSubmissionErrorCode["PaymentsMethodUnavailable"] = "PAYMENTS_METHOD_UNAVAILABLE";
    StorefrontSubmissionErrorCode["PaymentsPhoneNumberInvalid"] = "PAYMENTS_PHONE_NUMBER_INVALID";
    StorefrontSubmissionErrorCode["PaymentsPhoneNumberRequired"] = "PAYMENTS_PHONE_NUMBER_REQUIRED";
    StorefrontSubmissionErrorCode["PaymentsPostalCodeInvalid"] = "PAYMENTS_POSTAL_CODE_INVALID";
    StorefrontSubmissionErrorCode["PaymentsPostalCodeRequired"] = "PAYMENTS_POSTAL_CODE_REQUIRED";
    StorefrontSubmissionErrorCode["PaymentsShopifyPaymentsRequired"] = "PAYMENTS_SHOPIFY_PAYMENTS_REQUIRED";
    StorefrontSubmissionErrorCode["PaymentsUnacceptablePaymentAmount"] = "PAYMENTS_UNACCEPTABLE_PAYMENT_AMOUNT";
    StorefrontSubmissionErrorCode["PaymentsWalletContentMissing"] = "PAYMENTS_WALLET_CONTENT_MISSING";
    StorefrontSubmissionErrorCode["TaxesDeliveryGroupIdNotFound"] = "TAXES_DELIVERY_GROUP_ID_NOT_FOUND";
    StorefrontSubmissionErrorCode["TaxesLineIdNotFound"] = "TAXES_LINE_ID_NOT_FOUND";
    StorefrontSubmissionErrorCode["TaxesMustBeDefined"] = "TAXES_MUST_BE_DEFINED";
})(StorefrontSubmissionErrorCode = exports.StorefrontSubmissionErrorCode || (exports.StorefrontSubmissionErrorCode = {}));
/** The different kinds of order transactions. */
var StorefrontTransactionKind;
(function (StorefrontTransactionKind) {
    /**
     * An amount reserved against the cardholder's funding source.
     * Money does not change hands until the authorization is captured.
     *
     */
    StorefrontTransactionKind["Authorization"] = "AUTHORIZATION";
    /** A transfer of the money that was reserved during the authorization stage. */
    StorefrontTransactionKind["Capture"] = "CAPTURE";
    /** Money returned to the customer when they have paid too much. */
    StorefrontTransactionKind["Change"] = "CHANGE";
    /** An authorization for a payment taken with an EMV credit card reader. */
    StorefrontTransactionKind["EmvAuthorization"] = "EMV_AUTHORIZATION";
    /** An authorization and capture performed together in a single step. */
    StorefrontTransactionKind["Sale"] = "SALE";
})(StorefrontTransactionKind = exports.StorefrontTransactionKind || (exports.StorefrontTransactionKind = {}));
/** Transaction statuses describe the status of a transaction. */
var StorefrontTransactionStatus;
(function (StorefrontTransactionStatus) {
    /** There was an error while processing the transaction. */
    StorefrontTransactionStatus["Error"] = "ERROR";
    /** The transaction failed. */
    StorefrontTransactionStatus["Failure"] = "FAILURE";
    /** The transaction is pending. */
    StorefrontTransactionStatus["Pending"] = "PENDING";
    /** The transaction succeeded. */
    StorefrontTransactionStatus["Success"] = "SUCCESS";
})(StorefrontTransactionStatus = exports.StorefrontTransactionStatus || (exports.StorefrontTransactionStatus = {}));
/** The accepted types of unit of measurement. */
var StorefrontUnitPriceMeasurementMeasuredType;
(function (StorefrontUnitPriceMeasurementMeasuredType) {
    /** Unit of measurements representing areas. */
    StorefrontUnitPriceMeasurementMeasuredType["Area"] = "AREA";
    /** Unit of measurements representing lengths. */
    StorefrontUnitPriceMeasurementMeasuredType["Length"] = "LENGTH";
    /** Unit of measurements representing volumes. */
    StorefrontUnitPriceMeasurementMeasuredType["Volume"] = "VOLUME";
    /** Unit of measurements representing weights. */
    StorefrontUnitPriceMeasurementMeasuredType["Weight"] = "WEIGHT";
})(StorefrontUnitPriceMeasurementMeasuredType = exports.StorefrontUnitPriceMeasurementMeasuredType || (exports.StorefrontUnitPriceMeasurementMeasuredType = {}));
/** The valid units of measurement for a unit price measurement. */
var StorefrontUnitPriceMeasurementMeasuredUnit;
(function (StorefrontUnitPriceMeasurementMeasuredUnit) {
    /** 100 centiliters equals 1 liter. */
    StorefrontUnitPriceMeasurementMeasuredUnit["Cl"] = "CL";
    /** 100 centimeters equals 1 meter. */
    StorefrontUnitPriceMeasurementMeasuredUnit["Cm"] = "CM";
    /** Metric system unit of weight. */
    StorefrontUnitPriceMeasurementMeasuredUnit["G"] = "G";
    /** 1 kilogram equals 1000 grams. */
    StorefrontUnitPriceMeasurementMeasuredUnit["Kg"] = "KG";
    /** Metric system unit of volume. */
    StorefrontUnitPriceMeasurementMeasuredUnit["L"] = "L";
    /** Metric system unit of length. */
    StorefrontUnitPriceMeasurementMeasuredUnit["M"] = "M";
    /** Metric system unit of area. */
    StorefrontUnitPriceMeasurementMeasuredUnit["M2"] = "M2";
    /** 1 cubic meter equals 1000 liters. */
    StorefrontUnitPriceMeasurementMeasuredUnit["M3"] = "M3";
    /** 1000 milligrams equals 1 gram. */
    StorefrontUnitPriceMeasurementMeasuredUnit["Mg"] = "MG";
    /** 1000 milliliters equals 1 liter. */
    StorefrontUnitPriceMeasurementMeasuredUnit["Ml"] = "ML";
    /** 1000 millimeters equals 1 meter. */
    StorefrontUnitPriceMeasurementMeasuredUnit["Mm"] = "MM";
})(StorefrontUnitPriceMeasurementMeasuredUnit = exports.StorefrontUnitPriceMeasurementMeasuredUnit || (exports.StorefrontUnitPriceMeasurementMeasuredUnit = {}));
/** Systems of weights and measures. */
var StorefrontUnitSystem;
(function (StorefrontUnitSystem) {
    /** Imperial system of weights and measures. */
    StorefrontUnitSystem["ImperialSystem"] = "IMPERIAL_SYSTEM";
    /** Metric system of weights and measures. */
    StorefrontUnitSystem["MetricSystem"] = "METRIC_SYSTEM";
})(StorefrontUnitSystem = exports.StorefrontUnitSystem || (exports.StorefrontUnitSystem = {}));
/** Units of measurement for weight. */
var StorefrontWeightUnit;
(function (StorefrontWeightUnit) {
    /** Metric system unit of mass. */
    StorefrontWeightUnit["Grams"] = "GRAMS";
    /** 1 kilogram equals 1000 grams. */
    StorefrontWeightUnit["Kilograms"] = "KILOGRAMS";
    /** Imperial system unit of mass. */
    StorefrontWeightUnit["Ounces"] = "OUNCES";
    /** 1 pound equals 16 ounces. */
    StorefrontWeightUnit["Pounds"] = "POUNDS";
})(StorefrontWeightUnit = exports.StorefrontWeightUnit || (exports.StorefrontWeightUnit = {}));
exports.MapmakerAuthenticatedAccountFragmentDoc = (0, client_1.gql) `
    fragment MapmakerAuthenticatedAccount on MapmakerAuthenticatedAccount {
  email
  stickerTokenBalance
}
    `;
exports.MapmakerAccountFragmentDoc = (0, client_1.gql) `
    fragment MapmakerAccount on MapmakerAccount {
  id
  mapmakerFileCount
  ... on MapmakerAuthenticatedAccount {
    ...MapmakerAuthenticatedAccount
  }
}
    ${exports.MapmakerAuthenticatedAccountFragmentDoc}`;
exports.MapmakerFileBaseFragmentDoc = (0, client_1.gql) `
    fragment MapmakerFileBase on MapmakerFile {
  id
  name
  ownerId
  designId
  businessId
  openingsWithImages
  createdAt
  updatedAt
  previewImageUrl
  accessPolicy
  viewerPolicy
  deleted
  outputType
  outputScale
}
    `;
exports.MapmakerDesignLiteFragmentDoc = (0, client_1.gql) `
    fragment MapmakerDesignLite on MapmakerDesign {
  id
  businessId
  name
  thumbnailUrl
  width
  height
  outputOptions {
    type
    name
    scale
    inputs
  }
  regionType
  regionTypePlural
  regionCount
  keywords
}
    `;
exports.MapmakerFileLiteFragmentDoc = (0, client_1.gql) `
    fragment MapmakerFileLite on MapmakerFile {
  ...MapmakerFileBase
  design {
    ...MapmakerDesignLite
  }
}
    ${exports.MapmakerFileBaseFragmentDoc}
${exports.MapmakerDesignLiteFragmentDoc}`;
exports.MapmakerFileAccessFragmentDoc = (0, client_1.gql) `
    fragment MapmakerFileAccess on MapmakerFileAccess {
  id
  fileId
  granteeId
  granteeEmail
  granteeHasAccount
  role
}
    `;
exports.OpeningSuggestionFragmentDoc = (0, client_1.gql) `
    fragment OpeningSuggestion on OpeningSuggestion {
  id
  fileId
  fileOwnerId
  openingId
  suggesterId
  status
  submittedAt
  name
  note
  input
}
    `;
exports.MapmakerDesignHeavyFragmentDoc = (0, client_1.gql) `
    fragment MapmakerDesignHeavy on MapmakerDesign {
  ...MapmakerDesignLite
  features
}
    ${exports.MapmakerDesignLiteFragmentDoc}`;
exports.MapmakerFileHeavyFragmentDoc = (0, client_1.gql) `
    fragment MapmakerFileHeavy on MapmakerFile {
  ...MapmakerFileLite
  inputs
  fileAccesses {
    ...MapmakerFileAccess
  }
  openingSuggestions {
    ...OpeningSuggestion
  }
  design {
    ...MapmakerDesignHeavy
  }
}
    ${exports.MapmakerFileLiteFragmentDoc}
${exports.MapmakerFileAccessFragmentDoc}
${exports.OpeningSuggestionFragmentDoc}
${exports.MapmakerDesignHeavyFragmentDoc}`;
exports.StickerOrderItemFragmentDoc = (0, client_1.gql) `
    fragment StickerOrderItem on StickerOrderItem {
  openingId
  sizeClass
  quantity
  quantityWithMoney
  quantityWithTokens
  scale
  render {
    url
  }
}
    `;
exports.StickerOrderFragmentDoc = (0, client_1.gql) `
    fragment StickerOrder on StickerOrder {
  id
  businessId
  createdAt
  outputType
  stickers {
    ...StickerOrderItem
  }
}
    ${exports.StickerOrderItemFragmentDoc}`;
exports.StickerVariantForPricingFragmentDoc = (0, client_1.gql) `
    fragment StickerVariantForPricing on StorefrontProductVariant {
  id
  title
  priceV2 {
    currencyCode
    amount
  }
  stickerSizeClass: metafield(namespace: "mapmaker", key: "sticker.sizeClass") {
    value
  }
  stickerOutputType: metafield(namespace: "mapmaker", key: "sticker.outputType") {
    value
  }
  stickerTokens: metafield(namespace: "mapmaker", key: "sticker.tokens") {
    value
  }
  tokenRedemptionVariant: metafield(
    namespace: "mapmaker"
    key: "sticker.tokenRedemptionVariant"
  ) {
    value
  }
}
    `;
exports.StorefrontCheckoutLightFragmentDoc = (0, client_1.gql) `
    fragment StorefrontCheckoutLight on StorefrontCheckout {
  id
  completedAt
  lineItems(first: 100) {
    edges {
      node {
        id
        quantity
      }
    }
  }
}
    `;
exports.BlogPostCardFragmentDoc = (0, client_1.gql) `
    fragment BlogPostCard on Post {
  _id
  title
  slug {
    current
  }
  author {
    name
    slug {
      current
    }
  }
  mainImage {
    asset {
      _id
      url
      path
      assetId
      extension
    }
  }
  publishedAt
}
    `;
exports.BlogPostFragmentDoc = (0, client_1.gql) `
    fragment BlogPost on Post {
  _id
  title
  slug {
    current
  }
  author {
    name
    slug {
      current
    }
  }
  mainImage {
    asset {
      _id
      url
      path
      assetId
      extension
    }
  }
  publishedAt
  bodyRaw
}
    `;
exports.StorefrontDiscountApplicationFragmentDoc = (0, client_1.gql) `
    fragment StorefrontDiscountApplication on StorefrontDiscountApplication {
  targetSelection
  targetType
  allocationMethod
  value {
    ... on StorefrontMoneyV2 {
      amount
      currencyCode
    }
    ... on StorefrontPricingPercentageValue {
      percentage
    }
  }
  ... on StorefrontAutomaticDiscountApplication {
    title
  }
  ... on StorefrontDiscountCodeApplication {
    code
    applicable
  }
}
    `;
exports.StorefrontDiscountAllocationFragmentDoc = (0, client_1.gql) `
    fragment StorefrontDiscountAllocation on StorefrontDiscountAllocation {
  allocatedAmount {
    amount
    currencyCode
  }
  discountApplication {
    ...StorefrontDiscountApplication
  }
}
    ${exports.StorefrontDiscountApplicationFragmentDoc}`;
exports.StorefrontCheckoutLineItemHeavyFragmentDoc = (0, client_1.gql) `
    fragment StorefrontCheckoutLineItemHeavy on StorefrontCheckoutLineItem {
  id
  title
  quantity
  unitPrice {
    amount
    currencyCode
  }
  customAttributes {
    key
    value
  }
  discountAllocations {
    ...StorefrontDiscountAllocation
  }
  variant {
    id
    title
    sku
    priceV2 {
      amount
      currencyCode
    }
    selectedOptions {
      name
      value
    }
    image {
      originalSrc
      transformedSrc(maxWidth: 512, crop: CENTER)
    }
    product {
      id
      handle
      tblProductType: metafield(namespace: "tbl", key: "productType") {
        key
        value
      }
    }
  }
}
    ${exports.StorefrontDiscountAllocationFragmentDoc}`;
exports.StorefrontCheckoutHeavyFragmentDoc = (0, client_1.gql) `
    fragment StorefrontCheckoutHeavy on StorefrontCheckout {
  id
  completedAt
  webUrl
  totalPrice {
    amount
    currencyCode
  }
  totalTax {
    amount
    currencyCode
  }
  subtotalPriceV2 {
    amount
    currencyCode
  }
  totalPriceV2 {
    amount
    currencyCode
  }
  note
  requiresShipping
  lineItemsSubtotalPrice {
    amount
    currencyCode
  }
  discountApplications(first: 100) {
    edges {
      node {
        ...StorefrontDiscountApplication
      }
    }
  }
  lineItems(first: 100) {
    edges {
      node {
        ...StorefrontCheckoutLineItemHeavy
      }
    }
  }
}
    ${exports.StorefrontDiscountApplicationFragmentDoc}
${exports.StorefrontCheckoutLineItemHeavyFragmentDoc}`;
exports.StickerOrderForLineItemFragmentDoc = (0, client_1.gql) `
    fragment StickerOrderForLineItem on StickerOrder {
  id
  outputType
  stickers {
    openingId
    quantity
    render {
      url
    }
  }
  file {
    id
    backupVersion
    name
    outputType
    outputScale
    design {
      id
      outputOptions {
        type
        name
        scale
      }
    }
  }
}
    `;
exports.NavigationLinkTargetFragmentDoc = (0, client_1.gql) `
    fragment NavigationLinkTarget on Page {
  _id
  title
  slug {
    current
  }
}
    `;
exports.NavigationLinkFragmentDoc = (0, client_1.gql) `
    fragment NavigationLink on NavigationLink {
  _key
  title
  hidden
  target {
    ...NavigationLinkTarget
  }
  children {
    title
    hidden
    target {
      ...NavigationLinkTarget
    }
    children {
      title
      hidden
      target {
        ...NavigationLinkTarget
      }
    }
  }
}
    ${exports.NavigationLinkTargetFragmentDoc}`;
exports.NavigationFragmentDoc = (0, client_1.gql) `
    fragment Navigation on Navigation {
  _id
  title
  children {
    ...NavigationLink
  }
}
    ${exports.NavigationLinkFragmentDoc}`;
exports.PageFragmentDoc = (0, client_1.gql) `
    fragment Page on Page {
  _id
  title
  slug {
    current
  }
  contentRaw
}
    `;
exports.TrackingInfoFragmentDoc = (0, client_1.gql) `
    fragment TrackingInfo on TrackingInfo {
  company
  number
  url
}
    `;
exports.FulfillmentFragmentDoc = (0, client_1.gql) `
    fragment Fulfillment on Fulfillment {
  id
  createdAt
  deliveredAt
  trackingInfo {
    ...TrackingInfo
  }
}
    ${exports.TrackingInfoFragmentDoc}`;
exports.OrderItemDetailsFragmentDoc = (0, client_1.gql) `
    fragment OrderItemDetails on OrderItem {
  id
  name
  attributes
  originalUnitPrice
  discountedUnitPrice
  quantity
  handle
  description
  image {
    url
    altText
  }
  ... on MapLineItem {
    blueprintId
  }
  ... on StickerLineItem {
    stickerOrderId
    tokensUsed
  }
  ... on StickerTokenLineItem {
    numTokens
  }
}
    `;
exports.RefundFragmentDoc = (0, client_1.gql) `
    fragment Refund on Refund {
  id
  createdAt
  totalRefunded
}
    `;
exports.OrderDetailsFragmentDoc = (0, client_1.gql) `
    fragment OrderDetails on Order {
  id
  number
  createdAt
  cancelledAt
  subtotal
  totalShipping
  totalTax
  total
  billingAddressMatchesShippingAddress
  billingAddressFormatted
  shippingAddressFormatted
  note
  fulfillments {
    ...Fulfillment
  }
  items {
    ...OrderItemDetails
  }
  refunds {
    ...Refund
  }
}
    ${exports.FulfillmentFragmentDoc}
${exports.OrderItemDetailsFragmentDoc}
${exports.RefundFragmentDoc}`;
exports.MapLineItemFragmentDoc = (0, client_1.gql) `
    fragment MapLineItem on OrderItem {
  ... on MapLineItem {
    blueprintId
  }
}
    `;
exports.OrderItemLightFragmentDoc = (0, client_1.gql) `
    fragment OrderItemLight on OrderItem {
  id
  name
  image {
    url
    altText
  }
  ...MapLineItem
}
    ${exports.MapLineItemFragmentDoc}`;
exports.OrderLightFragmentDoc = (0, client_1.gql) `
    fragment OrderLight on Order {
  id
  number
  createdAt
  cancelledAt
  subtotal
  totalShipping
  totalTax
  total
  shippingAddressFormatted
  items {
    ...OrderItemLight
  }
}
    ${exports.OrderItemLightFragmentDoc}`;
exports.StickerOrderForStickerLineItemFragmentDoc = (0, client_1.gql) `
    fragment StickerOrderForStickerLineItem on StickerOrder {
  id
  outputType
  stickers {
    openingId
    quantity
    render {
      url
    }
  }
  file {
    id
    backupVersion
    name
  }
}
    `;
exports.StickerOfferItemFragmentDoc = (0, client_1.gql) `
    fragment StickerOfferItem on StickerOfferItem {
  openingId
  sizeClass
  render {
    url
  }
}
    `;
exports.StickerOfferFragmentDoc = (0, client_1.gql) `
    fragment StickerOffer on StickerOffer {
  stickers {
    ...StickerOfferItem
  }
}
    ${exports.StickerOfferItemFragmentDoc}`;
exports.WalgreensStoreFragmentDoc = (0, client_1.gql) `
    fragment WalgreensStore on WalgreensStore {
  storeNum
  promiseTime
  zip
  city
  state
  street
  phone
  distance
  distanceUnit
  openTime
  closeTime
  timeZone
  tax
}
    `;
exports.StorefrontProductImageFragmentDoc = (0, client_1.gql) `
    fragment StorefrontProductImage on StorefrontImage {
  id
  altText
  tinySrc: transformedSrc(maxWidth: 256)
  mediumSrc: transformedSrc(maxWidth: 1024)
  largeSrc: transformedSrc(maxWidth: 2048)
}
    `;
exports.StorefrontProductPageVariantFragmentDoc = (0, client_1.gql) `
    fragment StorefrontProductPageVariant on StorefrontProductVariant {
  id
  sku
  title
  priceV2 {
    amount
    currencyCode
  }
  availableForSale
  image {
    ...StorefrontProductImage
  }
  selectedOptions {
    name
    value
  }
  personalizationType: metafield(
    namespace: "photomaps"
    key: "personalizationType"
  ) {
    key
    value
  }
  mapmakerBlueprintId: metafield(namespace: "mapmaker", key: "blueprintId") {
    key
    value
  }
  mapmakerBackground: metafield(namespace: "mapmaker", key: "background") {
    key
    value
  }
  mapmakerOutputType: metafield(namespace: "mapmaker", key: "outputType") {
    key
    value
  }
  mapmakerOutputScale: metafield(namespace: "mapmaker", key: "outputScale") {
    key
    value
  }
  mapmakerDefaultInputs: metafield(namespace: "mapmaker", key: "defaultInputs") {
    key
    value
  }
}
    ${exports.StorefrontProductImageFragmentDoc}`;
exports.StorefrontProductPageProductFragmentDoc = (0, client_1.gql) `
    fragment StorefrontProductPageProduct on StorefrontProduct {
  id
  title
  descriptionHtml
  handle
  tags
  priceRange {
    maxVariantPrice {
      amount
      currencyCode
    }
    minVariantPrice {
      amount
      currencyCode
    }
  }
  options {
    id
    name
    values
  }
  images(first: 30) {
    edges {
      node {
        ...StorefrontProductImage
      }
    }
  }
  variants(first: 100) {
    edges {
      node {
        ...StorefrontProductPageVariant
      }
    }
  }
  hideQuantity: metafield(namespace: "photomaps", key: "hideQuantity") {
    key
    value
  }
  personalizationType: metafield(
    namespace: "photomaps"
    key: "personalizationType"
  ) {
    key
    value
  }
  freeStickerTokens: metafield(namespace: "photomaps", key: "freeStickerTokens") {
    key
    value
  }
  mapmakerBlueprintId: metafield(namespace: "mapmaker", key: "blueprintId") {
    key
    value
  }
  mapmakerBackground: metafield(namespace: "mapmaker", key: "background") {
    key
    value
  }
  mapmakerOutputType: metafield(namespace: "mapmaker", key: "outputType") {
    key
    value
  }
  mapmakerOutputScale: metafield(namespace: "mapmaker", key: "outputScale") {
    key
    value
  }
  mapmakerDefaultInputs: metafield(namespace: "mapmaker", key: "defaultInputs") {
    key
    value
  }
}
    ${exports.StorefrontProductImageFragmentDoc}
${exports.StorefrontProductPageVariantFragmentDoc}`;
exports.StickerTokenVariantFragmentDoc = (0, client_1.gql) `
    fragment StickerTokenVariant on StorefrontProductVariant {
  id
  sku
  title
  priceV2 {
    amount
    currencyCode
  }
  selectedOptions {
    name
    value
  }
}
    `;
exports.StickerTokenProductFragmentDoc = (0, client_1.gql) `
    fragment StickerTokenProduct on StorefrontProduct {
  id
  variants(first: 100) {
    edges {
      node {
        ...StickerTokenVariant
      }
    }
  }
}
    ${exports.StickerTokenVariantFragmentDoc}`;
exports.StickerOrderForSandboxFragmentDoc = (0, client_1.gql) `
    fragment StickerOrderForSandbox on StickerOrder {
  id
  businessId
  createdAt
  outputType
  stickers {
    openingId
    sizeClass
    quantity
    quantityWithMoney
    quantityWithTokens
    scale
    render {
      url
    }
  }
  file {
    id
    inputs
    design {
      id
      businessId
      height
      width
      features
    }
  }
}
    `;
exports.RenderableDesignFragmentDoc = (0, client_1.gql) `
    fragment RenderableDesign on MapmakerDesign {
  id
  businessId
  name
  width
  height
  regionType
  regionTypePlural
  regionCount
  features
}
    `;
exports.RenderableFileFragmentDoc = (0, client_1.gql) `
    fragment RenderableFile on MapmakerFile {
  id
  updatedAt
  name
  inputs
  design {
    ...RenderableDesign
  }
}
    ${exports.RenderableDesignFragmentDoc}`;
exports.RenderableOpeningSuggestionFragmentDoc = (0, client_1.gql) `
    fragment RenderableOpeningSuggestion on OpeningSuggestion {
  id
  fileId
  openingId
  input
}
    `;
exports.PresignedPostFragmentDoc = (0, client_1.gql) `
    fragment PresignedPost on PresignedPost {
  url
  fields
  expires
}
    `;
exports.GetAccountDocument = (0, client_1.gql) `
    query getAccount {
  account {
    ...MapmakerAccount
  }
}
    ${exports.MapmakerAccountFragmentDoc}`;
/**
 * __useGetAccountQuery__
 *
 * To run a query within a React component, call `useGetAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountQuery({
 *   variables: {
 *   },
 * });
 */
function useGetAccountQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.GetAccountDocument, options);
}
exports.useGetAccountQuery = useGetAccountQuery;
function useGetAccountLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.GetAccountDocument, options);
}
exports.useGetAccountLazyQuery = useGetAccountLazyQuery;
exports.GetDesignDocument = (0, client_1.gql) `
    query getDesign($id: String!) {
  design: mapmakerDesign(id: $id) {
    ...MapmakerDesignHeavy
  }
}
    ${exports.MapmakerDesignHeavyFragmentDoc}`;
/**
 * __useGetDesignQuery__
 *
 * To run a query within a React component, call `useGetDesignQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDesignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDesignQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
function useGetDesignQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.GetDesignDocument, options);
}
exports.useGetDesignQuery = useGetDesignQuery;
function useGetDesignLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.GetDesignDocument, options);
}
exports.useGetDesignLazyQuery = useGetDesignLazyQuery;
exports.GetFileWithDesignDocument = (0, client_1.gql) `
    query getFileWithDesign($id: String!) {
  file: mapmakerFile(id: $id) {
    ...MapmakerFileHeavy
  }
}
    ${exports.MapmakerFileHeavyFragmentDoc}`;
/**
 * __useGetFileWithDesignQuery__
 *
 * To run a query within a React component, call `useGetFileWithDesignQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFileWithDesignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFileWithDesignQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
function useGetFileWithDesignQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.GetFileWithDesignDocument, options);
}
exports.useGetFileWithDesignQuery = useGetFileWithDesignQuery;
function useGetFileWithDesignLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.GetFileWithDesignDocument, options);
}
exports.useGetFileWithDesignLazyQuery = useGetFileWithDesignLazyQuery;
exports.CreateFileDocument = (0, client_1.gql) `
    mutation createFile($input: CreateMapmakerFileInput!) {
  createMapmakerFile(input: $input) {
    file {
      ...MapmakerFileHeavy
    }
  }
}
    ${exports.MapmakerFileHeavyFragmentDoc}`;
/**
 * __useCreateFileMutation__
 *
 * To run a mutation, you first call `useCreateFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFileMutation, { data, loading, error }] = useCreateFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
function useCreateFileMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(exports.CreateFileDocument, options);
}
exports.useCreateFileMutation = useCreateFileMutation;
exports.UpdateFileDocument = (0, client_1.gql) `
    mutation updateFile($input: UpdateMapmakerFileInput!) {
  updateMapmakerFile(input: $input) {
    file {
      ...MapmakerFileLite
    }
  }
}
    ${exports.MapmakerFileLiteFragmentDoc}`;
/**
 * __useUpdateFileMutation__
 *
 * To run a mutation, you first call `useUpdateFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFileMutation, { data, loading, error }] = useUpdateFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
function useUpdateFileMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(exports.UpdateFileDocument, options);
}
exports.useUpdateFileMutation = useUpdateFileMutation;
exports.UpdateFileHeavyDocument = (0, client_1.gql) `
    mutation updateFileHeavy($input: UpdateMapmakerFileInput!) {
  updateMapmakerFile(input: $input) {
    file {
      ...MapmakerFileHeavy
    }
  }
}
    ${exports.MapmakerFileHeavyFragmentDoc}`;
/**
 * __useUpdateFileHeavyMutation__
 *
 * To run a mutation, you first call `useUpdateFileHeavyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFileHeavyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFileHeavyMutation, { data, loading, error }] = useUpdateFileHeavyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
function useUpdateFileHeavyMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(exports.UpdateFileHeavyDocument, options);
}
exports.useUpdateFileHeavyMutation = useUpdateFileHeavyMutation;
exports.DeleteFileDocument = (0, client_1.gql) `
    mutation deleteFile($input: DeleteMapmakerFileInput!) {
  deleteMapmakerFile(input: $input) {
    file {
      ...MapmakerFileLite
    }
  }
}
    ${exports.MapmakerFileLiteFragmentDoc}`;
/**
 * __useDeleteFileMutation__
 *
 * To run a mutation, you first call `useDeleteFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFileMutation, { data, loading, error }] = useDeleteFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
function useDeleteFileMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(exports.DeleteFileDocument, options);
}
exports.useDeleteFileMutation = useDeleteFileMutation;
exports.GetStickerOrderDocument = (0, client_1.gql) `
    query getStickerOrder($id: String!) {
  stickerOrder(id: $id) {
    ...StickerOrder
    file {
      ...MapmakerFileLite
    }
  }
}
    ${exports.StickerOrderFragmentDoc}
${exports.MapmakerFileLiteFragmentDoc}`;
/**
 * __useGetStickerOrderQuery__
 *
 * To run a query within a React component, call `useGetStickerOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStickerOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStickerOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
function useGetStickerOrderQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.GetStickerOrderDocument, options);
}
exports.useGetStickerOrderQuery = useGetStickerOrderQuery;
function useGetStickerOrderLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.GetStickerOrderDocument, options);
}
exports.useGetStickerOrderLazyQuery = useGetStickerOrderLazyQuery;
exports.GetStickerOrdersDocument = (0, client_1.gql) `
    query getStickerOrders($ids: [String!]!) {
  stickerOrders(ids: $ids) {
    ...StickerOrder
  }
}
    ${exports.StickerOrderFragmentDoc}`;
/**
 * __useGetStickerOrdersQuery__
 *
 * To run a query within a React component, call `useGetStickerOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStickerOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStickerOrdersQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
function useGetStickerOrdersQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.GetStickerOrdersDocument, options);
}
exports.useGetStickerOrdersQuery = useGetStickerOrdersQuery;
function useGetStickerOrdersLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.GetStickerOrdersDocument, options);
}
exports.useGetStickerOrdersLazyQuery = useGetStickerOrdersLazyQuery;
exports.CreateStickerOrderDocument = (0, client_1.gql) `
    mutation createStickerOrder($input: CreateStickerOrderInput!) {
  createStickerOrder(input: $input) {
    ...StickerOrder
  }
}
    ${exports.StickerOrderFragmentDoc}`;
/**
 * __useCreateStickerOrderMutation__
 *
 * To run a mutation, you first call `useCreateStickerOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStickerOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStickerOrderMutation, { data, loading, error }] = useCreateStickerOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
function useCreateStickerOrderMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(exports.CreateStickerOrderDocument, options);
}
exports.useCreateStickerOrderMutation = useCreateStickerOrderMutation;
exports.PresignedImageUploadDocument = (0, client_1.gql) `
    mutation presignedImageUpload {
  presignedImageUpload {
    url
    fields
    expires
  }
}
    `;
/**
 * __usePresignedImageUploadMutation__
 *
 * To run a mutation, you first call `usePresignedImageUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePresignedImageUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [presignedImageUploadMutation, { data, loading, error }] = usePresignedImageUploadMutation({
 *   variables: {
 *   },
 * });
 */
function usePresignedImageUploadMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(exports.PresignedImageUploadDocument, options);
}
exports.usePresignedImageUploadMutation = usePresignedImageUploadMutation;
exports.GetStickerProductsDocument = (0, client_1.gql) `
    query getStickerProducts {
  stickers: storefrontCollectionByHandle(handle: "sticker-products") {
    products(first: 10, sortKey: PRICE) {
      edges {
        node {
          id
          variants(first: 20) {
            edges {
              node {
                ...StickerVariantForPricing
              }
            }
          }
        }
      }
    }
  }
}
    ${exports.StickerVariantForPricingFragmentDoc}`;
/**
 * __useGetStickerProductsQuery__
 *
 * To run a query within a React component, call `useGetStickerProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStickerProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStickerProductsQuery({
 *   variables: {
 *   },
 * });
 */
function useGetStickerProductsQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.GetStickerProductsDocument, options);
}
exports.useGetStickerProductsQuery = useGetStickerProductsQuery;
function useGetStickerProductsLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.GetStickerProductsDocument, options);
}
exports.useGetStickerProductsLazyQuery = useGetStickerProductsLazyQuery;
exports.StorefrontGetCheckoutLightDocument = (0, client_1.gql) `
    query storefrontGetCheckoutLight($checkoutId: ID!) {
  storefrontCheckout: storefrontNode(id: $checkoutId) {
    id
    ... on StorefrontCheckout {
      ...StorefrontCheckoutLight
    }
  }
}
    ${exports.StorefrontCheckoutLightFragmentDoc}`;
/**
 * __useStorefrontGetCheckoutLightQuery__
 *
 * To run a query within a React component, call `useStorefrontGetCheckoutLightQuery` and pass it any options that fit your needs.
 * When your component renders, `useStorefrontGetCheckoutLightQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStorefrontGetCheckoutLightQuery({
 *   variables: {
 *      checkoutId: // value for 'checkoutId'
 *   },
 * });
 */
function useStorefrontGetCheckoutLightQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.StorefrontGetCheckoutLightDocument, options);
}
exports.useStorefrontGetCheckoutLightQuery = useStorefrontGetCheckoutLightQuery;
function useStorefrontGetCheckoutLightLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.StorefrontGetCheckoutLightDocument, options);
}
exports.useStorefrontGetCheckoutLightLazyQuery = useStorefrontGetCheckoutLightLazyQuery;
exports.StorefrontCreateCheckoutDocument = (0, client_1.gql) `
    mutation storefrontCreateCheckout($input: StorefrontCheckoutCreateInput!) {
  storefrontCheckoutCreate(input: $input) {
    checkout {
      ...StorefrontCheckoutHeavy
    }
  }
}
    ${exports.StorefrontCheckoutHeavyFragmentDoc}`;
/**
 * __useStorefrontCreateCheckoutMutation__
 *
 * To run a mutation, you first call `useStorefrontCreateCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStorefrontCreateCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storefrontCreateCheckoutMutation, { data, loading, error }] = useStorefrontCreateCheckoutMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
function useStorefrontCreateCheckoutMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(exports.StorefrontCreateCheckoutDocument, options);
}
exports.useStorefrontCreateCheckoutMutation = useStorefrontCreateCheckoutMutation;
exports.StorefrontAddCheckoutLineItemsDocument = (0, client_1.gql) `
    mutation storefrontAddCheckoutLineItems($checkoutId: ID!, $lineItems: [StorefrontCheckoutLineItemInput!]!) {
  storefrontCheckoutLineItemsAdd(checkoutId: $checkoutId, lineItems: $lineItems) {
    checkout {
      ...StorefrontCheckoutHeavy
    }
  }
}
    ${exports.StorefrontCheckoutHeavyFragmentDoc}`;
/**
 * __useStorefrontAddCheckoutLineItemsMutation__
 *
 * To run a mutation, you first call `useStorefrontAddCheckoutLineItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStorefrontAddCheckoutLineItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storefrontAddCheckoutLineItemsMutation, { data, loading, error }] = useStorefrontAddCheckoutLineItemsMutation({
 *   variables: {
 *      checkoutId: // value for 'checkoutId'
 *      lineItems: // value for 'lineItems'
 *   },
 * });
 */
function useStorefrontAddCheckoutLineItemsMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(exports.StorefrontAddCheckoutLineItemsDocument, options);
}
exports.useStorefrontAddCheckoutLineItemsMutation = useStorefrontAddCheckoutLineItemsMutation;
exports.BlogPostDocument = (0, client_1.gql) `
    query blogPost($slug: String!) {
  post: allPost(where: {slug: {current: {eq: $slug}}}) {
    ...BlogPost
  }
  recentPosts: allPost(sort: [{publishedAt: DESC}]) {
    ...BlogPostCard
  }
}
    ${exports.BlogPostFragmentDoc}
${exports.BlogPostCardFragmentDoc}`;
/**
 * __useBlogPostQuery__
 *
 * To run a query within a React component, call `useBlogPostQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlogPostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlogPostQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
function useBlogPostQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.BlogPostDocument, options);
}
exports.useBlogPostQuery = useBlogPostQuery;
function useBlogPostLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.BlogPostDocument, options);
}
exports.useBlogPostLazyQuery = useBlogPostLazyQuery;
exports.AllPostsDocument = (0, client_1.gql) `
    query allPosts {
  allPost(sort: [{publishedAt: DESC}]) {
    ...BlogPostCard
  }
}
    ${exports.BlogPostCardFragmentDoc}`;
/**
 * __useAllPostsQuery__
 *
 * To run a query within a React component, call `useAllPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPostsQuery({
 *   variables: {
 *   },
 * });
 */
function useAllPostsQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.AllPostsDocument, options);
}
exports.useAllPostsQuery = useAllPostsQuery;
function useAllPostsLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.AllPostsDocument, options);
}
exports.useAllPostsLazyQuery = useAllPostsLazyQuery;
exports.StorefrontGetCheckoutHeavyDocument = (0, client_1.gql) `
    query storefrontGetCheckoutHeavy($checkoutId: ID!) {
  storefrontCheckout: storefrontNode(id: $checkoutId) {
    id
    ... on StorefrontCheckout {
      ...StorefrontCheckoutHeavy
    }
  }
}
    ${exports.StorefrontCheckoutHeavyFragmentDoc}`;
/**
 * __useStorefrontGetCheckoutHeavyQuery__
 *
 * To run a query within a React component, call `useStorefrontGetCheckoutHeavyQuery` and pass it any options that fit your needs.
 * When your component renders, `useStorefrontGetCheckoutHeavyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStorefrontGetCheckoutHeavyQuery({
 *   variables: {
 *      checkoutId: // value for 'checkoutId'
 *   },
 * });
 */
function useStorefrontGetCheckoutHeavyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.StorefrontGetCheckoutHeavyDocument, options);
}
exports.useStorefrontGetCheckoutHeavyQuery = useStorefrontGetCheckoutHeavyQuery;
function useStorefrontGetCheckoutHeavyLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.StorefrontGetCheckoutHeavyDocument, options);
}
exports.useStorefrontGetCheckoutHeavyLazyQuery = useStorefrontGetCheckoutHeavyLazyQuery;
exports.StorefrontRemoveCheckoutLineItemsDocument = (0, client_1.gql) `
    mutation storefrontRemoveCheckoutLineItems($checkoutId: ID!, $lineItemIds: [ID!]!) {
  storefrontCheckoutLineItemsRemove(
    checkoutId: $checkoutId
    lineItemIds: $lineItemIds
  ) {
    checkout {
      ...StorefrontCheckoutHeavy
    }
  }
}
    ${exports.StorefrontCheckoutHeavyFragmentDoc}`;
/**
 * __useStorefrontRemoveCheckoutLineItemsMutation__
 *
 * To run a mutation, you first call `useStorefrontRemoveCheckoutLineItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStorefrontRemoveCheckoutLineItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storefrontRemoveCheckoutLineItemsMutation, { data, loading, error }] = useStorefrontRemoveCheckoutLineItemsMutation({
 *   variables: {
 *      checkoutId: // value for 'checkoutId'
 *      lineItemIds: // value for 'lineItemIds'
 *   },
 * });
 */
function useStorefrontRemoveCheckoutLineItemsMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(exports.StorefrontRemoveCheckoutLineItemsDocument, options);
}
exports.useStorefrontRemoveCheckoutLineItemsMutation = useStorefrontRemoveCheckoutLineItemsMutation;
exports.GetStickerOrdersForCartPageDocument = (0, client_1.gql) `
    query getStickerOrdersForCartPage($ids: [String!]!) {
  stickerOrders(ids: $ids) {
    ...StickerOrderForLineItem
  }
}
    ${exports.StickerOrderForLineItemFragmentDoc}`;
/**
 * __useGetStickerOrdersForCartPageQuery__
 *
 * To run a query within a React component, call `useGetStickerOrdersForCartPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStickerOrdersForCartPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStickerOrdersForCartPageQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
function useGetStickerOrdersForCartPageQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.GetStickerOrdersForCartPageDocument, options);
}
exports.useGetStickerOrdersForCartPageQuery = useGetStickerOrdersForCartPageQuery;
function useGetStickerOrdersForCartPageLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.GetStickerOrdersForCartPageDocument, options);
}
exports.useGetStickerOrdersForCartPageLazyQuery = useGetStickerOrdersForCartPageLazyQuery;
exports.StorefrontUpdateCheckoutAttributesDocument = (0, client_1.gql) `
    mutation storefrontUpdateCheckoutAttributes($checkoutId: ID!, $input: StorefrontCheckoutAttributesUpdateV2Input!) {
  storefrontCheckoutAttributesUpdateV2(checkoutId: $checkoutId, input: $input) {
    checkout {
      ...StorefrontCheckoutHeavy
    }
  }
}
    ${exports.StorefrontCheckoutHeavyFragmentDoc}`;
/**
 * __useStorefrontUpdateCheckoutAttributesMutation__
 *
 * To run a mutation, you first call `useStorefrontUpdateCheckoutAttributesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStorefrontUpdateCheckoutAttributesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storefrontUpdateCheckoutAttributesMutation, { data, loading, error }] = useStorefrontUpdateCheckoutAttributesMutation({
 *   variables: {
 *      checkoutId: // value for 'checkoutId'
 *      input: // value for 'input'
 *   },
 * });
 */
function useStorefrontUpdateCheckoutAttributesMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(exports.StorefrontUpdateCheckoutAttributesDocument, options);
}
exports.useStorefrontUpdateCheckoutAttributesMutation = useStorefrontUpdateCheckoutAttributesMutation;
exports.StorefrontUpdateCheckoutLineItemsDocument = (0, client_1.gql) `
    mutation storefrontUpdateCheckoutLineItems($checkoutId: ID!, $lineItems: [StorefrontCheckoutLineItemUpdateInput!]!) {
  storefrontCheckoutLineItemsUpdate(
    checkoutId: $checkoutId
    lineItems: $lineItems
  ) {
    checkout {
      ...StorefrontCheckoutHeavy
    }
  }
}
    ${exports.StorefrontCheckoutHeavyFragmentDoc}`;
/**
 * __useStorefrontUpdateCheckoutLineItemsMutation__
 *
 * To run a mutation, you first call `useStorefrontUpdateCheckoutLineItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStorefrontUpdateCheckoutLineItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storefrontUpdateCheckoutLineItemsMutation, { data, loading, error }] = useStorefrontUpdateCheckoutLineItemsMutation({
 *   variables: {
 *      checkoutId: // value for 'checkoutId'
 *      lineItems: // value for 'lineItems'
 *   },
 * });
 */
function useStorefrontUpdateCheckoutLineItemsMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(exports.StorefrontUpdateCheckoutLineItemsDocument, options);
}
exports.useStorefrontUpdateCheckoutLineItemsMutation = useStorefrontUpdateCheckoutLineItemsMutation;
exports.GetDesignsAndFilesDocument = (0, client_1.gql) `
    query getDesignsAndFiles {
  designs: mapmakerDesigns {
    ...MapmakerDesignLite
  }
  files: mapmakerFiles {
    ...MapmakerFileLite
  }
  sharedFiles: sharedMapmakerFiles {
    ...MapmakerFileLite
  }
}
    ${exports.MapmakerDesignLiteFragmentDoc}
${exports.MapmakerFileLiteFragmentDoc}`;
/**
 * __useGetDesignsAndFilesQuery__
 *
 * To run a query within a React component, call `useGetDesignsAndFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDesignsAndFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDesignsAndFilesQuery({
 *   variables: {
 *   },
 * });
 */
function useGetDesignsAndFilesQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.GetDesignsAndFilesDocument, options);
}
exports.useGetDesignsAndFilesQuery = useGetDesignsAndFilesQuery;
function useGetDesignsAndFilesLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.GetDesignsAndFilesDocument, options);
}
exports.useGetDesignsAndFilesLazyQuery = useGetDesignsAndFilesLazyQuery;
exports.GetDesignsDocument = (0, client_1.gql) `
    query getDesigns($request: GetMapmakerDesignsRequest) {
  designs: mapmakerDesigns(request: $request) {
    ...MapmakerDesignLite
  }
}
    ${exports.MapmakerDesignLiteFragmentDoc}`;
/**
 * __useGetDesignsQuery__
 *
 * To run a query within a React component, call `useGetDesignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDesignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDesignsQuery({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
function useGetDesignsQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.GetDesignsDocument, options);
}
exports.useGetDesignsQuery = useGetDesignsQuery;
function useGetDesignsLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.GetDesignsDocument, options);
}
exports.useGetDesignsLazyQuery = useGetDesignsLazyQuery;
exports.NavigationByIdDocument = (0, client_1.gql) `
    query navigationById($id: String!, $pageSlug: String) {
  allNavigation(where: {id: {current: {eq: $id}}}) {
    ...Navigation
  }
  allPage(where: {slug: {current: {eq: $pageSlug}}}) {
    ...Page
  }
}
    ${exports.NavigationFragmentDoc}
${exports.PageFragmentDoc}`;
/**
 * __useNavigationByIdQuery__
 *
 * To run a query within a React component, call `useNavigationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useNavigationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNavigationByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      pageSlug: // value for 'pageSlug'
 *   },
 * });
 */
function useNavigationByIdQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.NavigationByIdDocument, options);
}
exports.useNavigationByIdQuery = useNavigationByIdQuery;
function useNavigationByIdLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.NavigationByIdDocument, options);
}
exports.useNavigationByIdLazyQuery = useNavigationByIdLazyQuery;
exports.CreateTicketDocument = (0, client_1.gql) `
    mutation createTicket($input: CreateTicketInput) {
  createTicket(input: $input) {
    created
  }
}
    `;
/**
 * __useCreateTicketMutation__
 *
 * To run a mutation, you first call `useCreateTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTicketMutation, { data, loading, error }] = useCreateTicketMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
function useCreateTicketMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(exports.CreateTicketDocument, options);
}
exports.useCreateTicketMutation = useCreateTicketMutation;
exports.PageBySlugDocument = (0, client_1.gql) `
    query pageBySlug($slug: String!) {
  allPage(where: {slug: {current: {eq: $slug}}}) {
    ...Page
  }
}
    ${exports.PageFragmentDoc}`;
/**
 * __usePageBySlugQuery__
 *
 * To run a query within a React component, call `usePageBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
function usePageBySlugQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.PageBySlugDocument, options);
}
exports.usePageBySlugQuery = usePageBySlugQuery;
function usePageBySlugLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.PageBySlugDocument, options);
}
exports.usePageBySlugLazyQuery = usePageBySlugLazyQuery;
exports.GetReferenceDocument = (0, client_1.gql) `
    query getReference($ref: String!) {
  sanityReference(input: {ref: $ref}) {
    id
    slug
  }
}
    `;
/**
 * __useGetReferenceQuery__
 *
 * To run a query within a React component, call `useGetReferenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReferenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReferenceQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *   },
 * });
 */
function useGetReferenceQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.GetReferenceDocument, options);
}
exports.useGetReferenceQuery = useGetReferenceQuery;
function useGetReferenceLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.GetReferenceDocument, options);
}
exports.useGetReferenceLazyQuery = useGetReferenceLazyQuery;
exports.GetOrderDocument = (0, client_1.gql) `
    query getOrder($number: String!) {
  order(number: $number) {
    ...OrderDetails
  }
}
    ${exports.OrderDetailsFragmentDoc}`;
/**
 * __useGetOrderQuery__
 *
 * To run a query within a React component, call `useGetOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderQuery({
 *   variables: {
 *      number: // value for 'number'
 *   },
 * });
 */
function useGetOrderQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.GetOrderDocument, options);
}
exports.useGetOrderQuery = useGetOrderQuery;
function useGetOrderLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.GetOrderDocument, options);
}
exports.useGetOrderLazyQuery = useGetOrderLazyQuery;
exports.GetStickerOrdersForOrderDetailsDocument = (0, client_1.gql) `
    query getStickerOrdersForOrderDetails($ids: [String!]!) {
  stickerOrders(ids: $ids) {
    ...StickerOrderForStickerLineItem
  }
}
    ${exports.StickerOrderForStickerLineItemFragmentDoc}`;
/**
 * __useGetStickerOrdersForOrderDetailsQuery__
 *
 * To run a query within a React component, call `useGetStickerOrdersForOrderDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStickerOrdersForOrderDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStickerOrdersForOrderDetailsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
function useGetStickerOrdersForOrderDetailsQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.GetStickerOrdersForOrderDetailsDocument, options);
}
exports.useGetStickerOrdersForOrderDetailsQuery = useGetStickerOrdersForOrderDetailsQuery;
function useGetStickerOrdersForOrderDetailsLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.GetStickerOrdersForOrderDetailsDocument, options);
}
exports.useGetStickerOrdersForOrderDetailsLazyQuery = useGetStickerOrdersForOrderDetailsLazyQuery;
exports.GetOrdersForUserDocument = (0, client_1.gql) `
    query getOrdersForUser {
  orders {
    ...OrderLight
  }
}
    ${exports.OrderLightFragmentDoc}`;
/**
 * __useGetOrdersForUserQuery__
 *
 * To run a query within a React component, call `useGetOrdersForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrdersForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrdersForUserQuery({
 *   variables: {
 *   },
 * });
 */
function useGetOrdersForUserQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.GetOrdersForUserDocument, options);
}
exports.useGetOrdersForUserQuery = useGetOrdersForUserQuery;
function useGetOrdersForUserLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.GetOrdersForUserDocument, options);
}
exports.useGetOrdersForUserLazyQuery = useGetOrdersForUserLazyQuery;
exports.PrivacyPolicyDocument = (0, client_1.gql) `
    query privacyPolicy {
  storefrontShop {
    privacyPolicy {
      title
      body
    }
  }
}
    `;
/**
 * __usePrivacyPolicyQuery__
 *
 * To run a query within a React component, call `usePrivacyPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrivacyPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrivacyPolicyQuery({
 *   variables: {
 *   },
 * });
 */
function usePrivacyPolicyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.PrivacyPolicyDocument, options);
}
exports.usePrivacyPolicyQuery = usePrivacyPolicyQuery;
function usePrivacyPolicyLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.PrivacyPolicyDocument, options);
}
exports.usePrivacyPolicyLazyQuery = usePrivacyPolicyLazyQuery;
exports.RefundPolicyDocument = (0, client_1.gql) `
    query refundPolicy {
  storefrontShop {
    refundPolicy {
      title
      body
    }
  }
}
    `;
/**
 * __useRefundPolicyQuery__
 *
 * To run a query within a React component, call `useRefundPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useRefundPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRefundPolicyQuery({
 *   variables: {
 *   },
 * });
 */
function useRefundPolicyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.RefundPolicyDocument, options);
}
exports.useRefundPolicyQuery = useRefundPolicyQuery;
function useRefundPolicyLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.RefundPolicyDocument, options);
}
exports.useRefundPolicyLazyQuery = useRefundPolicyLazyQuery;
exports.TermsOfServiceDocument = (0, client_1.gql) `
    query termsOfService {
  storefrontShop {
    termsOfService {
      title
      body
    }
  }
}
    `;
/**
 * __useTermsOfServiceQuery__
 *
 * To run a query within a React component, call `useTermsOfServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useTermsOfServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTermsOfServiceQuery({
 *   variables: {
 *   },
 * });
 */
function useTermsOfServiceQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.TermsOfServiceDocument, options);
}
exports.useTermsOfServiceQuery = useTermsOfServiceQuery;
function useTermsOfServiceLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.TermsOfServiceDocument, options);
}
exports.useTermsOfServiceLazyQuery = useTermsOfServiceLazyQuery;
exports.CreateRectangularPrintsForDownloadDocument = (0, client_1.gql) `
    mutation createRectangularPrintsForDownload($input: CreateRectangularPrintsRequest) {
  createRectangularPrints(input: $input) {
    prints {
      key
      url
    }
  }
}
    `;
/**
 * __useCreateRectangularPrintsForDownloadMutation__
 *
 * To run a mutation, you first call `useCreateRectangularPrintsForDownloadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRectangularPrintsForDownloadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRectangularPrintsForDownloadMutation, { data, loading, error }] = useCreateRectangularPrintsForDownloadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
function useCreateRectangularPrintsForDownloadMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(exports.CreateRectangularPrintsForDownloadDocument, options);
}
exports.useCreateRectangularPrintsForDownloadMutation = useCreateRectangularPrintsForDownloadMutation;
exports.GetStickerOfferDocument = (0, client_1.gql) `
    query getStickerOffer($input: StickerOfferInput!) {
  stickerOffer(input: $input) {
    ...StickerOffer
  }
}
    ${exports.StickerOfferFragmentDoc}`;
/**
 * __useGetStickerOfferQuery__
 *
 * To run a query within a React component, call `useGetStickerOfferQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStickerOfferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStickerOfferQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
function useGetStickerOfferQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.GetStickerOfferDocument, options);
}
exports.useGetStickerOfferQuery = useGetStickerOfferQuery;
function useGetStickerOfferLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.GetStickerOfferDocument, options);
}
exports.useGetStickerOfferLazyQuery = useGetStickerOfferLazyQuery;
exports.WalgreensProductsDocument = (0, client_1.gql) `
    query walgreensProducts {
  walgreensProducts {
    productId
    productPrice
    productSize
  }
}
    `;
/**
 * __useWalgreensProductsQuery__
 *
 * To run a query within a React component, call `useWalgreensProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWalgreensProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWalgreensProductsQuery({
 *   variables: {
 *   },
 * });
 */
function useWalgreensProductsQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.WalgreensProductsDocument, options);
}
exports.useWalgreensProductsQuery = useWalgreensProductsQuery;
function useWalgreensProductsLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.WalgreensProductsDocument, options);
}
exports.useWalgreensProductsLazyQuery = useWalgreensProductsLazyQuery;
exports.WalgreensSubmitOrderDocument = (0, client_1.gql) `
    mutation walgreensSubmitOrder($input: WalgreensSubmitOrderInput) {
  walgreensSubmitOrder(input: $input) {
    walgreensOrderId
  }
}
    `;
/**
 * __useWalgreensSubmitOrderMutation__
 *
 * To run a mutation, you first call `useWalgreensSubmitOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWalgreensSubmitOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [walgreensSubmitOrderMutation, { data, loading, error }] = useWalgreensSubmitOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
function useWalgreensSubmitOrderMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(exports.WalgreensSubmitOrderDocument, options);
}
exports.useWalgreensSubmitOrderMutation = useWalgreensSubmitOrderMutation;
exports.WalgreensStoresDocument = (0, client_1.gql) `
    query walgreensStores($input: WalgreensStoresInput!) {
  walgreensStores(input: $input) {
    ...WalgreensStore
  }
}
    ${exports.WalgreensStoreFragmentDoc}`;
/**
 * __useWalgreensStoresQuery__
 *
 * To run a query within a React component, call `useWalgreensStoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useWalgreensStoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWalgreensStoresQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
function useWalgreensStoresQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.WalgreensStoresDocument, options);
}
exports.useWalgreensStoresQuery = useWalgreensStoresQuery;
function useWalgreensStoresLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.WalgreensStoresDocument, options);
}
exports.useWalgreensStoresLazyQuery = useWalgreensStoresLazyQuery;
exports.CreateRectangularPrintsDocument = (0, client_1.gql) `
    mutation createRectangularPrints($input: CreateRectangularPrintsRequest) {
  createRectangularPrints(input: $input) {
    prints {
      key
      url
    }
  }
}
    `;
/**
 * __useCreateRectangularPrintsMutation__
 *
 * To run a mutation, you first call `useCreateRectangularPrintsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRectangularPrintsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRectangularPrintsMutation, { data, loading, error }] = useCreateRectangularPrintsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
function useCreateRectangularPrintsMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(exports.CreateRectangularPrintsDocument, options);
}
exports.useCreateRectangularPrintsMutation = useCreateRectangularPrintsMutation;
exports.StorefrontGetProductByHandleDocument = (0, client_1.gql) `
    query storefrontGetProductByHandle($handle: String!) {
  product: storefrontProductByHandle(handle: $handle) {
    ...StorefrontProductPageProduct
  }
  stickerTokenProduct: storefrontProduct(handle: "sticker-tokens") {
    ...StickerTokenProduct
  }
}
    ${exports.StorefrontProductPageProductFragmentDoc}
${exports.StickerTokenProductFragmentDoc}`;
/**
 * __useStorefrontGetProductByHandleQuery__
 *
 * To run a query within a React component, call `useStorefrontGetProductByHandleQuery` and pass it any options that fit your needs.
 * When your component renders, `useStorefrontGetProductByHandleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStorefrontGetProductByHandleQuery({
 *   variables: {
 *      handle: // value for 'handle'
 *   },
 * });
 */
function useStorefrontGetProductByHandleQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.StorefrontGetProductByHandleDocument, options);
}
exports.useStorefrontGetProductByHandleQuery = useStorefrontGetProductByHandleQuery;
function useStorefrontGetProductByHandleLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.StorefrontGetProductByHandleDocument, options);
}
exports.useStorefrontGetProductByHandleLazyQuery = useStorefrontGetProductByHandleLazyQuery;
exports.StickerTokensModalDocument = (0, client_1.gql) `
    query stickerTokensModal($designId: String!, $scale: Float!, $outputType: ProjectOutputType!) {
  design: mapmakerDesign(id: $designId) {
    id
    name
    regionType
    regionTypePlural
    stickerInfo(scale: $scale, outputType: $outputType) {
      count
      tokens
      sizeClassGroups {
        count
        tokens
        sizeClass
      }
    }
  }
  stickerTokenProduct: storefrontProduct(handle: "sticker-tokens") {
    ...StickerTokenProduct
  }
}
    ${exports.StickerTokenProductFragmentDoc}`;
/**
 * __useStickerTokensModalQuery__
 *
 * To run a query within a React component, call `useStickerTokensModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useStickerTokensModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStickerTokensModalQuery({
 *   variables: {
 *      designId: // value for 'designId'
 *      scale: // value for 'scale'
 *      outputType: // value for 'outputType'
 *   },
 * });
 */
function useStickerTokensModalQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.StickerTokensModalDocument, options);
}
exports.useStickerTokensModalQuery = useStickerTokensModalQuery;
function useStickerTokensModalLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.StickerTokensModalDocument, options);
}
exports.useStickerTokensModalLazyQuery = useStickerTokensModalLazyQuery;
exports.AddMapmakerFileAccessDocument = (0, client_1.gql) `
    mutation addMapmakerFileAccess($input: AddMapmakerFileAccessInput!) {
  addMapmakerFileAccess(input: $input) {
    fileAccess {
      ...MapmakerFileAccess
    }
  }
}
    ${exports.MapmakerFileAccessFragmentDoc}`;
/**
 * __useAddMapmakerFileAccessMutation__
 *
 * To run a mutation, you first call `useAddMapmakerFileAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMapmakerFileAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMapmakerFileAccessMutation, { data, loading, error }] = useAddMapmakerFileAccessMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
function useAddMapmakerFileAccessMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(exports.AddMapmakerFileAccessDocument, options);
}
exports.useAddMapmakerFileAccessMutation = useAddMapmakerFileAccessMutation;
exports.DeleteMapmakerFileAccessDocument = (0, client_1.gql) `
    mutation deleteMapmakerFileAccess($input: DeleteMapmakerFileAccessInput!) {
  deleteMapmakerFileAccess(input: $input) {
    success
  }
}
    `;
/**
 * __useDeleteMapmakerFileAccessMutation__
 *
 * To run a mutation, you first call `useDeleteMapmakerFileAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMapmakerFileAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMapmakerFileAccessMutation, { data, loading, error }] = useDeleteMapmakerFileAccessMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
function useDeleteMapmakerFileAccessMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(exports.DeleteMapmakerFileAccessDocument, options);
}
exports.useDeleteMapmakerFileAccessMutation = useDeleteMapmakerFileAccessMutation;
exports.DeleteOpeningSuggestionDocument = (0, client_1.gql) `
    mutation deleteOpeningSuggestion($input: DeleteOpeningSuggestionInput!) {
  deleteOpeningSuggestion(input: $input) {
    success
  }
}
    `;
/**
 * __useDeleteOpeningSuggestionMutation__
 *
 * To run a mutation, you first call `useDeleteOpeningSuggestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOpeningSuggestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOpeningSuggestionMutation, { data, loading, error }] = useDeleteOpeningSuggestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
function useDeleteOpeningSuggestionMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(exports.DeleteOpeningSuggestionDocument, options);
}
exports.useDeleteOpeningSuggestionMutation = useDeleteOpeningSuggestionMutation;
exports.HideOpeningSuggestionDocument = (0, client_1.gql) `
    mutation hideOpeningSuggestion($input: HideOpeningSuggestionInput!) {
  hideOpeningSuggestion(input: $input) {
    suggestion {
      ...OpeningSuggestion
    }
  }
}
    ${exports.OpeningSuggestionFragmentDoc}`;
/**
 * __useHideOpeningSuggestionMutation__
 *
 * To run a mutation, you first call `useHideOpeningSuggestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHideOpeningSuggestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hideOpeningSuggestionMutation, { data, loading, error }] = useHideOpeningSuggestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
function useHideOpeningSuggestionMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(exports.HideOpeningSuggestionDocument, options);
}
exports.useHideOpeningSuggestionMutation = useHideOpeningSuggestionMutation;
exports.GetOpeningSuggestionDocument = (0, client_1.gql) `
    query getOpeningSuggestion($fileId: String!, $openingId: String!, $suggestionId: String!) {
  openingSuggestion(
    fileId: $fileId
    openingId: $openingId
    suggestionId: $suggestionId
  ) {
    ...OpeningSuggestion
  }
}
    ${exports.OpeningSuggestionFragmentDoc}`;
/**
 * __useGetOpeningSuggestionQuery__
 *
 * To run a query within a React component, call `useGetOpeningSuggestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpeningSuggestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOpeningSuggestionQuery({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      openingId: // value for 'openingId'
 *      suggestionId: // value for 'suggestionId'
 *   },
 * });
 */
function useGetOpeningSuggestionQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.GetOpeningSuggestionDocument, options);
}
exports.useGetOpeningSuggestionQuery = useGetOpeningSuggestionQuery;
function useGetOpeningSuggestionLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.GetOpeningSuggestionDocument, options);
}
exports.useGetOpeningSuggestionLazyQuery = useGetOpeningSuggestionLazyQuery;
exports.CreateOpeningSuggestionDocument = (0, client_1.gql) `
    mutation createOpeningSuggestion($input: CreateOpeningSuggestionInput!) {
  createOpeningSuggestion(input: $input) {
    suggestion {
      ...OpeningSuggestion
    }
  }
}
    ${exports.OpeningSuggestionFragmentDoc}`;
/**
 * __useCreateOpeningSuggestionMutation__
 *
 * To run a mutation, you first call `useCreateOpeningSuggestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOpeningSuggestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOpeningSuggestionMutation, { data, loading, error }] = useCreateOpeningSuggestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
function useCreateOpeningSuggestionMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(exports.CreateOpeningSuggestionDocument, options);
}
exports.useCreateOpeningSuggestionMutation = useCreateOpeningSuggestionMutation;
exports.UpdateOpeningSuggestionDocument = (0, client_1.gql) `
    mutation updateOpeningSuggestion($input: UpdateOpeningSuggestionInput!) {
  updateOpeningSuggestion(input: $input) {
    suggestion {
      ...OpeningSuggestion
    }
  }
}
    ${exports.OpeningSuggestionFragmentDoc}`;
/**
 * __useUpdateOpeningSuggestionMutation__
 *
 * To run a mutation, you first call `useUpdateOpeningSuggestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOpeningSuggestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOpeningSuggestionMutation, { data, loading, error }] = useUpdateOpeningSuggestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
function useUpdateOpeningSuggestionMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(exports.UpdateOpeningSuggestionDocument, options);
}
exports.useUpdateOpeningSuggestionMutation = useUpdateOpeningSuggestionMutation;
exports.SubmitOpeningSuggestionDocument = (0, client_1.gql) `
    mutation submitOpeningSuggestion($input: SubmitOpeningSuggestionInput!) {
  submitOpeningSuggestion(input: $input) {
    suggestion {
      ...OpeningSuggestion
    }
  }
}
    ${exports.OpeningSuggestionFragmentDoc}`;
/**
 * __useSubmitOpeningSuggestionMutation__
 *
 * To run a mutation, you first call `useSubmitOpeningSuggestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitOpeningSuggestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitOpeningSuggestionMutation, { data, loading, error }] = useSubmitOpeningSuggestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
function useSubmitOpeningSuggestionMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(exports.SubmitOpeningSuggestionDocument, options);
}
exports.useSubmitOpeningSuggestionMutation = useSubmitOpeningSuggestionMutation;
exports.GetStickerOrdersForSandboxDocument = (0, client_1.gql) `
    query getStickerOrdersForSandbox($ids: [String!]!) {
  stickerOrders(ids: $ids) {
    ...StickerOrderForSandbox
  }
}
    ${exports.StickerOrderForSandboxFragmentDoc}`;
/**
 * __useGetStickerOrdersForSandboxQuery__
 *
 * To run a query within a React component, call `useGetStickerOrdersForSandboxQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStickerOrdersForSandboxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStickerOrdersForSandboxQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
function useGetStickerOrdersForSandboxQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.GetStickerOrdersForSandboxDocument, options);
}
exports.useGetStickerOrdersForSandboxQuery = useGetStickerOrdersForSandboxQuery;
function useGetStickerOrdersForSandboxLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.GetStickerOrdersForSandboxDocument, options);
}
exports.useGetStickerOrdersForSandboxLazyQuery = useGetStickerOrdersForSandboxLazyQuery;
exports.RenderDocument = (0, client_1.gql) `
    mutation render($request: RenderRequest!) {
  render(request: $request) {
    url
  }
}
    `;
/**
 * __useRenderMutation__
 *
 * To run a mutation, you first call `useRenderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renderMutation, { data, loading, error }] = useRenderMutation({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
function useRenderMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(exports.RenderDocument, options);
}
exports.useRenderMutation = useRenderMutation;
exports.GetRenderableDesignDocument = (0, client_1.gql) `
    query getRenderableDesign($designId: String!) {
  design: mapmakerDesign(id: $designId) {
    ...RenderableDesign
  }
}
    ${exports.RenderableDesignFragmentDoc}`;
/**
 * __useGetRenderableDesignQuery__
 *
 * To run a query within a React component, call `useGetRenderableDesignQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRenderableDesignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRenderableDesignQuery({
 *   variables: {
 *      designId: // value for 'designId'
 *   },
 * });
 */
function useGetRenderableDesignQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.GetRenderableDesignDocument, options);
}
exports.useGetRenderableDesignQuery = useGetRenderableDesignQuery;
function useGetRenderableDesignLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.GetRenderableDesignDocument, options);
}
exports.useGetRenderableDesignLazyQuery = useGetRenderableDesignLazyQuery;
exports.GetRenderableFileDocument = (0, client_1.gql) `
    query getRenderableFile($fileId: String!) {
  file: mapmakerFile(id: $fileId) {
    ...RenderableFile
  }
}
    ${exports.RenderableFileFragmentDoc}`;
/**
 * __useGetRenderableFileQuery__
 *
 * To run a query within a React component, call `useGetRenderableFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRenderableFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRenderableFileQuery({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
function useGetRenderableFileQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.GetRenderableFileDocument, options);
}
exports.useGetRenderableFileQuery = useGetRenderableFileQuery;
function useGetRenderableFileLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.GetRenderableFileDocument, options);
}
exports.useGetRenderableFileLazyQuery = useGetRenderableFileLazyQuery;
exports.GetRenderableOpeningSuggestionDocument = (0, client_1.gql) `
    query getRenderableOpeningSuggestion($fileId: String!, $openingId: String!, $suggestionId: String!) {
  suggestion: openingSuggestion(
    fileId: $fileId
    openingId: $openingId
    suggestionId: $suggestionId
  ) {
    ...RenderableOpeningSuggestion
  }
}
    ${exports.RenderableOpeningSuggestionFragmentDoc}`;
/**
 * __useGetRenderableOpeningSuggestionQuery__
 *
 * To run a query within a React component, call `useGetRenderableOpeningSuggestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRenderableOpeningSuggestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRenderableOpeningSuggestionQuery({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      openingId: // value for 'openingId'
 *      suggestionId: // value for 'suggestionId'
 *   },
 * });
 */
function useGetRenderableOpeningSuggestionQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.GetRenderableOpeningSuggestionDocument, options);
}
exports.useGetRenderableOpeningSuggestionQuery = useGetRenderableOpeningSuggestionQuery;
function useGetRenderableOpeningSuggestionLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.GetRenderableOpeningSuggestionDocument, options);
}
exports.useGetRenderableOpeningSuggestionLazyQuery = useGetRenderableOpeningSuggestionLazyQuery;
exports.RenderableFileListDocument = (0, client_1.gql) `
    query renderableFileList {
  mapmakerFiles {
    ...MapmakerFileLite
  }
}
    ${exports.MapmakerFileLiteFragmentDoc}`;
/**
 * __useRenderableFileListQuery__
 *
 * To run a query within a React component, call `useRenderableFileListQuery` and pass it any options that fit your needs.
 * When your component renders, `useRenderableFileListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRenderableFileListQuery({
 *   variables: {
 *   },
 * });
 */
function useRenderableFileListQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.RenderableFileListDocument, options);
}
exports.useRenderableFileListQuery = useRenderableFileListQuery;
function useRenderableFileListLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.RenderableFileListDocument, options);
}
exports.useRenderableFileListLazyQuery = useRenderableFileListLazyQuery;
exports.RenderableFileHeavyDocument = (0, client_1.gql) `
    query renderableFileHeavy($fileId: String!) {
  mapmakerFile(id: $fileId) {
    ...MapmakerFileHeavy
  }
}
    ${exports.MapmakerFileHeavyFragmentDoc}`;
/**
 * __useRenderableFileHeavyQuery__
 *
 * To run a query within a React component, call `useRenderableFileHeavyQuery` and pass it any options that fit your needs.
 * When your component renders, `useRenderableFileHeavyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRenderableFileHeavyQuery({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
function useRenderableFileHeavyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.RenderableFileHeavyDocument, options);
}
exports.useRenderableFileHeavyQuery = useRenderableFileHeavyQuery;
function useRenderableFileHeavyLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.RenderableFileHeavyDocument, options);
}
exports.useRenderableFileHeavyLazyQuery = useRenderableFileHeavyLazyQuery;
exports.RedeemStickerTokenVoucherDocument = (0, client_1.gql) `
    mutation redeemStickerTokenVoucher($input: RedeemStickerTokenVoucherRequest!) {
  redeemStickerTokenVoucher(input: $input) {
    transaction {
      tokens
    }
    account {
      id
      ... on MapmakerAuthenticatedAccount {
        stickerTokenBalance
      }
    }
  }
}
    `;
/**
 * __useRedeemStickerTokenVoucherMutation__
 *
 * To run a mutation, you first call `useRedeemStickerTokenVoucherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedeemStickerTokenVoucherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redeemStickerTokenVoucherMutation, { data, loading, error }] = useRedeemStickerTokenVoucherMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
function useRedeemStickerTokenVoucherMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(exports.RedeemStickerTokenVoucherDocument, options);
}
exports.useRedeemStickerTokenVoucherMutation = useRedeemStickerTokenVoucherMutation;
exports.AccountStickerTokenDataDocument = (0, client_1.gql) `
    query accountStickerTokenData {
  account {
    id
    ... on MapmakerAuthenticatedAccount {
      stickerTokenBalance
    }
  }
  stickerTokenTransactions {
    id
    createdAt
    reason
    tokens
    startingBalance
    endingBalance
    note
  }
}
    `;
/**
 * __useAccountStickerTokenDataQuery__
 *
 * To run a query within a React component, call `useAccountStickerTokenDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountStickerTokenDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountStickerTokenDataQuery({
 *   variables: {
 *   },
 * });
 */
function useAccountStickerTokenDataQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.AccountStickerTokenDataDocument, options);
}
exports.useAccountStickerTokenDataQuery = useAccountStickerTokenDataQuery;
function useAccountStickerTokenDataLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.AccountStickerTokenDataDocument, options);
}
exports.useAccountStickerTokenDataLazyQuery = useAccountStickerTokenDataLazyQuery;
exports.CreatePresignedPostDocument = (0, client_1.gql) `
    mutation createPresignedPost($folder: String) {
  createPresignedPost(folder: $folder) {
    ...PresignedPost
  }
}
    ${exports.PresignedPostFragmentDoc}`;
/**
 * __useCreatePresignedPostMutation__
 *
 * To run a mutation, you first call `useCreatePresignedPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePresignedPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPresignedPostMutation, { data, loading, error }] = useCreatePresignedPostMutation({
 *   variables: {
 *      folder: // value for 'folder'
 *   },
 * });
 */
function useCreatePresignedPostMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(exports.CreatePresignedPostDocument, options);
}
exports.useCreatePresignedPostMutation = useCreatePresignedPostMutation;
exports.StorefrontReplaceCheckoutLineItemsDocument = (0, client_1.gql) `
    mutation storefrontReplaceCheckoutLineItems($checkoutId: ID!, $lineItems: [StorefrontCheckoutLineItemInput!]!) {
  storefrontCheckoutLineItemsReplace(
    checkoutId: $checkoutId
    lineItems: $lineItems
  ) {
    checkout {
      ...StorefrontCheckoutHeavy
    }
  }
}
    ${exports.StorefrontCheckoutHeavyFragmentDoc}`;
/**
 * __useStorefrontReplaceCheckoutLineItemsMutation__
 *
 * To run a mutation, you first call `useStorefrontReplaceCheckoutLineItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStorefrontReplaceCheckoutLineItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storefrontReplaceCheckoutLineItemsMutation, { data, loading, error }] = useStorefrontReplaceCheckoutLineItemsMutation({
 *   variables: {
 *      checkoutId: // value for 'checkoutId'
 *      lineItems: // value for 'lineItems'
 *   },
 * });
 */
function useStorefrontReplaceCheckoutLineItemsMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(exports.StorefrontReplaceCheckoutLineItemsDocument, options);
}
exports.useStorefrontReplaceCheckoutLineItemsMutation = useStorefrontReplaceCheckoutLineItemsMutation;
const result = {
    "possibleTypes": {
        "AsideOrBlockOrContentImageOrScreenshotOrYoutube": [
            "Aside",
            "Block",
            "ContentImage",
            "Screenshot",
            "Youtube"
        ],
        "BlockOrContentImageOrYoutube": [
            "Block",
            "ContentImage",
            "Youtube"
        ],
        "Document": [
            "Author",
            "Navigation",
            "Page",
            "Post",
            "SanityFileAsset",
            "SanityImageAsset"
        ],
        "MapmakerAccount": [
            "MapmakerAuthenticatedAccount",
            "MapmakerUnauthenticatedAccount"
        ],
        "OrderItem": [
            "BasicLineItem",
            "MapLineItem",
            "StickerLineItem",
            "StickerTokenLineItem"
        ],
        "StorefrontBaseCartLine": [
            "StorefrontCartLine",
            "StorefrontComponentizableCartLine"
        ],
        "StorefrontCartCompletionAction": [
            "StorefrontCompletePaymentChallenge"
        ],
        "StorefrontCartCompletionAttemptResult": [
            "StorefrontCartCompletionActionRequired",
            "StorefrontCartCompletionFailed",
            "StorefrontCartCompletionProcessing",
            "StorefrontCartCompletionSuccess"
        ],
        "StorefrontCartDiscountAllocation": [
            "StorefrontCartAutomaticDiscountAllocation",
            "StorefrontCartCodeDiscountAllocation",
            "StorefrontCartCustomDiscountAllocation"
        ],
        "StorefrontCartSubmitForCompletionResult": [
            "StorefrontSubmitAlreadyAccepted",
            "StorefrontSubmitFailed",
            "StorefrontSubmitSuccess",
            "StorefrontSubmitThrottled"
        ],
        "StorefrontDeliveryAddress": [
            "StorefrontMailingAddress"
        ],
        "StorefrontDiscountApplication": [
            "StorefrontAutomaticDiscountApplication",
            "StorefrontDiscountCodeApplication",
            "StorefrontManualDiscountApplication",
            "StorefrontScriptDiscountApplication"
        ],
        "StorefrontDisplayableError": [
            "StorefrontCartUserError",
            "StorefrontCheckoutUserError",
            "StorefrontCustomerUserError",
            "StorefrontMetafieldDeleteUserError",
            "StorefrontMetafieldsSetUserError",
            "StorefrontUserError"
        ],
        "StorefrontHasMetafields": [
            "StorefrontArticle",
            "StorefrontBlog",
            "StorefrontCart",
            "StorefrontCollection",
            "StorefrontCustomer",
            "StorefrontLocation",
            "StorefrontMarket",
            "StorefrontOrder",
            "StorefrontPage",
            "StorefrontProduct",
            "StorefrontProductVariant",
            "StorefrontShop"
        ],
        "StorefrontMedia": [
            "StorefrontExternalVideo",
            "StorefrontMediaImage",
            "StorefrontModel3d",
            "StorefrontVideo"
        ],
        "StorefrontMenuItemResource": [
            "StorefrontArticle",
            "StorefrontBlog",
            "StorefrontCollection",
            "StorefrontPage",
            "StorefrontProduct",
            "StorefrontShopPolicy"
        ],
        "StorefrontMerchandise": [
            "StorefrontProductVariant"
        ],
        "StorefrontMetafieldParentResource": [
            "StorefrontArticle",
            "StorefrontBlog",
            "StorefrontCart",
            "StorefrontCollection",
            "StorefrontCustomer",
            "StorefrontLocation",
            "StorefrontMarket",
            "StorefrontOrder",
            "StorefrontPage",
            "StorefrontProduct",
            "StorefrontProductVariant",
            "StorefrontShop"
        ],
        "StorefrontMetafieldReference": [
            "StorefrontCollection",
            "StorefrontGenericFile",
            "StorefrontMediaImage",
            "StorefrontMetaobject",
            "StorefrontPage",
            "StorefrontProduct",
            "StorefrontProductVariant",
            "StorefrontVideo"
        ],
        "StorefrontNode": [
            "StorefrontAppliedGiftCard",
            "StorefrontArticle",
            "StorefrontBlog",
            "StorefrontCart",
            "StorefrontCartLine",
            "StorefrontCheckout",
            "StorefrontCheckoutLineItem",
            "StorefrontCollection",
            "StorefrontComment",
            "StorefrontComponentizableCartLine",
            "StorefrontExternalVideo",
            "StorefrontGenericFile",
            "StorefrontLocation",
            "StorefrontMailingAddress",
            "StorefrontMarket",
            "StorefrontMediaImage",
            "StorefrontMediaPresentation",
            "StorefrontMenu",
            "StorefrontMenuItem",
            "StorefrontMetafield",
            "StorefrontMetaobject",
            "StorefrontModel3d",
            "StorefrontOrder",
            "StorefrontPage",
            "StorefrontPayment",
            "StorefrontProduct",
            "StorefrontProductOption",
            "StorefrontProductVariant",
            "StorefrontShop",
            "StorefrontShopPolicy",
            "StorefrontUrlRedirect",
            "StorefrontVideo"
        ],
        "StorefrontOnlineStorePublishable": [
            "StorefrontArticle",
            "StorefrontBlog",
            "StorefrontCollection",
            "StorefrontPage",
            "StorefrontProduct"
        ],
        "StorefrontPricingValue": [
            "StorefrontMoneyV2",
            "StorefrontPricingPercentageValue"
        ],
        "StorefrontSearchResultItem": [
            "StorefrontArticle",
            "StorefrontPage",
            "StorefrontProduct"
        ],
        "StorefrontSellingPlanCheckoutChargeValue": [
            "StorefrontMoneyV2",
            "StorefrontSellingPlanCheckoutChargePercentageValue"
        ],
        "StorefrontSellingPlanPriceAdjustmentValue": [
            "StorefrontSellingPlanFixedAmountPriceAdjustment",
            "StorefrontSellingPlanFixedPriceAdjustment",
            "StorefrontSellingPlanPercentagePriceAdjustment"
        ],
        "StorefrontTrackable": [
            "StorefrontArticle",
            "StorefrontCollection",
            "StorefrontPage",
            "StorefrontProduct",
            "StorefrontSearchQuerySuggestion"
        ]
    }
};
exports.default = result;
//# sourceMappingURL=data:application/json;base64,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